/* ==========================================================================
 theme.js — JavaScript global du thème
 Chargé en defer dans theme.liquid
 ========================================================================== */

(function () {
  'use strict';

  document.documentElement.classList.add('js-ready');

 /* ── i18n ────────────────────────────
 Les libellés UI du JS viennent de window.__T (snippet theme-strings,
 rendu par | t dans theme.liquid) — chaque appel garde un REPLI
 français en dur : sans le snippet ou clé manquante, comportement
 d'origine intact. Les COMPARAISONS de données (rôles, metafields)
 restent sur les valeurs françaises canoniques — seul l'AFFICHAGE
 passe par __T (dont le dictionnaire __T.roles). */
  const __T = window.__T || {};
 // DÉCODAGE DES ENTITÉS (bug réel 2026-07-26 : « Pages &AMP; Articles »
 // affiché littéral dans les suggestions) : le filtre Liquid `t`
 // ÉCHAPPE le HTML des clés non-_html → l'île theme-strings livre
 // « Pages &amp; articles », et le JS insère en textContent → l'entité
 // s'affiche en toutes lettres (l'uppercase CSS en fait « &AMP; »).
 // Point de correction UNIQUE : décoder ici couvre toutes les clés,
 // présentes et futures. &amp; décodé EN DERNIER (décodage standard).
  const deent = (s) => String(s)
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&');
  const T = (k, fb) => (typeof __T[k] === 'string' ? deent(__T[k]) : fb);
 // Pluriel minimal one/other sur gabarits {count} — suffisant FR/EN ;
 // les langues à pluriels riches
 // basculeront sur les clés CLDR complètes.
  const TN = (n, kOne, kOther, fbOne, fbOther) =>
    (n === 1 ? T(kOne, fbOne) : T(kOther, fbOther)).replace('{count}', n);
 // Préfixe de locale pour les fetchs Section Rendering et predictive —
 // sans lui, suggestions et cartes favoris seraient rendues en FRANÇAIS
 // sur les URL localisées.  routes.root_url = « / » (primaire) mais
 // « /en » SANS slash final (locale secondaire) normalisé ici avec
 // slash final garanti.
  const ROOT = (() => {
    const r = (typeof __T.routesRoot === 'string' && __T.routesRoot) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  })();
 // Format monétaire BOUTIQUE (shop.money_format) — solde la dette
 // Phase 12 du « € » en dur de cartAddPanel. Groupage par espace fine
 // insécable, décimales ignorées (format boutique sans décimales, §11).
  const fmtMoney = (cents) => {
    const grouped = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const tpl = typeof __T.moneyFormat === 'string' ? __T.moneyFormat : '';
    let out = tpl ? tpl.replace(/\{\{\s*amount[^}]*\}\}/, grouped) : grouped + ' €';
 // Prix par locale : FR = format boutique ; toute autre
 // locale = anglo-saxon « €montant » (symbole à gauche, mêmes séparateurs)
 // — même bascule que snippets/money-l10n.liquid. Robustesse : sortie
 // ne se terminant pas par « € » (Currency formatting admin changé)
 // rendue telle quelle, jamais cassée.
    const lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    if (lang !== 'fr') {
      const m = out.match(/^([\s\S]*?)(?:\s|\u00A0|\u202F|&nbsp;)*€\s*$/);
      if (m) out = '€' + m[1];
    }
    return out;
  };

 /* ── Piège de focus PARTAGÉ (tiroir de filtres, modale question) ────
 À appeler depuis le keydown du composant OUVERT : Tab et Shift+Tab
 cyclent parmi les focusables VISIBLES du conteneur (un <details>
 replié ou un display:none est ignoré via offsetParent — valable ici :
 les conteneurs sont position:fixed, leurs enfants rendus ont donc
 toujours un offsetParent). Si le focus s'est déjà échappé du
 conteneur, il y est ramené. */
  const FOCUSABLE_SEL = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const trapTabKey = (container, e) => {
    if (e.key !== 'Tab') return;
    const items = [...container.querySelectorAll(FOCUSABLE_SEL)]
      .filter((el) => {
        if (el.offsetParent === null) return false;
 // Enfant d'un <details> REPLIÉ : le navigateur le saute au Tab
 // mais il garde display:block ET un offsetParent — sans cette
 // garde, le « dernier » du cycle serait un élément inatteignable
 // et le piège laisserait fuir le focus (vécu : tiroir de filtres,
 // cases des groupes repliés). La summary du details replié, elle,
 // reste tabbable.
        const closed = el.closest('details:not([open])');
        if (closed && !(el.tagName === 'SUMMARY' && el.parentElement === closed)) return false;
        return true;
      });
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    if (!container.contains(active)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  };

 /* ── Hauteur dynamique du header sticky CSS variable ───────────────
 Publie `--header-sticky-height` sur <html> à partir de l'offsetHeight
 réel de <section class="shopify-section header-section">. Cette
 variable est consommée par toutes les pages qui ont besoin d'ancrer
 un élément sticky JUSTE SOUS le header — actuellement utilisée par
 `.pdp__gallery` (sections/main-product.liquid) pour que la galerie
 produit se cale au pixel près sous le header, peu importe :
 - le breakpoint (mobile, tablette, laptop, desktop ≥1200)
 - le scaling navigateur (Windows 125%/150%/200%, zoom utilisateur)
 - les variations futures du header (ajout d'une bande, font swap)
 Fallback CSS : la variable a une valeur par défaut (80px) côté
 consommateur si jamais ce JS échoue à s'exécuter.

 3 events suffisent pour couvrir 99 % des cas (pas besoin de
 ResizeObserver) :
 - DOMContentLoaded : init dès que le DOM est dispo
 - load : recalcul après chargement des fonts (Playfair
 via Google Fonts peut décaler la hauteur
 wordmark de quelques px au swap)
 - resize : changement d'orientation, redimensionnement
 fenêtre. */
  (function stickyHeaderHeight() {
    function update() {
      const header = document.querySelector('.header-section');
      if (!header) return;
      const h = header.offsetHeight;
      document.documentElement.style.setProperty('--header-sticky-height', h + 'px');
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', update);
    } else {
      update();
    }
    window.addEventListener('load', update);
    window.addEventListener('resize', update);
  })();

 /* ── Footer accordéons ────────────────────────────────────────────────
 Les <details data-mobile-collapse> du footer sont fermés par défaut
 en HTML (rendu mobile correct). En desktop ≥ 768px, on les force
 ouverts pour afficher les colonnes en grille classique.
 */
  (function syncFooterDetails() {
    const mql = window.matchMedia('(min-width: 768px)');
    const details = document.querySelectorAll('.footer__col[data-mobile-collapse]');
    if (!details.length) return;

    const apply = (matches) => {
      details.forEach((d) => {
        if (matches) d.setAttribute('open', '');
        else d.removeAttribute('open');
      });
    };
    apply(mql.matches);
    mql.addEventListener('change', (e) => apply(e.matches));

    // Desktop : les titres ne sont PAS des accordéons — un clic fermait
    // la colonne sans indication visuelle (recette 2026-09-02, décision :
    // comportement retiré hors mobile plutôt que signalé).
    details.forEach((d) => {
      const summary = d.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (e) => {
        if (mql.matches) e.preventDefault();
      });
    });
  })();

 /* ── Burger menu (drawer) ─────────────────────────────────────────────
 Ouverture / fermeture du panneau latéral via :
 - clic sur [data-burger-toggle] (le bouton du header)
 - clic sur [data-burger-close] (le bouton du panneau)
 - clic sur l'overlay
 - touche Escape
 Verrouille le scroll body, gère aria-expanded et focus trap basique.
 */
  (function burgerMenu() {
    const toggle = document.querySelector('[data-burger-toggle]');
    const drawer = document.querySelector('[data-burger-drawer]');
    if (!toggle || !drawer) return;

    const overlay = drawer.querySelector('[data-burger-overlay]');
    const closeBtn = drawer.querySelector('[data-burger-close]');
    let lastFocused = null;

    const focusableSelector = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';

    const open = () => {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
 // Focus ENTRANT sur le PANNEAU (tabindex -1), pas sur la croix : le focus
 // programmatique sur un bouton déclenche :focus-visible sur iOS -> anneau
 // doré plein cadre autour de la croix, par-dessus le burger ouvert (bug
 // réel iPhone, 2026-08-20). Le panneau focusé garde le contrat du
 // dialogue (piège Tab + restitution) ; premier Tab -> la croix.
      setTimeout(() => {
        const panel = drawer.querySelector('.burger__panel') || drawer;
        panel.setAttribute('tabindex', '-1');
        panel.style.outline = 'none';
        panel.focus();
      }, 50);
 // Flou de l'overlay DIFFÉRÉ après la transition d'ouverture (~0.24 s) :
 // ne pas recalculer le backdrop-filter à chaque frame du fondu (lag
 // d'ouverture). Garde : ne floute pas si l'utilisateur a déjà refermé.
      setTimeout(() => {
        if (drawer.classList.contains('is-open')) drawer.classList.add('is-blurred');
      }, 260);
      document.addEventListener('keydown', onKeydown);
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.classList.remove('is-blurred');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('no-scroll');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    };

    const onKeydown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
 // Focus trap : confine Tab/Shift+Tab à l'intérieur du drawer
      if (e.key === 'Tab') {
        const focusables = drawer.querySelectorAll(focusableSelector);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = drawer.classList.contains('is-open');
      if (isOpen) close();
      else open();
    });
    if (closeBtn) closeBtn.addEventListener('click', (e) => { e.preventDefault(); close(); });
    if (overlay) overlay.addEventListener('click', close);
  })();

 /* ── Sélecteurs header : langue (globe) + devise (billet) ─────────────
 Deux dropdowns à structure identique (classes header__lang-*),
 gérés par le même module générique. Pour chacun : toggle au clic
 sur le trigger, fermeture sur :
 - clic en dehors
 - touche Escape (focus revient sur le trigger)
 - Tab sortant du menu (focusout sans relatedTarget interne)
 Navigation clavier / entre les items du menu ouvert.
 Ouvrir l'un ferme l'autre (jamais 2 dropdowns ouverts côte à côte).
 Le sélecteur de langue passe par le même mécanisme.
 */
  (function headerDropdowns() {
    const configs = [
      { root: '[data-lang-switcher]',     trigger: '[data-lang-trigger]',     menu: '[data-lang-menu]' },
      { root: '[data-currency-switcher]', trigger: '[data-currency-trigger]', menu: '[data-currency-menu]' },
    ];
    const instances = [];

    configs.forEach((cfg) => {
      const switcher = document.querySelector(cfg.root);
      if (!switcher) return;

      const trigger = switcher.querySelector(cfg.trigger);
      const menu = switcher.querySelector(cfg.menu);
      if (!trigger || !menu) return;

      const items = Array.from(menu.querySelectorAll('.header__lang-item'));
      const instance = { isOpen: false };

      const open = () => {
 // Ferme les autres dropdowns avant d'ouvrir celui-ci
        instances.forEach((other) => {
          if (other !== instance && other.isOpen) other.close();
        });
        instance.isOpen = true;
        menu.dataset.open = 'true';
        trigger.setAttribute('aria-expanded', 'true');
 // Focus sur le 1er item après l'animation (transition 0.18 s)
        setTimeout(() => {
          if (items[0]) items[0].focus();
        }, 50);
      };

      const close = () => {
        instance.isOpen = false;
        menu.dataset.open = 'false';
        trigger.setAttribute('aria-expanded', 'false');
      };
      instance.close = close;

 // Toggle au clic
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        if (instance.isOpen) close();
        else open();
      });

 // Fermeture au clic en dehors
      document.addEventListener('click', (e) => {
        if (instance.isOpen && !switcher.contains(e.target)) close();
      });

 // Fermeture sur Escape (focus revient sur le trigger)
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && instance.isOpen) {
          close();
          trigger.focus();
        }
      });

 // Navigation flèches / entre items
      menu.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        const currentIdx = items.indexOf(document.activeElement);
        const delta = e.key === 'ArrowDown' ? 1 : -1;
        const nextIdx = (currentIdx + delta + items.length) % items.length;
        items[nextIdx].focus();
      });

 // Fermeture si le focus quitte tout le switcher (Tab sortant)
      switcher.addEventListener('focusout', (e) => {
        if (!instance.isOpen) return;
        if (switcher.contains(e.relatedTarget)) return;
        close();
      });

      instances.push(instance);
    });
  })();

 /* ── Menus déroulants nav desktop : Index / Découvrir ────
 Wrappers [data-nav-menu] du header (≥ 1200). Trois entrées de
 commande qui cohabitent sans se marcher dessus :
 - SOURIS / STYLET : ouverture au pointerenter du wrapper,
 fermeture DIFFÉRÉE ~220 ms au pointerleave (survol tolérant,
 modèle infobulle glossaire) — avec le pont CSS ::before, la
 souris peut descendre en biais vers les items sans fermeture ;
 - TACTILE (Surface) : les pointerenter/leave de type 'touch' sont
 IGNORÉS (un tap émet aussi pointerenter : sans ce filtre,
 tap = ouverture par enter PUIS toggle par click = fermeture
 immédiate) le tap ne passe que par le click du BOUTON :
 toggle franc, fermeture au tap dehors ;
 - CLAVIER : Entrée/Espace toggle (bouton natif), Échap ferme et
 rend le focus, Tab sortant ferme.
 Un clic souris sur un menu DÉJÀ ouvert par survol ne le referme pas
 (flag hoverOpened — le clic d'habitude ne doit pas « clignoter »).
 Un seul menu ouvert à la fois. */
  (function headerNavMenus() {
    const items = Array.from(document.querySelectorAll('[data-nav-menu]'));
    if (!items.length) return;

    const CLOSE_DELAY = 220;
    const instances = [];

    items.forEach((item) => {
      const trigger = item.querySelector('[data-nav-menu-trigger]');
      const panel = item.querySelector('[data-nav-menu-panel]');
      if (!trigger || !panel) return;

      let closeTimer = null;
      let hoverOpened = false;
      const inst = {};

      const open = (byHover) => {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        instances.forEach((other) => { if (other !== inst) other.close(); });
        hoverOpened = !!byHover;
        panel.dataset.open = 'true';
        trigger.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        hoverOpened = false;
        panel.dataset.open = 'false';
        trigger.setAttribute('aria-expanded', 'false');
      };
      const scheduleClose = () => {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(close, CLOSE_DELAY);
      };
      inst.close = close;
      inst.root = item;

      item.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'touch') return;
        open(true);
      });
      item.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'touch') return;
        scheduleClose();
      });

      trigger.addEventListener('click', () => {
        if (panel.dataset.open === 'true') {
          if (hoverOpened) { hoverOpened = false; return; } // clic d'habitude sous survol : rien
          close();
        } else {
          open(false);
        }
      });

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && panel.dataset.open === 'true') {
          e.stopPropagation();
          close();
          trigger.focus();
        }
      });
      item.addEventListener('focusout', (e) => {
        if (item.contains(e.relatedTarget)) return;
        close();
      });

      instances.push(inst);
    });

 // Fermeture au clic / tap en dehors (tactile notamment)
    document.addEventListener('click', (e) => {
      instances.forEach((inst) => {
        if (!inst.root.contains(e.target)) inst.close();
      });
    });
  })();

 /* ── Page collection : drawer filtres + auto-submit ───────────────────
 Mobile/tablette : le bouton « Filtres » du topbar ouvre/ferme le
 drawer overlay. Fermeture sur :
 - clic sur l'overlay
 - clic sur le bouton du drawer
 - touche Escape
 Quand le drawer est ouvert, le scroll body est verrouillé.

 Form filtres : auto-submit sur change d'un input (checkbox, sort,
 prix). L'expérience reste rapide : un seul rechargement par
 interaction utilisateur, l'URL reste la source de vérité.
 */
  (function collectionFilters() {
    const sidebar = document.querySelector('[data-collection-sidebar]');
    const toggle  = document.querySelector('[data-sidebar-toggle]');
    const closes  = document.querySelectorAll('[data-sidebar-close]');
    const form    = document.querySelector('[data-collection-filters]');
    const sort    = document.querySelector('[data-sort-select]');

 /* ── Outils du tiroir chargés en DIFFÉRÉ (fragment collection-tools) ──
 Accès direct (personnes + thématiques, JSON) et croisement de thèmes
 ne sont plus rendus dans la page : fetch de la section sur la MÊME URL
 (collection + current_tags identiques) au premier temps libre après le
 chargement, ou dès l'ouverture du tiroir ; puis person-search:mount
 (la barre rapide du topbar partage ce jeu de données). */
    const toolsHost = document.querySelector('[data-collection-tools]');
    let toolsLoaded = false;
    let toolsLoading = null;
    const loadTools = () => {
      if (!toolsHost || toolsLoaded || toolsLoading) return toolsLoading;
      const sec = toolsHost.getAttribute('data-collection-tools-section') || 'collection-tools';
      const qs = window.location.search ? window.location.search + '&' : '?';
      const url = window.location.pathname + qs + 'section_id=' + encodeURIComponent(sec);
      toolsLoading = fetch(url, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.shopify-section') || doc.body;
          toolsHost.innerHTML = inner.innerHTML;
          toolsLoaded = true;
          document.dispatchEvent(new CustomEvent('person-search:mount'));
        })
        .catch(() => {})
        .finally(() => { toolsLoading = null; });
      return toolsLoading;
    };
    if (toolsHost) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(() => loadTools(), { timeout: 2500 });
      else window.setTimeout(loadTools, 1200);
    }

 /* ── Drawer toggle (tiroir universel) ── */
    if (sidebar && toggle) {
 // PORTAL DOM : le tiroir est
 // déplacé vers <body> au chargement — son position:fixed s'ancre
 // au viewport sans interférence d'AUCUN ancêtre (transform/filter/
 // contain, présent ou futur), même approche que le lightbox PDP.
 // Symptôme corrigé : panneau décalé du montant du scroll de page
 // (haut coupé, premiers filtres inaccessibles, verrou body
 // empêchant de remonter). Complété côté CSS : overlay + panneau
 // en position:fixed DIRECT. Les associations form="…" (tri, pills
 // rapides) fonctionnent par ID au niveau document survivent au
 // déplacement.
      if (sidebar.parentNode !== document.body) {
        document.body.appendChild(sidebar);
      }

 // Verrou body iOS RÉEL : overflow:hidden ne
 // bloque PAS le scroll de la page derrière sur Safari iOS — les
 // gestes « fuyaient » vers la page (l'écran remontait tout seul
 // pendant qu'on cherchait les derniers filtres). Technique
 // position:fixed + top:-scrollY, position restaurée à la fermeture.
      let lockScrollY = 0;
      const open = () => {
        loadTools();
        lockScrollY = window.scrollY;
        sidebar.dataset.open = 'true';
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('collection-sidebar-open');
        document.body.style.top = `-${lockScrollY}px`;
 // Toujours ouvrir EN TÊTE de liste (défense : si le navigateur a
 // restauré un défilement interne, le haut — Filtrer, accès
 // direct, premiers filtres — doit rester atteignable).
        if (form) form.scrollTop = 0;
 // Gestion de focus (dialogue modal) : le focus ENTRE dans le
 // tiroir à l'ouverture — sur le bouton de fermeture du panneau
 // (repère stable, premier focusable), après la transition CSS.
        const firstTarget = sidebar.querySelector('.collection-sidebar__panel [data-sidebar-close], .collection-sidebar__panel button, .collection-sidebar__panel a[href]');
        if (firstTarget) setTimeout(() => firstTarget.focus(), 80);
        document.addEventListener('keydown', onKeydown);
      };
      const close = () => {
        sidebar.dataset.open = 'false';
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('collection-sidebar-open');
        document.body.style.top = '';
        window.scrollTo(0, lockScrollY);
        document.removeEventListener('keydown', onKeydown);
 // Restitution : le clavier repart d'où il était venu.
        toggle.focus();
      };
      const onKeydown = (e) => {
        if (e.key === 'Escape') { close(); return; }
        trapTabKey(sidebar, e);
      };

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (sidebar.dataset.open === 'true') close();
        else open();
      });
      closes.forEach((btn) => btn.addEventListener('click', close));
    }

 /* ── Auto-submit du form de filtres au change ── */
    if (form) {
      form.addEventListener('change', () => form.submit());
    }

 /* ── Sort select : submit le form parent (associé via form="…") ── */
    if (sort && form) {
      sort.addEventListener('change', () => form.submit());
    }

 /* ── Filtres rapides ──
 Les cases des pills sont ASSOCIÉES au form du tiroir (form=) mais
 le tiroir contient les MÊMES cases (name/value) : avant submit, on
 synchronise les doubles (sinon décocher une pill laisserait la
 case du tiroir cochée le filtre resterait au submit). */
    const quick = document.querySelector('[data-quick-filters]');
    if (quick && form) {
      quick.addEventListener('change', (e) => {
        const inp = e.target;
        if (!inp || inp.type !== 'checkbox') return;
        form.querySelectorAll('input[type="checkbox"]').forEach((fi) => {
          if (fi.name === inp.name && fi.value === inp.value) fi.checked = inp.checked;
        });
        form.submit();
      });
 // Fermeture des popovers au clic à l'extérieur
      document.addEventListener('click', (e) => {
        quick.querySelectorAll('details[open]').forEach((d) => {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      });
    }
  })();

 /* ── Page personne : bio « Lire la suite » ────────────────────────────
 Amélioration progressive : la bio est rendue COMPLÈTE dans le markup
 (sans JS tout est lisible, pas de bouton). Le JS pose le clamp
 (classe is-clamped, 5 lignes) puis mesure le débordement RÉEL :
 - texte tronqué bouton révélé (toggle Lire la suite / Réduire)
 - bio courte clamp retiré, bouton jamais montré
 Pas d'animation (pas d'enjeu prefers-reduced-motion). */
  (function personBio() {
 // MULTI-INSTANCES : la page Catalogues porte une
 // description déroulable PAR carte — le module traite désormais
 // toutes les [data-person-bio] de la page (pages personnes/thèmes :
 // une seule instance, comportement strictement inchangé).
    const wraps = document.querySelectorAll('[data-person-bio]');
    if (!wraps.length) return;
    wraps.forEach((wrap) => {
      const text = wrap.querySelector('[data-person-bio-text]');
      const btn  = wrap.querySelector('[data-person-bio-toggle]');
      if (!text || !btn) return;

      text.classList.add('is-clamped');
      const overflows = text.scrollHeight > text.clientHeight + 1;
      if (!overflows) {
        text.classList.remove('is-clamped');
        return; // le bouton reste hidden
      }

      btn.hidden = false;
      btn.addEventListener('click', () => {
        const expanded = !text.classList.toggle('is-clamped');
        btn.textContent = expanded ? T('readLess', 'Réduire') : T('readMore', 'Lire la suite');
        btn.setAttribute('aria-expanded', String(expanded));
 // Réduction : le clic vient du BAS du texte déplié — une fois
 // replié, l'écran resterait plus bas, incohérent avec le
 // parcours. On remonte au niveau du bloc
 // replié si son haut est passé sous le header sticky (offset
 // géré par scroll-margin-top sur le wrap de chaque contexte).
        if (!expanded) {
          const headerH = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')
          ) || 80;
          if (wrap.getBoundingClientRect().top < headerH) {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            wrap.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          }
        }
      });
    });
  })();

 /* ── Barre alphabétique GÉNÉRIQUE (index de personnes, futur Glossaire) ─
 Filtrage CÔTÉ CLIENT de la liste déjà rendue (complète depuis S5) :
 multi-sélection de lettres (set vide = tout visible), « Tout voir »
 désactivé quand rien n'est actif, compteur « X <singulier>s affichés
 sur N » pendant un filtre. Amélioration progressive : la barre est
 rendue hidden et révélée ICI sans JS, liste complète, zéro UI morte.
 Générique par attributs : [data-alpha-bar] + [data-alpha-list] avec
 items [data-letter] + compteur optionnel [data-alpha-count]
 (data-alpha-total / data-alpha-singular). Résultat vide impossible
 (seules les lettres peuplées sont cliquables). Pas d'animation. */
  (function alphaFilter() {
    const bar = document.querySelector('[data-alpha-bar]');
    const list = document.querySelector('[data-alpha-list]');
    if (!bar || !list) return;

    const buttons = Array.from(bar.querySelectorAll('[data-alpha-letter]'));
    const clearBtn = bar.querySelector('[data-alpha-clear]');
    const items = Array.from(list.querySelectorAll('[data-letter]'));
    if (!buttons.length || !items.length) return;

    const countEl = document.querySelector('[data-alpha-count]');
    const countDefault = countEl ? countEl.textContent.trim() : '';
    const countTotal = countEl ? countEl.dataset.alphaTotal : '';
    const countSingular = countEl ? countEl.dataset.alphaSingular : '';

    bar.hidden = false;
    const active = new Set();

    function apply() {
      let shown = 0;
      for (const item of items) {
        const visible = active.size === 0 || active.has(item.dataset.letter);
        item.hidden = !visible;
        if (visible) shown++;
      }
      if (clearBtn) clearBtn.disabled = active.size === 0;
      if (countEl) {
        if (active.size === 0) {
          countEl.textContent = countDefault;
        } else {
          const tpl = shown === 1
            ? T('alphaCountOne', '{shown} {label} affiché sur {total}')
            : T('alphaCountOther', '{shown} {label}s affichés sur {total}');
          countEl.textContent = tpl
            .replace('{shown}', shown)
            .replace('{label}', countSingular)
            .replace('{total}', countTotal);
        }
      }
    }

    for (const btn of buttons) {
      btn.addEventListener('click', () => {
        const letter = btn.dataset.alphaLetter;
        const pressed = active.has(letter);
        if (pressed) active.delete(letter);
        else active.add(letter);
        btn.setAttribute('aria-pressed', String(!pressed));
        btn.classList.toggle('is-active', !pressed);
        apply();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        active.clear();
        for (const btn of buttons) {
          btn.setAttribute('aria-pressed', 'false');
          btn.classList.remove('is-active');
        }
        apply();
      });
    }
  })();

 /* ── GLOSSAIRE : « Voir aussi » vs filtre A-Z ────────────
 Une ancre #terme-x dont le groupe-lettre est masqué par le filtre
 alphabétique ne défilerait nulle part on lève le filtre (clic
 « Tout voir ») AVANT de laisser la navigation d'ancre native se
 faire (le démasquage est synchrone, la cible est visible quand le
 navigateur défile). Sans filtre actif : aucun effet. */
  (function glossarySeeAlso() {
    const list = document.querySelector('[data-alpha-list]');
    if (!list || !list.querySelector('.glox-term__see-link')) return;
    list.addEventListener('click', (e) => {
      const link = e.target.closest('.glox-term__see-link');
      if (!link) return;
      const id = decodeURIComponent((link.getAttribute('href') || '').slice(1));
      const target = id && document.getElementById(id);
      if (!target) return;
      const group = target.closest('[data-letter]');
      if (group && group.hidden) {
        const clear = document.querySelector('[data-alpha-clear]');
        if (clear) clear.click();
      }
    });
  })();

 /* ── PHOTOS DU FORMULAIRE VENDRE — upload Cloudinary UNSIGNED ─────────
 (upload direct navigateur vers Cloudinary, preset unsigned).
 Progressive enhancement : le snippet estimation-form
 rend le repli checklist+mailto VISIBLE et la zone d'upload HIDDEN ;
 ce module (si les data-cloud/preset sont posés = réglages remplis)
 révèle la zone et masque le repli. Sans JS ou sans réglages : le
 repli sert, rien ne casse.
 - Ajout par bouton « Parcourir », clic sur la dropzone, ou drag &
 drop (desktop) ; listeners passifs sur rien — les dragover
 DOIVENT preventDefault (sinon le navigateur ouvre le fichier).
 - Chaque photo : validation format (JPEG/PNG/WebP/HEIC) et taille
 (10 Mo = plafond image du plan gratuit Cloudinary), aperçu
 (object URL — un HEIC non décodable perd sa vignette, pas son
 envoi), XHR POST unsigned jauge de progression réelle
 (xhr.upload.progress), retrait par × (abort si en cours).
 - URL sécurisée (secure_url) posée en champ caché
 contact[Photo N] (renumérotation à chaque changement) l'e-mail
 du form contact natif arrive avec les liens.
 - SUBMIT GATÉ pendant un téléversement : preventDefault + message,
 puis reprise AUTOMATIQUE (form.submit ne redéclenche pas ce
 listener) quand tout est monté. Un échec d'upload ne bloque
 jamais l'envoi du formulaire (la photo est simplement absente).
 NOTE sécurité : preset unsigned = par nature public (cloud name +
 preset visibles dans le DOM). Garde-fous CÔTÉ CLOUDINARY : preset
 restreint aux formats image, dossier dédié, quota du plan surveillé,
 préset révocable à tout moment (cf. guide de config). */
  (function estPhotos() {
    const root = document.querySelector('[data-est-photos]');
    if (!root) return;
    const form = root.closest('form');
    const fallback = root.querySelector('[data-est-photos-fallback]');
    const zone = root.querySelector('[data-est-photos-zone]');
    const drop = root.querySelector('[data-est-photos-drop]');
    const browse = root.querySelector('[data-est-photos-browse]');
    const input = root.querySelector('[data-est-photos-input]');
    const previews = root.querySelector('[data-est-photos-previews]');
    const status = root.querySelector('[data-est-photos-status]');
    const urlsBox = root.querySelector('[data-est-photos-urls]');
    if (!form || !zone || !drop || !browse || !input || !previews || !urlsBox) return;

    const cloud = root.getAttribute('data-cloud');
    const preset = root.getAttribute('data-preset');
    if (!cloud || !preset) return;
    const endpoint = 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/image/upload';
    const MAX_FILES = parseInt(root.getAttribute('data-max-files'), 10) || 8;
    const MAX_MB = parseInt(root.getAttribute('data-max-mb'), 10) || 10;
    const MAX_BYTES = MAX_MB * 1024 * 1024;
    const ACCEPTED_TYPE = /^image\/(jpe?g|png|webp|heic|heif)$/i;
    const ACCEPTED_EXT = /\.(jpe?g|png|webp|heic|heif)$/i;

 // Révélation (amélioration progressive)
    zone.hidden = false;
    if (fallback) fallback.hidden = true;

    const items = [];
    let pendingSubmit = false;

    const say = (msg) => { if (status) status.textContent = msg || ''; };
    const uploadingCount = () => items.filter((it) => it.status === 'uploading').length;

 // Champs cachés contact[Photo N] reconstruits à chaque changement
 // (numérotation toujours contiguë, quel que soit l'ordre des retraits)
    const syncHiddenInputs = () => {
      urlsBox.innerHTML = '';
      let n = 0;
      items.forEach((it) => {
        if (it.status !== 'done' || !it.url) return;
        n += 1;
        const h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'contact[Photo ' + n + ']';
        h.value = it.url;
        urlsBox.appendChild(h);
      });
    };

    const refresh = () => {
      syncHiddenInputs();
      const up = uploadingCount();
      const done = items.filter((it) => it.status === 'done').length;
      if (up > 0) {
        say(TN(up, 'uploadProgressOne', 'uploadProgressOther',
          'Téléversement en cours — {count} photo restante…',
          'Téléversement en cours — {count} photos restantes…'));
      } else if (done > 0) {
        say(TN(done, 'photosJoinedOne', 'photosJoinedOther',
          '{count} photo jointe à votre proposition.',
          '{count} photos jointes à votre proposition.'));
      } else {
        say('');
      }
 // Reprise auto d'un envoi retenu par le gate
      if (pendingSubmit && up === 0) {
        pendingSubmit = false;
        form.submit();
      }
    };

    const removeItem = (it) => {
      if (it.xhr && it.status === 'uploading') {
        try { it.xhr.abort(); } catch (e) { /* déjà terminé */ }
        it.status = 'removed';
      }
      if (it.objectUrl) URL.revokeObjectURL(it.objectUrl);
      const idx = items.indexOf(it);
      if (idx !== -1) items.splice(idx, 1);
      it.node.remove();
      refresh();
    };

    const fail = (it) => {
      it.status = 'error';
      it.bar.style.width = '0';
      it.node.classList.add('is-error');
      say(T('uploadFailed', "Échec du téléversement d'une photo — retirez-la (×) et réessayez, ou envoyez-la par e-mail après votre proposition."));
    };

    const startUpload = (it) => {
      const fd = new FormData();
      fd.append('file', it.file);
      fd.append('upload_preset', preset);
      const xhr = new XMLHttpRequest();
      it.xhr = xhr;
      xhr.open('POST', endpoint);
      xhr.upload.addEventListener('progress', (e) => {
        if (!e.lengthComputable) return;
        it.bar.style.width = Math.round((e.loaded / e.total) * 100) + '%';
      });
      xhr.addEventListener('load', () => {
        let url = '';
        try { url = (JSON.parse(xhr.responseText) || {}).secure_url || ''; } catch (e) { /* réponse non JSON */ }
        if (xhr.status >= 200 && xhr.status < 300 && url) {
          it.status = 'done';
          it.url = url;
          it.bar.style.width = '100%';
          it.node.classList.add('is-done');
        } else {
          fail(it);
        }
        refresh();
      });
      xhr.addEventListener('error', () => { fail(it); refresh(); });
      xhr.send(fd);
    };

    const addFiles = (files) => {
      const list = Array.prototype.slice.call(files || []);
      for (const file of list) {
        if (items.length >= MAX_FILES) {
          say(T('maxFiles', 'Maximum {max} photos — retirez-en une pour en ajouter.').replace('{max}', MAX_FILES));
          break;
        }
        const isImage = ACCEPTED_TYPE.test(file.type) || (!file.type && ACCEPTED_EXT.test(file.name));
        if (!isImage) {
          say(T('badFormat', '« {name} » ignoré — formats acceptés : JPEG, PNG, WebP, HEIC.').replace('{name}', file.name));
          continue;
        }
        if (file.size > MAX_BYTES) {
          say(T('tooBig', '« {name} » dépasse {max} Mo — réduisez-la ou envoyez-la par e-mail.').replace('{name}', file.name).replace('{max}', MAX_MB));
          continue;
        }

        const it = { file: file, status: 'uploading', url: '', xhr: null, objectUrl: '', node: null, bar: null };

        const li = document.createElement('li');
        li.className = 'est-photos__item';
        const img = document.createElement('img');
        img.className = 'est-photos__thumb';
        img.alt = '';
 // HEIC : certains navigateurs ne le décodent pas en <img> —
 // on retire la vignette cassée, l'upload continue normalement.
        img.addEventListener('error', () => img.remove());
        try {
          it.objectUrl = URL.createObjectURL(file);
          img.src = it.objectUrl;
        } catch (e) { img.remove(); }
        const bar = document.createElement('span');
        bar.className = 'est-photos__bar';
        const rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'est-photos__remove';
        rm.setAttribute('aria-label', T('removePhoto', 'Retirer cette photo'));
        rm.textContent = '×';
        rm.addEventListener('click', () => removeItem(it));
        li.appendChild(img);
        li.appendChild(bar);
        li.appendChild(rm);
        previews.appendChild(li);
        it.node = li;
        it.bar = bar;
        items.push(it);
        startUpload(it);
      }
      refresh();
    };

 // Sélecteur de fichiers : bouton, ou clic n'importe où sur la dropzone
    browse.addEventListener('click', () => input.click());
    drop.addEventListener('click', (e) => {
      if (e.target.closest('[data-est-photos-browse]')) return; // déjà géré
      input.click();
    });
    input.addEventListener('change', () => {
      addFiles(input.files);
      input.value = ''; // re-sélectionner le même fichier doit re-déclencher change
    });

 // Drag & drop (desktop) — preventDefault sur dragover obligatoire,
 // sinon le drop navigue vers le fichier.
    ['dragenter', 'dragover'].forEach((t) => {
      drop.addEventListener(t, (e) => {
        e.preventDefault();
        drop.classList.add('is-dragover');
      });
    });
    drop.addEventListener('dragleave', () => drop.classList.remove('is-dragover'));
    drop.addEventListener('drop', (e) => {
      e.preventDefault();
      drop.classList.remove('is-dragover');
      if (e.dataTransfer) addFiles(e.dataTransfer.files);
    });

 // Gate du submit : jamais d'envoi avec un téléversement en route —
 // l'envoi repart TOUT SEUL à la fin (cf. refresh).
    form.addEventListener('submit', (e) => {
      if (uploadingCount() > 0) {
        e.preventDefault();
        pendingSubmit = true;
        say(T('uploadFinishing', 'Vos photos finissent de se téléverser — votre proposition partira automatiquement dans quelques instants.'));
      }
    });
  })();

 /* ── MAILLAGE GLOSSAIRE : infobulle des termes (.glx) ─────────────────
 G1 (cadrage validé : infobulle RICHE charte — pas de
 title natif). Les liens.glx (injectés par le script glossary-link
 dans le miroir description_linked) portent data-glx-tip = extrait
 de la définition EMBARQUÉ à la génération zéro requête au survol.
 - UNE carte partagée, créée ici et PORTALÉE dans <body> (jamais
 de fixed sous un ancêtre transformé — containing block) ;
 - carte SURVOLABLE (modèle hoverable tooltip) :
 fermeture DIFFÉRÉE 220 ms — le pointeur peut traverser
 l'écart mot carte pour cliquer « Voir la définition » (vrai
 lien, href copié du mot) ; entrer dans la carte annule la
 fermeture ;
 - survol SOURIS uniquement (pointerType 'touch' ignoré — au tactile
 le tap navigue, nouvel onglet) + focus CLAVIER (Échap referme) ;
 - position : au-dessus du lien, rabattue dessous si pas la place,
 serrée dans le viewport ; masquée au scroll ;
 - aria : role tooltip + aria-describedby posé dynamiquement. */
  (function glxTooltip() {
    if (!document.querySelector('.glx[data-glx-tip]')) return;

    const tip = document.createElement('div');
    tip.className = 'glx-tip';
    tip.id = 'glx-tip';
    tip.setAttribute('role', 'tooltip');
    tip.hidden = true;
    tip.innerHTML = '<p class="glx-tip__term"></p><p class="glx-tip__text"></p><a class="glx-tip__more" target="_blank" rel="noopener">Voir la définition →</a>';
    document.body.appendChild(tip);
    const termEl = tip.querySelector('.glx-tip__term');
    const textEl = tip.querySelector('.glx-tip__text');
    const moreEl = tip.querySelector('.glx-tip__more');
    // Pages de termes (maquette 2026-11-02) : carte { handle -> URL de la
    // page } émise par le snippet glx-pages ; les miroirs maillés ne
    // changent pas. Mode 'extra' = second lien « Lire l'article complet »
    // sous « Voir la définition » ; mode 'replace' = le lien unique vise
    // la page quand elle existe (réglage de thème glx_page_link_mode).
    const pagesEl = document.querySelector('[data-glx-pages]');
    let glxPages = {};
    let glxPagesMode = 'extra';
    try {
      if (pagesEl) { glxPages = JSON.parse(pagesEl.textContent || '{}') || {}; glxPagesMode = pagesEl.getAttribute('data-glx-pages-mode') || 'extra'; }
    } catch (e) { glxPages = {}; }
    const pageEl = document.createElement('a');
    pageEl.className = 'glx-tip__more glx-tip__page';
    pageEl.target = '_blank';
    pageEl.rel = 'noopener';
    pageEl.hidden = true;
    tip.appendChild(pageEl);
    let current = null;
    let hideTimer = 0;

    const hide = () => {
      clearTimeout(hideTimer);
      if (!current) return;
      current.removeAttribute('aria-describedby');
      current = null;
      tip.hidden = true;
    };
    const scheduleHide = () => {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 220);
    };

    const show = (link) => {
      clearTimeout(hideTimer);
      const excerpt = link.getAttribute('data-glx-tip');
      if (!excerpt) return;
 // Enveloppe COLLATION (.glx--collation) : le lien contient la
 // NOTATION — le titre de l'infobulle vient de l'aria-label
 // (« Lire une collation »), pas du texte enveloppé.
 // data-glx-term (posé par le moteur de maillage quand le texte lié
 // n'est pas le titre de l'entrée : sigle « L.A.S. », alias, pluriel)
 // prime sur le texte enveloppé — le survol titre l'ENTRÉE.
      termEl.textContent = link.getAttribute('data-glx-term')
        || (link.classList.contains('glx--collation')
          ? (link.getAttribute('aria-label') || '')
          : link.textContent.replace(/\s+/g, ' ').trim()) || link.getAttribute('aria-label') || '';
      textEl.textContent = excerpt;
      moreEl.href = link.href;
 // Libellé du lien de pied ADAPTÉ à la cible ET LOCALISÉ (fix
 //) : le data-glx-more embarqué dans les miroirs est du
 // FR figé à la génération (les miroirs EN affichaient « Voir sa
 // page ») il ne sert plus que de REPLI ; le TYPE du lien
 // (classe glx--person, posée par s7-links) choisit la clé
 // traduite. Correct dans toutes les langues sans régénérer aucun
 // miroir.
      moreEl.textContent = (link.classList.contains('glx--person')
        ? T('seePersonPage', 'Voir sa page')
        : (link.getAttribute('data-glx-more') || T('seeDefinition', 'Voir la définition'))) + ' →';
      const glxHref = link.getAttribute('href') || '';
      const glxHandle = (glxHref.split('#terme-')[1] || '').split(/[?&]/)[0];
      const glxPageUrl = glxHandle && Object.prototype.hasOwnProperty.call(glxPages, glxHandle) ? glxPages[glxHandle] : '';
      pageEl.hidden = true;
      if (link.classList.contains('glx--page')) {
        // Lien déjà retargeté par le moteur de maillage vers la page du terme.
        moreEl.textContent = T('readFullEntry', "Lire l'article complet") + ' →';
      } else if (glxPageUrl && glxPagesMode === 'replace') {
        moreEl.href = glxPageUrl;
        moreEl.textContent = T('readFullEntry', "Lire l'article complet") + ' →';
      } else if (glxPageUrl) {
        pageEl.href = glxPageUrl;
        pageEl.textContent = T('readFullEntry', "Lire l'article complet") + ' →';
        pageEl.hidden = false;
      }
      link.setAttribute('aria-describedby', 'glx-tip');
      current = link;
      tip.hidden = false;
      const r = link.getBoundingClientRect();
      const tw = tip.offsetWidth;
      const th = tip.offsetHeight;
      let left = r.left + r.width / 2 - tw / 2;
      left = Math.max(12, Math.min(left, window.innerWidth - tw - 12));
      let top = r.top - th - 10;
      if (top < 12) top = r.bottom + 10;
      tip.style.left = left + 'px';
      tip.style.top = top + 'px';
    };

    document.addEventListener('pointerover', (e) => {
      if (e.pointerType === 'touch') return;
      const t = e.target;
 // Retour sur le mot courant ou entrée dans la carte : on annule
 // la fermeture différée (la carte est survolable).
      if (current && (t === current || current.contains(t) || tip.contains(t))) {
        clearTimeout(hideTimer);
        return;
      }
      const link = t.closest ? t.closest('.glx[data-glx-tip]') : null;
      if (!link || link === current) return;
      show(link);
    });
    document.addEventListener('pointerout', (e) => {
      if (!current) return;
      const from = e.target;
      const fromLink = from.closest ? from.closest('.glx[data-glx-tip]') : null;
      const leavingCurrent = fromLink === current || tip.contains(from);
      if (!leavingCurrent) return;
      const to = e.relatedTarget;
      if (to && (to === current || current.contains(to) || tip.contains(to))) return;
 // Fermeture DIFFÉRÉE : laisse le temps de traverser l'écart
 // mot carte (l'arrivée dans la carte annule, cf. pointerover).
      scheduleHide();
    });
    document.addEventListener('focusin', (e) => {
      if (tip.contains(e.target)) return; // clic sur « Voir la définition »
      const link = e.target.closest ? e.target.closest('.glx[data-glx-tip]') : null;
      if (link) show(link);
      else hide();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') hide();
    });
 // Tactile : tap en DEUX TEMPS (révision client 2026-08-21 — REMPLACE
 // « tap = navigation directe » validé le 2026-07-07). 1er tap sur un
 // terme = la carte de définition s'affiche (même visuel que le hover) ;
 // la navigation vers le glossaire passe UNIQUEMENT par le lien
 // « Voir la définition → » de la carte. Tap ailleurs = fermeture ;
 // 2e tap sur le mot = la carte reste. Desktop (hover) inchangé.
    const glxTouchUi = window.matchMedia('(hover: none)');
    document.addEventListener('click', (e) => {
      if (!glxTouchUi.matches) return;
      const link = e.target.closest ? e.target.closest('.glx[data-glx-tip]') : null;
      if (link) {
        e.preventDefault();
        if (link !== current) show(link);
        return;
      }
      if (current && !tip.contains(e.target)) hide();
    });
    window.addEventListener('scroll', hide, { passive: true });
  })();

 /* ── SWIPE tactile partagé (hero zones 1 et 2) ────────────────────────
 Glisser gauche/droite au doigt = navigation manuelle, EN PLUS des
 points. Même calibrage que le
 swipe du lightbox : amplitude > 40 px ET geste plus horizontal que
 vertical (le scroll vertical de la page reste natif — listeners
 passifs, jamais de preventDefault). Un vrai swipe ne déclenche pas
 les liens de la carte : iOS/Android ne dispatchent pas de click après
 un déplacement du doigt. */
  const attachHeroSwipe = (el, onSwipe) => {
 // VERROUILLAGE D'AXE : dès que le geste est
 // jugé majoritairement HORIZONTAL (seuil 8px), on annule le pan
 // vertical natif via preventDefault — sinon l'écran monte/descend
 // pendant le swipe des slides. Un geste vertical rend la main au
 // scroll natif immédiatement. Le touchmove est NON-passif par
 // nécessité (preventDefault) mais scopé aux seules zones swipables.
    let startX = 0;
    let startY = 0;
    let axis = null; // null = indéterminé · 'h' = horizontal · 'v' = vertical
    el.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { axis = 'v'; return; }
      axis = null;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchmove', (e) => {
      if (e.touches.length !== 1) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (axis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        axis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }
      if (axis === 'h') e.preventDefault();
    }, { passive: false });
    el.addEventListener('touchend', (e) => {
      const wasHorizontal = axis === 'h';
      axis = null;
      if (!wasHorizontal || e.changedTouches.length !== 1) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      onSwipe(dx < 0 ? 1 : -1);   // doigt vers la gauche = slide suivante
    }, { passive: true });
  };

 /* ── Hero homepage : carrousel zone gauche ────────────────────────────
 Auto-scroll réglable (default 8 s) avec pause au survol, au focus
 clavier (focusin/focusout) et quand l'onglet redevient invisible
 (visibilitychange). Pastilles cliquables ET swipe tactile pour saut
 manuel : déclenchent une pause d'inactivité de 30 s avant que
 l'auto-scroll reprenne.
 L'auto-scroll est désactivé si :
 - data-hero-autoplay="false" (réglé via Theme Editor)
 - prefers-reduced-motion: reduce
 - une seule slide dans le carrousel
 Dans ces cas, l'utilisateur navigue avec les pastilles ou au doigt.
 */
  (function homeHero() {
    const carousels = document.querySelectorAll('[data-hero-carousel]');
    if (!carousels.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const MANUAL_OVERRIDE_MS = 30000;

    carousels.forEach((carousel) => {
      const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
      const dots   = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
      if (slides.length < 2) return;   // 1 slide → rien à animer

      const autoplayEnabled = carousel.getAttribute('data-hero-autoplay') !== 'false';
      const interval = parseInt(carousel.getAttribute('data-hero-interval'), 10) || 8000;
      const canAutoplay = autoplayEnabled && !reduceMotion;
      let index = 0;
      let timer = null;
      let manualResumeTimer = null;

      const goTo = (next) => {
        if (next === index) return;
        slides[index].classList.remove('is-active');
        slides[index].setAttribute('aria-hidden', 'true');
        if (dots[index]) {
          dots[index].classList.remove('is-active');
          dots[index].setAttribute('aria-selected', 'false');
          dots[index].setAttribute('aria-current', 'false');
        }
        index = (next + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        slides[index].setAttribute('aria-hidden', 'false');
        if (dots[index]) {
          dots[index].classList.add('is-active');
          dots[index].setAttribute('aria-selected', 'true');
          dots[index].setAttribute('aria-current', 'true');
        }
      };

      const start = () => {
        if (!canAutoplay) return;
        stop();
        timer = setInterval(() => goTo(index + 1), interval);
      };

      const stop = () => {
        if (timer) { clearInterval(timer); timer = null; }
      };

      const pauseForManual = () => {
        stop();
        if (manualResumeTimer) clearTimeout(manualResumeTimer);
        manualResumeTimer = setTimeout(() => {
          manualResumeTimer = null;
          start();
        }, MANUAL_OVERRIDE_MS);
      };

 // Hover : pause / resume (ne déclenche PAS le manual override)
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', () => {
        if (manualResumeTimer) return;   // ne reprend pas si override manuel actif
        start();
      });

 // Focus clavier : pause / resume (utilisateur navigue au Tab)
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', (e) => {
 // ignore les bascules de focus restant à l'intérieur du carrousel
        if (carousel.contains(e.relatedTarget)) return;
        if (manualResumeTimer) return;
        start();
      });

 // Pastilles : saut manuel + pause 30 s
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = parseInt(dot.getAttribute('data-hero-dot'), 10);
          if (Number.isNaN(target)) return;
          goTo(target);
          pauseForManual();
        });
      });

 // Swipe tactile : même sémantique qu'un clic de pastille
      attachHeroSwipe(carousel, (dir) => {
        goTo(index + dir);
        pauseForManual();
      });

 // Onglet caché : pause ; onglet visible : reprise (sauf override manuel)
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else if (!manualResumeTimer) start();
      });

      start();
    });
  })();

 /* ── "Explorer par thèmes" : carrousel défilable ─────────────────────
 Le défilement tactile + trackpad est NATIF (overflow-x: auto +
 scroll-snap proximity) — ce module n'ajoute que :
 - les classes d'état is-scrollable / is-at-start / is-at-end
 (fondus de bord + visibilité des boutons, cf. CSS section)
 - les boutons prev/next (défilement d'une carte, smooth sauf
 prefers-reduced-motion)
 - les flèches / clavier : section survolée ou focus interne,
 jamais pendant une saisie (pattern de la galerie produit) ;
 preventDefault évite le double-scroll natif du conteneur focus.
 */
  (function themesCarousel() {
    const wraps = document.querySelectorAll('[data-themes-carousel]');
    if (!wraps.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const isTypingTarget = (el) =>
      !!el && (el.isContentEditable ||
               el.tagName === 'INPUT' ||
               el.tagName === 'TEXTAREA' ||
               el.tagName === 'SELECT');

    wraps.forEach((wrap) => {
      const scroller = wrap.querySelector('[data-themes-scroller]');
      if (!scroller) return;
      const prevBtn = wrap.querySelector('[data-themes-prev]');
      const nextBtn = wrap.querySelector('[data-themes-next]');

 /* ── États (fondus de bord + boutons) ── */
      const updateState = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        wrap.classList.toggle('is-scrollable', maxScroll > 4);
        wrap.classList.toggle('is-at-start', scroller.scrollLeft <= 4);
        wrap.classList.toggle('is-at-end', scroller.scrollLeft >= maxScroll - 4);
        if (prevBtn) prevBtn.disabled = scroller.scrollLeft <= 4;
        if (nextBtn) nextBtn.disabled = scroller.scrollLeft >= maxScroll - 4;
      };
      scroller.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);
      updateState();

 /* ── Défilement d'une carte (boutons + clavier) ── */
      const step = () => {
 // Générique : 1er enfant VISIBLE du scroller —
 // couvre.tcard (thèmes) ET.acard (Actualités & Salons, dont
 // les cartes filtrées par pills sont [hidden]).
        const card = scroller.querySelector(':scope > *:not([hidden])');
        if (!card) return scroller.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const scrollByCards = (dir) => {
        scroller.scrollBy({
          left: dir * step(),
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      };
      if (prevBtn) prevBtn.addEventListener('click', () => scrollByCards(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollByCards(1));

 /* Pas de drag souris, volontairement : sur des rangées de
 cartes-LIENS, un dragstart natif non annulé déclenche le drag
 HTML5 du lien ou de l'image et détourne les pointer events
 (pointerup jamais reçu, état bloqué, clic suivant avalé) ; un
 drag maison fiable exigerait capture de pointeur, seuils et
 pointercancel avec des cas limites résiduels. La souris a les
 flèches, la barre de défilement, la molette et le clavier ; le
 tactile a son glissement natif. */

 /* ── Clavier (flèches gauche/droite) ── */
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        if (isTypingTarget(e.target)) return;
        const focusInside = wrap.contains(document.activeElement);
        const hoverInside = wrap.matches(':hover');
        if (!focusInside && !hoverInside) return;
        e.preventDefault();
        scrollByCards(e.key === 'ArrowRight' ? 1 : -1);
      });
    });
  })();

 /* ── Hero homepage zone 2 : rotation + POINTS "pièce à la une" ────────
 Si plusieurs produits ont le metafield custom.status == "a-la-une",
 ils sont rendus comme N slides superposés dans.hero-featured.
 - Rotation AUTO (fade) toutes les `data-featured-interval` ms (8 s
 défaut), pause au survol / focus clavier / onglet caché.
 - POINTS cliquables : un par pièce, actif synchronisé ;
 clic = intention utilisateur goTo + suspension de l'auto 30 s
 puis reprise (même pattern que le carrousel gauche).
 - SWIPE tactile : glisser gauche/droite = même
 sémantique qu'un clic de point (helper attachHeroSwipe).
 - prefers-reduced-motion : rotation AUTO coupée, mais les POINTS
 et le swipe restent actifs la navigation manuelle est possible
 (avant ce fix, l'utilisateur était enfermé sur la slide 1). */
  (function homeHeroFeatured() {
    const containers = document.querySelectorAll('[data-hero-featured]');
    if (!containers.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    containers.forEach((container) => {
      const slides = Array.from(container.querySelectorAll('.hero-featured__slide'));
      if (slides.length < 2) return;

      const dots = Array.from(container.querySelectorAll('[data-featured-dot]'));
      const rotationOn = container.getAttribute('data-featured-rotation') === 'true' && !reduceMotion;
      const interval = parseInt(container.getAttribute('data-featured-interval'), 10) || 8000;
      const RESUME_DELAY = 30000;
      let index = 0;
      let timer = null;
      let resumeTimer = null;

      const goTo = (next) => {
        const target = (next + slides.length) % slides.length;
        if (target === index) return;
        slides[index].classList.remove('is-active');
        slides[index].setAttribute('aria-hidden', 'true');
        if (dots[index]) {
          dots[index].classList.remove('is-active');
          dots[index].removeAttribute('aria-current');
        }
        index = target;
        slides[index].classList.add('is-active');
        slides[index].setAttribute('aria-hidden', 'false');
        if (dots[index]) {
          dots[index].classList.add('is-active');
          dots[index].setAttribute('aria-current', 'true');
        }
      };

      const stop = () => {
        if (timer) { clearInterval(timer); timer = null; }
      };
      const start = () => {
        if (!rotationOn) return; // rotation off / reduced-motion : no-op (les points restent seuls maîtres)
        stop();
        timer = setInterval(() => goTo(index + 1), interval);
      };

 // Navigation manuelle (active AUSSI en reduced-motion) : suspend
 // l'auto 30 s puis reprend — partagée points + swipe.
      const manualGo = (target) => {
        goTo(target);
        stop();
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(start, RESUME_DELAY);
      };

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => manualGo(i));
      });

 // Swipe tactile sur la carte vedette
      attachHeroSwipe(container, (dir) => manualGo(index + dir));

 // Pause au survol et au focus clavier
      container.addEventListener('mouseenter', stop);
      container.addEventListener('mouseleave', start);
      container.addEventListener('focusin', stop);
      container.addEventListener('focusout', (e) => {
        if (container.contains(e.relatedTarget)) return;
        start();
      });

 // Pause si l'onglet devient invisible
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      start();
    });
  })();

 /* ── Hero « à la une » : VIDÉO de pièce différée ─────────────────────
 Chaque slide peut porter une <video data-hero-video> SANS src (les
 pistes MP4 transcodées sont dans data-video-sources). La photo reste
 le poster et l'élément LCP — ce module ne fait RIEN avant l'événement
 load de la page, puis :
 - GATES = les CHOIX UTILISATEUR EXPLICITES SEULEMENT (révision client
   2026-08-25 : la vidéo joue AUSSI sur téléphone — muted+playsinline
   autorise l'autoplay muet sur iOS et Android ; « c'est un mobile »
   n'est pas un choix, contrairement à) : prefers-reduced-motion
   (accessibilité OS) et Save-Data (économiseur de données) → photo
   fixe. iOS en mode économie d'énergie : play() rejeté → catch
   silencieux, la photo reste (dégradation native) ;
 - choix de la PISTE par écran ET connexion — la data mobile reste
   maîtrisée : < 768 px → la plus grande ≤ 480p ; tablette → ≤ 720p ;
   grand écran + 4g → ≤ 1080p ; connexion lente (≠ 4g) → plafond
   rabattu à 480p quel que soit l'écran ; jamais le master au-delà,
   et à défaut de piste sous le plafond, LA PLUS PETITE disponible ;
 - charge la vidéo de la slide ACTIVE seulement ; lecture au canplay
   puis fondu (.is-playing). Slide désactivée → pause ; slide vidéo
   activée par la rotation/points/swipe → chargée à ce moment-là
   (MutationObserver sur is-active : zéro couplage avec le module de
   rotation). Onglet caché → pause. Échec de lecture → silencieux,
   la photo reste (catch sur play()). */
  (function heroFeaturedVideo() {
    const videos = Array.from(document.querySelectorAll('[data-hero-video]'));
    if (!videos.length) return;
    // Les DEUX gates = des choix utilisateur explicites, jamais une
    // détection d'appareil (le mobile VOIT la vidéo — révision client
    // 2026-08-25, remplace le repli-image-mobile de 2026-07-09).
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const conn = navigator.connection;
    if (conn && conn.saveData) return;

    const pickSource = (video) => {
      let sources = [];
      try { sources = JSON.parse(video.getAttribute('data-video-sources') || '[]'); } catch (e) { /* attribut illisible → photo */ }
      if (!sources.length) return null;
      // PLAFONNEMENT PAR ÉCRAN (révisé 2026-09-02, audit vitesse : le
      // HLS natif tirait la variante 1080p 7,2 Mbps même au téléphone
      // ~8 Mo). Les déclinaisons MP4 480/720p arrivent du MIROIR
      // video_sources_json (l'attribut Liquid seul n'a que le maître).
      // Ordre : MP4 sous plafond d'abord ; le HLS adaptatif ne prime
      // QUE sur desktop rapide (grand écran, le flux s'ajuste seul).
      const hls = sources.find((s) => s.format === 'm3u8');
      const hlsOk = hls && video.canPlayType('application/vnd.apple.mpegurl');
      const mp4s = sources.filter((s) => s.format !== 'm3u8');
      const fast = !conn || !conn.effectiveType || conn.effectiveType === '4g';
      if (window.innerWidth >= 1024 && fast && hlsOk) return hls;
      if (!mp4s.length) return hlsOk ? hls : null;
      let cap;
      if (window.innerWidth < 768) cap = 480;            // téléphone
      else if (window.innerWidth < 1024) cap = 720;      // tablette
      else cap = fast ? 1080 : 720;                      // desktop sans HLS natif
      if (!fast && cap > 480) cap = 480;                 // connexion lente : plafond rabattu
      const under = mp4s.filter((s) => s.height && s.height <= cap)
        .sort((a, b) => b.height - a.height);
      if (under.length) return under[0];
      // aucun MP4 sous plafond : le HLS adaptatif vaut mieux qu'un
      // MP4 au-dessus (il descendra tout seul) ; sinon la plus petite
      if (hlsOk) return hls;
      return mp4s.slice().sort((a, b) => (a.height || 0) - (b.height || 0))[0];
    };

    const play = (video) => {
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    };

    const arm = (video) => {
      if (video.dataset.armed) { if (video.paused) play(video); return; }
      const src = pickSource(video);
      if (!src) return;
      video.dataset.armed = '1';
      video.muted = true; // ceinture : l'attribut peut être perdu, l'autoplay l'exige
      video.addEventListener('canplay', () => {
        play(video);
        video.classList.add('is-playing');
      }, { once: true });
      video.src = src.url;
      video.load();
    };

    const isActive = (video) => {
      const slide = video.closest('.hero-featured__slide');
      return !slide || slide.classList.contains('is-active');
    };

    const sync = () => {
      videos.forEach((v) => {
        if (document.hidden || !isActive(v)) { if (!v.paused) v.pause(); return; }
        arm(v);
      });
    };

    videos.forEach((v) => {
      const slide = v.closest('.hero-featured__slide');
      if (!slide) return;
      new MutationObserver(sync).observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
    document.addEventListener('visibilitychange', sync);

    if (document.readyState === 'complete') sync();
    else window.addEventListener('load', sync, { once: true });
  })();

 /* Cartes produit : le badge statut est UNIQUE et statique, rendu
 côté Liquid (cascade de priorité dans snippets/pcard.liquid) —
 aucune animation, aucun JS. */

 /* ── FAVORIS STORE GLOBAL ─────────────────────────────────────────────
  DOIT ÊTRE DÉFINI AVANT le module PDP (qui l'utilise via
 window.LibrairieFavoris). Bug d'init précédent (commit 07c089f) :
 le store était défini APRÈS le module PDP favoritesPdp voyait
 window.LibrairieFavoris === undefined et faisait return silencieux.

 Singleton exposé sur window.LibrairieFavoris. Stocke un array de
 handles produit dans localStorage["librairie-favoris"]. API :
 - has(handle), add(handle), remove(handle), toggle(handle)
 - all array, count number
 Dispatche window event "librairie:favoris-changed" sur tout changement.
 Listen storage event natif pour sync cross-tab automatique. */
  const favoritesStore = (function () {
    const KEY = 'librairie-favoris';

    const read = () => {
      try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
 // localStorage corrompu ou indisponible (mode privé Safari ancien) fallback array vide
        return [];
      }
    };

    const write = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {
 // Quota dépassé ou storage désactivé : on n'a rien à faire de plus
      }
    };

    const dispatch = () => {
      window.dispatchEvent(new CustomEvent('librairie:favoris-changed', {
        detail: { count: read().length }
      }));
    };

    return {
      all: () => read(),
      count: () => read().length,
      has: (handle) => read().indexOf(handle) !== -1,
      add: (handle) => {
        const list = read();
        if (list.indexOf(handle) === -1) {
          list.push(handle);
          write(list);
          dispatch();
        }
      },
      remove: (handle) => {
        const list = read().filter((h) => h !== handle);
        write(list);
        dispatch();
      },
      toggle: (handle) => {
        const list = read();
        const idx = list.indexOf(handle);
        if (idx === -1) {
          list.push(handle);
        } else {
          list.splice(idx, 1);
        }
        write(list);
        dispatch();
      }
    };
  })();
  window.LibrairieFavoris = favoritesStore;

 /* ── Verrou body PARTAGÉ (iOS-safe) ───────────────────────────────────
 position:fixed + top:-scrollY, position restaurée au déverrouillage
 (overflow:hidden seul ne bloque pas le scroll sur Safari iOS). Fige
 aussi le viewport sous les panneaux fixes — corrige le CURSEUR
 décalé du champ de recherche quand la page est scrollée en bas
 (bug de rendu Safari : caret d'un input dans un conteneur fixe
 au-dessus d'un document défilé). */
  const bodyLock = (() => {
    let y = 0;
    return {
      lock(cls) {
        y = window.scrollY;
        document.body.classList.add(cls);
        document.body.style.top = `-${y}px`;
      },
      unlock(cls) {
        document.body.classList.remove(cls);
        document.body.style.top = '';
        window.scrollTo(0, y);
      },
    };
  })();

 // Sync cross-tab : si un autre onglet modifie localStorage, on dispatche
 // notre event custom pour que le badge + boutons PDP de cet onglet
 // se mettent à jour aussi.
  window.addEventListener('storage', (e) => {
    if (e.key === 'librairie-favoris') {
      window.dispatchEvent(new CustomEvent('librairie:favoris-changed', {
        detail: { count: favoritesStore.count() }
      }));
    }
  });

 /* ══ PAGE PRODUIT (PDP) — interactions ══════════════════════════════
 Module relocalisé depuis sections/main-product.liquid {% javascript %}
 vers theme.js suite à un bug où le bundle JS auto-généré par Shopify
 pour les sections n'était pas chargé sur la page produit (bug
 observé via DevTools Console : aucun module JS détecté). En le
 mettant ici, on garantit son exécution puisque theme.js est inclus
 dans theme.liquid via <script src="..." defer>.

 Le test `if (!pdp) return;` rend le code idempotent : ne s'exécute
 QUE quand un élément [data-pdp] est présent dans la page (= page
 produit individuelle).

 Modules : galerie + lightbox + modal question + description toggle + favoris.
 */
  (function pdp() {
    const pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;

 /* ── 1. GALERIE : vignettes + nav prev/next main ──────────────── */
    (function gallery() {
      const main = pdp.querySelector('[data-pdp-gallery-main]');
      const mainImg = main && main.querySelector('.pdp__gallery-main-img');
      const thumbs = Array.from(pdp.querySelectorAll('[data-pdp-thumb-index]'));
      const prevBtn = pdp.querySelector('[data-pdp-main-prev]');
      const nextBtn = pdp.querySelector('[data-pdp-main-next]');
      if (!main || !mainImg || thumbs.length < 2) return;

 /* Référence capturée AVANT le portal DOM du lightbox : au premier
 open, le lightbox est déplacé vers document.body (cf. module
 lightbox) et SORT du sous-arbre [data-pdp]. Une requête
 pdp.querySelector(...) sur ses slides échoue alors ( la galerie
 restait bloquée sur la 1re image après fermeture du lightbox,
 bug). La référence d'élément, elle, survit au
 déplacement dans le DOM. */
      const lightboxRoot = pdp.querySelector('[data-pdp-lightbox]');

      let currentIndex = 0;

 /* ── Images de la galerie : SES PROPRES sources + préchargement ──
 Chaque vignette porte l'image à la TAILLE DE LA GALERIE (mêmes
 largeurs et même sizes que l'image principale — data-pdp-main-*).
 Avant (révision mobile 2026-09-14), le swap lisait les slides du
 lightbox : depuis que celles-ci ne sont plus préchargées, chaque
 changement d'image déclenchait le téléchargement d'un 1800 px, et
 un tap suivant annulait le précédent — la première photo restait
 affichée jusqu'à la fin de la série (constat client). Désormais :
 sources à la taille affichée (moitié plus légères) et préchargement
 SÉQUENTIEL en priorité basse après le chargement de la page, la
 suivante d'abord — le swap retrouve l'image en cache, comme avant.
 Connexion lente / économie de données : seule la suivante est
 préchargée d'avance, le reste au premier geste sur la galerie. */
      const mainSizes = mainImg.getAttribute('sizes') || '';
      const warmed = new Set();
 // Index dont l'image de galerie est DÉCODÉE (en cache) : le swap
 // peut l'afficher directement. Sinon la vignette sert de relais.
 // La 1re image n'est PAS présumée en cache : ses candidats de swap
 // doivent être ceux de image_tag (cf. main-product) — on la
 // préchauffe comme les autres (coût nul si identique) et son
 // chargement initial la marque décodée.
      const fullLoaded = new Set();
      if (mainImg.complete && mainImg.naturalWidth > 0) fullLoaded.add(0);
      const warmOne = (i) => new Promise((resolve) => {
        const t = thumbs[i];
        if (!t || warmed.has(i) || !t.dataset.pdpMainSrcset) { resolve(); return; }
        warmed.add(i);
        const im = new Image();
        try { im.fetchPriority = 'low'; } catch (e) { /* attribut absent : sans effet */ }
        im.onload = () => { fullLoaded.add(i); resolve(); };
        im.onerror = () => resolve();
        im.sizes = mainSizes;
        im.srcset = t.dataset.pdpMainSrcset;
        im.src = t.dataset.pdpMainSrc || '';
      });
      mainImg.addEventListener('load', () => { if (mainImg.srcset) fullLoaded.add(currentIndex); });
      let warmingAll = false;
 // Préchargement EN PARALLÈLE (pas en série : sur un iPhone en 4G,
 // chaque variante 1280 px demandée pour la première fois attend la
 // génération du CDN ~1 s — en série, l'utilisateur qui tapote dès
 // l'arrivée sur la fiche rattrapait le préchargement ; constat client
 // 2026-09-14). Après le chargement de la page, priorité basse.
      const warmAll = () => {
        if (warmingAll) return;
        warmingAll = true;
        const n = thumbs.length;
        for (let k = 1; k <= n; k++) warmOne((currentIndex + k) % n);
      };
      const conn = navigator.connection || {};
      const slowNet = !!conn.saveData || (conn.effectiveType && conn.effectiveType !== '4g');
      const kickWarm = () => {
        const idle = window.requestIdleCallback || ((f) => setTimeout(f, 400));
        idle(() => { if (slowNet) warmOne((currentIndex + 1) % thumbs.length); else warmAll(); });
      };
      if (document.readyState === 'complete') kickWarm();
      else window.addEventListener('load', kickWarm, { once: true });
 // Premier geste sur la galerie = intention : tout précharger.
      ['touchstart', 'mouseenter', 'focusin'].forEach((ev) => {
        pdp.querySelector('[data-pdp-gallery]').addEventListener(ev, warmAll, { once: true, passive: true });
      });

      const showIndex = (idx) => {
        const total = thumbs.length;
        const next = ((idx % total) + total) % total;
        if (next === currentIndex) return;

        const thumbData = thumbs[next].dataset;
        const lightboxSlide = lightboxRoot
          ? lightboxRoot.querySelector('[data-pdp-lightbox-slide="' + next + '"] img')
          : null;
        const fallbackImg = thumbs[next].querySelector('.pdp__gallery-thumb-img');
        if (!thumbData.pdpMainSrcset && !lightboxSlide && !fallbackImg) return;

 // La suivante se précharge dès maintenant (le geste se répète).
        warmOne((next + 1) % total);

        mainImg.classList.add('is-fading');
        setTimeout(() => {
          if (thumbData.pdpMainSrcset) {
 // Mêmes candidats et même sizes que le préchargement → cache.
            const applyFull = () => {
              mainImg.sizes = mainSizes;
              mainImg.srcset = thumbData.pdpMainSrcset;
              mainImg.src = thumbData.pdpMainSrc || mainImg.src;
            };
            const thumbImg = thumbs[next].querySelector('.pdp__gallery-thumb-img');
            if (!fullLoaded.has(next) && thumbImg && thumbImg.complete && thumbImg.naturalWidth > 0 && thumbImg.currentSrc) {
 // Image pas encore en cache : la VIGNETTE (déjà chargée) prend la
 // place à l'instant — le changement de photo est visible tout de
 // suite, et l'image nette la remplace dès qu'elle arrive (le
 // navigateur garde l'image affichée tant que la suivante n'est pas
 // décodée). Deux frames pour laisser la vignette se peindre.
              mainImg.srcset = '';
              mainImg.sizes = '';
              mainImg.src = thumbImg.currentSrc;
              requestAnimationFrame(() => requestAnimationFrame(applyFull));
            } else {
              applyFull();
            }
          } else if (lightboxSlide) {
 // Repli (markup sans data-pdp-main-*) : slides du lightbox, dont
 // les URLs vivent en data-* tant qu'il n'a pas été ouvert.
            mainImg.src = lightboxSlide.dataset.src || lightboxSlide.src;
            mainImg.srcset = lightboxSlide.dataset.srcset || lightboxSlide.srcset || '';
            mainImg.sizes = lightboxSlide.sizes || '';
          } else {
 // Purge du srcset hérité : sans ça le navigateur continue de
 // l'utiliser et l'image visible ne change pas malgré le src.
            mainImg.src = fallbackImg.src;
            mainImg.srcset = '';
            mainImg.sizes = '';
          }
          mainImg.classList.remove('is-fading');
        }, 200);

        thumbs.forEach((t, i) => {
          t.classList.toggle('is-active', i === next);
          t.setAttribute('aria-selected', i === next ? 'true' : 'false');
        });
        // colonne vignettes CONFINEE (finition 2026-08-22) : garder la
        // vignette active visible dans le defilement interne - scroll du
        // CONTENEUR seul (jamais scrollIntoView : il bougerait la page).
        const activeThumb = thumbs[next];
        const thumbsCol = activeThumb.parentElement;
        if (thumbsCol && thumbsCol.scrollHeight > thumbsCol.clientHeight) {
          if (activeThumb.offsetTop < thumbsCol.scrollTop) {
            thumbsCol.scrollTop = activeThumb.offsetTop;
          } else if (activeThumb.offsetTop + activeThumb.offsetHeight > thumbsCol.scrollTop + thumbsCol.clientHeight) {
            thumbsCol.scrollTop = activeThumb.offsetTop + activeThumb.offsetHeight - thumbsCol.clientHeight;
          }
        }

        main.setAttribute('data-pdp-open-lightbox', String(next));
        currentIndex = next;
      };

      // Vignettes = SWAP (retabli au changement de direction 2026-08-22,
      // arbitrage client : galerie classique — le clic vignette change
      // l'image principale ; la lightbox reste au clic sur l'image).
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          showIndex(parseInt(thumb.getAttribute('data-pdp-thumb-index'), 10) || 0);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          showIndex(currentIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          showIndex(currentIndex + 1);
        });
      }

 /* ── SWIPE tactile entre les images ───────────────
 modèle À AXE VERROUILLÉ réutilisé tel quel (attachHeroSwipe —
 fix iPhone du hero) : geste horizontal image
 suivante/précédente SANS pan vertical parasite (preventDefault
 scopé au geste jugé horizontal) ; geste vertical la main au
 scroll natif immédiatement ; hors de l'image principale, le
 scroll de la page n'est jamais touché. Un vrai swipe ne
 déclenche pas le clic d'ouverture du lightbox (iOS/Android ne
 dispatchent pas de click après déplacement du doigt). */
      attachHeroSwipe(main, (dir) => showIndex(currentIndex + dir));

 /* ── Resynchronisation à la fermeture du lightbox ──────────────
 La galerie principale reprend sur l'image consultée en plein
 écran (continuité). Événement émis par le module lightbox dans
 close. showIndex est no-op si l'index n'a pas changé. */
      pdp.addEventListener('pdp:lightbox-closed', (e) => {
        if (e.detail && typeof e.detail.index === 'number') showIndex(e.detail.index);
      });

 /* ── NAVIGATION CLAVIER / sur la galerie (hors lightbox) ──
 Active uniquement dans un contexte pertinent :
 - focus à l'intérieur de la galerie (vignettes, prev/next,
 image principale — tous des <button> focusables), OU
 - pointeur au-dessus de la galerie (:hover).
 Jamais pendant la saisie dans un champ (input / textarea /
 select / contenteditable), jamais quand le lightbox est ouvert
 (il a son propre handler / cohérent), jamais quand la
 modal « Poser une question » est ouverte. Ailleurs sur la
 page, les flèches gardent leur comportement natif (scroll). */
      const galleryRoot = pdp.querySelector('[data-pdp-gallery]');
      const isTypingTarget = (el) =>
        !!el && (el.isContentEditable ||
                 el.tagName === 'INPUT' ||
                 el.tagName === 'TEXTAREA' ||
                 el.tagName === 'SELECT');
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        if (!galleryRoot) return;
        if (document.body.classList.contains('pdp-lightbox-open')) return;
        if (document.body.classList.contains('pdp-question-modal-open')) return;
        if (isTypingTarget(e.target)) return;
        // Fleches actives sur TOUTE la fiche (garantie client 2026-08-22)
        // - la condition focus/survol d'origine est retiree ; les gardes
        // saisie/lightbox/modale au-dessus suffisent.
        e.preventDefault();
        showIndex(currentIndex + (e.key === 'ArrowRight' ? 1 : -1));
      });
    })();

 /* ── 2. LIGHTBOX ─────────────────────────────────────────────────── */
    (function lightbox() {
      const lightboxEl = pdp.querySelector('[data-pdp-lightbox]');
      if (!lightboxEl) return;

      const slides = Array.from(lightboxEl.querySelectorAll('[data-pdp-lightbox-slide]'));
      const counter = lightboxEl.querySelector('[data-pdp-lightbox-current]');
      const closeBtn = lightboxEl.querySelector('[data-pdp-lightbox-close]');
      const prevBtn = lightboxEl.querySelector('[data-pdp-lightbox-prev]');
      const nextBtn = lightboxEl.querySelector('[data-pdp-lightbox-next]');
      const openTriggers = pdp.querySelectorAll('[data-pdp-open-lightbox]');

      let currentIndex = 0;
      let lastFocused = null;
      let touchStartX = 0;

 /* ── État zoom (1x à 4x) + pan ── */
      const ZOOM_MIN = 1;
      const ZOOM_MAX = 4;
      const WHEEL_THROTTLE_MS = 80;   // throttle nav horizontale trackpad (le zoom est amorti via rAF, pas throttlé)
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let lastWheelAt = 0;
      let zoomLevel = 1;              // valeur appliquée (converge vers zoomTarget)
      let zoomTarget = 1;             // cible fixée par clic / molette / trackpad / boutons / paliers
      let zoomRaf = null;
      let panX = 0, panY = 0;
      let panStartX = 0, panStartY = 0, panOriginX = 0, panOriginY = 0;
      let isPanning = false;

      const getActiveImg = () => {
        const active = slides[currentIndex];
        return active ? active.querySelector('img') : null;
      };
 // Pose les URLs réelles d'une slide (data-src / data-srcset → src / srcset), une fois.
      const warm = (i) => {
        const img = slides[i] && slides[i].querySelector('img');
        if (!img || !img.dataset.src) return;
        img.srcset = img.dataset.srcset || '';
        img.src = img.dataset.src;
        delete img.dataset.src;
        delete img.dataset.srcset;
      };

 // Update du bouton display "1×" + marquage item actif du menu paliers
 // à chaque changement de zoom. Format : entier sans décimale, sinon 1 décimale.
      const updateZoomDisplay = () => {
        const displayEl = lightboxEl.querySelector('[data-pdp-zoom-current]');
        if (displayEl) {
          const formatted = zoomLevel === Math.floor(zoomLevel)
            ? zoomLevel + '×'
            : zoomLevel.toFixed(1).replace(/\.0$/, '') + '×';
          displayEl.textContent = formatted;
        }
        const menu = lightboxEl.querySelector('[data-pdp-lightbox-zoom-menu]');
        if (menu) {
          menu.querySelectorAll('button[data-zoom-level]').forEach((btn) => {
            const level = parseFloat(btn.getAttribute('data-zoom-level'));
            btn.classList.toggle('is-active', Math.abs(level - zoomLevel) < 0.05);
          });
        }
      };

      const applyTransform = () => {
        const img = getActiveImg();
        if (!img) return;
        img.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomLevel + ')';
        img.style.cursor = zoomLevel > 1 ? (isPanning ? 'grabbing' : 'grab') : 'zoom-in';
        updateZoomDisplay();
      };

 /* ── Convergence amortie zoomLevel zoomTarget (rAF) ──────────
 Toutes les sources de zoom fixent une CIBLE ; cette boucle
 interpole ~22 %/frame vers la cible. Résultat : la molette
 (crans discrets et gros) est adoucie sans devenir molle —
 « rigide mais souple » — et le trackpad (flux continu) ne part
 pas tout seul. Quand la cible est 1×, le pan est ramené à 0
 dans le même mouvement pour recentrer l'image. */
      const animateZoom = () => {
        zoomRaf = null;
        const diff = zoomTarget - zoomLevel;
        if (Math.abs(diff) < 0.004) {
          zoomLevel = zoomTarget;
          if (zoomLevel <= ZOOM_MIN) { panX = 0; panY = 0; }
          applyTransform();
          return;
        }
        zoomLevel += diff * 0.22;
        if (zoomTarget <= ZOOM_MIN) { panX *= 0.78; panY *= 0.78; }
        applyTransform();
        zoomRaf = requestAnimationFrame(animateZoom);
      };

      const setZoomTarget = (target, immediate) => {
        zoomTarget = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, target));
        if (immediate || reduceMotion.matches) {
          if (zoomRaf) { cancelAnimationFrame(zoomRaf); zoomRaf = null; }
          zoomLevel = zoomTarget;
          if (zoomLevel <= ZOOM_MIN) { panX = 0; panY = 0; }
          applyTransform();
          return;
        }
        if (!zoomRaf) zoomRaf = requestAnimationFrame(animateZoom);
      };

      const resetZoom = () => {
        if (zoomRaf) { cancelAnimationFrame(zoomRaf); zoomRaf = null; }
        zoomLevel = 1; zoomTarget = 1; panX = 0; panY = 0;
 // Reset du transform sur TOUS les slides (pas seulement le courant)
 // pour éviter qu'un slide précédemment zoomé garde sa transform
 // quand on revient dessus via prev/next.
        slides.forEach((slide) => {
          const img = slide.querySelector('img');
          if (img) {
            img.style.transform = '';
            img.style.cursor = 'zoom-in';
          }
        });
        updateZoomDisplay();
      };

      const setIndex = (idx) => {
        const total = slides.length;
        if (total === 0) return;
        resetZoom();
        currentIndex = ((idx % total) + total) % total;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === currentIndex));
        if (counter) counter.textContent = String(currentIndex + 1);
      };

      const open = (idx) => {
        lastFocused = document.activeElement;
 // Slides sans URL au chargement (révision mobile) : les vraies URLs
 // vivent en data-src / data-srcset et ne sont posées qu'ici, slide
 // demandée d'abord puis les autres.
        warm(idx || 0);
        slides.forEach((_, i) => { if (i !== (idx || 0)) warm(i); });
 // PORTAL DOM : au premier open, déplace le lightbox vers
 // document.body. Garantit que position: fixed s'ancre au viewport
 // sans interférence d'un éventuel ancêtre avec transform/filter/
 // perspective. Idempotent : no-op si déjà dans body.
        if (lightboxEl.parentNode !== document.body) {
          document.body.appendChild(lightboxEl);
        }
        setIndex(idx || 0);
        lightboxEl.removeAttribute('hidden');
        lightboxEl.setAttribute('data-open', 'true');
        document.body.classList.add('pdp-lightbox-open');
        if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
        document.addEventListener('keydown', onKeydown);
      };

      const close = () => {
        lightboxEl.setAttribute('data-open', 'false');
        document.body.classList.remove('pdp-lightbox-open');
        document.removeEventListener('keydown', onKeydown);
 // Continuité : informe la galerie principale de l'image consultée
 // (elle se resynchronise via son listener pdp:lightbox-closed).
        pdp.dispatchEvent(new CustomEvent('pdp:lightbox-closed', { detail: { index: currentIndex } }));
        setTimeout(() => {
          lightboxEl.setAttribute('hidden', '');
          if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
        }, 300);
      };

      const onKeydown = (e) => {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); setIndex(currentIndex - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setIndex(currentIndex + 1); }
      };

      openTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          if (trigger.classList.contains('pdp__gallery-main--placeholder')) return;
          e.preventDefault();
          const idx = parseInt(trigger.getAttribute('data-pdp-open-lightbox'), 10) || 0;
          open(idx);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prevBtn) prevBtn.addEventListener('click', () => setIndex(currentIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setIndex(currentIndex + 1));

      lightboxEl.addEventListener('click', (e) => {
        if (e.target === lightboxEl) close();
      });

 /* ── SWIPE TACTILE : touchstart sur la slide (capture position),
 touchend pour calculer dx. touch-action: pan-y sur.pdp-lightbox__slide
 garantit que le browser ne scrolle pas la page horizontalement. ── */
      let touchStartY = 0;
      lightboxEl.addEventListener('touchstart', (e) => {
        if (zoomTarget > ZOOM_MIN) return; // pas de swipe quand zoomé
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      lightboxEl.addEventListener('touchend', (e) => {
        if (zoomTarget > ZOOM_MIN) return;
        if (e.changedTouches.length !== 1 || touchStartX === 0) return;
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        touchStartX = 0;
        touchStartY = 0;
 // Swipe horizontal franc : amplitude > 40px ET plus horizontal que vertical
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        setIndex(currentIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });

 /* ── WHEEL / TRACKPAD — molette = zoom DIRECT (retour client
 2026-08-22 : l'« option B » Ctrl-seulement est retirée) :
 - vertical (molette OU trackpad 2 doigts, Ctrl ou pas) :
 zoom / dézoom, image zoomée ou non ;
 - horizontal franc sur image NON zoomée : navigation
 prev/next (trackpad), throttlé — conservé ;
 - Ctrl/Cmd + molette et pinch trackpad passent par la même
 branche zoom (wheel events ctrlKey=true).

 Calibrage par SOURCE (signaux de nature différente) :
 - MOLETTE : crans discrets et gros (deltaMode lignes, ou
 |deltaY| ≥ 80 px) incrément multiplicatif fixe par cran
 (±15 %), adouci par l'amorti rAF réactif sans à-coup
 - TRACKPAD : flux continu de petits deltas atténuation
 exponentielle proportionnelle au delta (freinage), même
 amorti rAF pas d'hypersensibilité ni de dérive ── */
      lightboxEl.addEventListener('wheel', (e) => {
        e.preventDefault(); // bloque scroll page sous-jacent dans tous les cas

 // Horizontal franc sur image non zoomée : navigation entre les vues
        if (!e.ctrlKey && !e.metaKey && zoomTarget <= ZOOM_MIN
            && Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 20) {
          const now = Date.now();
          if (now - lastWheelAt < WHEEL_THROTTLE_MS) return;
          lastWheelAt = now;
          setIndex(currentIndex + (e.deltaX > 0 ? 1 : -1));
          return;
        }

        const deltaPx = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
        if (deltaPx === 0) return;
        const isNotchWheel = e.deltaMode !== 0 || Math.abs(deltaPx) >= 80;
        let factor;
        if (isNotchWheel) {
          factor = deltaPx < 0 ? 1.15 : 1 / 1.15;
        } else {
          factor = Math.exp(deltaPx * -0.0035);
        }
        setZoomTarget(zoomTarget * factor);
      }, { passive: false });

 /* ── CLIC SIMPLE = toggle zoom (promesse du curseur loupe +) ───
 Clic sur l'image non zoomée zoom 2× animé. Clic sur l'image
 zoomée retour 1×. Un VRAI drag (pan) n'est pas un clic : si
 le pointeur a bougé de plus de 6 px entre mousedown et click,
 on ignore (l'utilisateur déplaçait l'image). au lieu de
 double-clic, incohérent avec l'affordance du curseur. */
      let pressX = 0, pressY = 0;
      lightboxEl.addEventListener('mousedown', (e) => {
        pressX = e.clientX; pressY = e.clientY;
      });
      lightboxEl.addEventListener('click', (e) => {
        const img = getActiveImg();
        if (!img || e.target !== img) return;
        const dx = e.clientX - pressX;
        const dy = e.clientY - pressY;
        if (Math.sqrt(dx * dx + dy * dy) > 6) return; // drag, pas un clic
        setZoomTarget(zoomTarget > ZOOM_MIN ? ZOOM_MIN : 2);
      });

 /* ── PAN : drag souris quand zoomé ── */
      lightboxEl.addEventListener('mousedown', (e) => {
        if (zoomTarget <= ZOOM_MIN) return;
        const img = getActiveImg();
        if (!img || !img.contains(e.target)) return;
        e.preventDefault();
        isPanning = true;
        panStartX = e.clientX;
        panStartY = e.clientY;
        panOriginX = panX;
        panOriginY = panY;
        applyTransform();
      });
      window.addEventListener('mousemove', (e) => {
        if (!isPanning) return;
        panX = panOriginX + (e.clientX - panStartX);
        panY = panOriginY + (e.clientY - panStartY);
        applyTransform();
      });
      window.addEventListener('mouseup', () => {
        if (!isPanning) return;
        isPanning = false;
        applyTransform();
      });

 /* ── ZOOM BOUTONS : +/-/reset explicites (UX accessible, pas besoin
 de connaître le raccourci clavier Ctrl+molette) ── */
      const zoomInBtn = lightboxEl.querySelector('[data-pdp-lightbox-zoom-in]');
      const zoomOutBtn = lightboxEl.querySelector('[data-pdp-lightbox-zoom-out]');
      const zoomResetBtn = lightboxEl.querySelector('[data-pdp-lightbox-zoom-reset]');
      const zoomBy = (delta) => setZoomTarget(zoomTarget + delta);
      if (zoomInBtn)    zoomInBtn.addEventListener('click', () => zoomBy(0.5));
      if (zoomOutBtn)   zoomOutBtn.addEventListener('click', () => zoomBy(-0.5));
      if (zoomResetBtn) zoomResetBtn.addEventListener('click', () => resetZoom());

 /* ── PINCH TACTILE (2 doigts) : ratio = nouvelle distance / distance
 initiale, appliqué au zoom mémorisé au touchstart. Compatible avec
 le swipe 1-doigt déjà géré plus haut (les 2 listeners se filtrent
 mutuellement par e.touches.length). ── */
      let pinchStartDistance = 0;
      let pinchStartZoom = 1;
      const getPinchDistance = (touches) => {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      };
      lightboxEl.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 2) return;
        pinchStartDistance = getPinchDistance(e.touches);
        pinchStartZoom = zoomLevel;
      }, { passive: true });
      lightboxEl.addEventListener('touchmove', (e) => {
        if (e.touches.length !== 2 || pinchStartDistance === 0) return;
        e.preventDefault();
        const ratio = getPinchDistance(e.touches) / pinchStartDistance;
 // immediate : le zoom suit le geste des doigts sans amorti (manipulation directe)
        setZoomTarget(pinchStartZoom * ratio, true);
      }, { passive: false });
      lightboxEl.addEventListener('touchend', (e) => {
        if (e.touches.length === 0 && pinchStartDistance > 0) {
          pinchStartDistance = 0;
          if (zoomTarget <= ZOOM_MIN) resetZoom();
        }
      }, { passive: true });

 /* ── MENU PALIERS DE ZOOM (1× 1.5× 2× 3× 4×) ──────────────────
 Popup au-dessus du bouton display. Toggle au clic, ferme sur
 sélection / clic ailleurs / Escape (Escape lightbox handler
 s'occupe déjà de fermer le lightbox entier — on ferme le menu
 AVANT que le ferme-lightbox ne kicke in). */
      const zoomDisplayBtn = lightboxEl.querySelector('[data-pdp-lightbox-zoom-display]');
      const zoomMenu = lightboxEl.querySelector('[data-pdp-lightbox-zoom-menu]');
      const zoomMenuButtons = zoomMenu
        ? Array.from(zoomMenu.querySelectorAll('button[data-zoom-level]'))
        : [];

      const setZoomMenuOpen = (open) => {
        if (!zoomMenu || !zoomDisplayBtn) return;
        if (open) {
          zoomMenu.hidden = false;
          zoomDisplayBtn.setAttribute('aria-expanded', 'true');
        } else {
          zoomMenu.hidden = true;
          zoomDisplayBtn.setAttribute('aria-expanded', 'false');
        }
      };

      if (zoomDisplayBtn) {
        zoomDisplayBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          setZoomMenuOpen(!!zoomMenu.hidden); // toggle
        });
      }
      zoomMenuButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const level = parseFloat(btn.getAttribute('data-zoom-level'));
          if (Number.isNaN(level)) return;
          if (level === ZOOM_MIN) {
            setZoomTarget(ZOOM_MIN); // retour 1× animé (pan recentré par l'amorti)
          } else {
            panX = 0; panY = 0; // reset pan au changement de palier
            setZoomTarget(level);
          }
          setZoomMenuOpen(false);
        });
      });
 // Ferme menu au clic en dehors du wrapper display
      document.addEventListener('click', (e) => {
        if (!zoomMenu || zoomMenu.hidden) return;
        const wrap = lightboxEl.querySelector('.pdp-lightbox__zoom-display-wrap');
        if (wrap && !wrap.contains(e.target)) {
          setZoomMenuOpen(false);
        }
      });
 // Escape : si menu ouvert, ferme menu d'abord (sans fermer le lightbox)
      lightboxEl.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && zoomMenu && !zoomMenu.hidden) {
          e.stopPropagation();
          setZoomMenuOpen(false);
          if (zoomDisplayBtn) zoomDisplayBtn.focus();
        }
      }, true); // capture phase pour précéder le onKeydown global du lightbox

 /* ── PAN TACTILE 1 DOIGT QUAND IMAGE ZOOMÉE ────────────────────
 Permet de déplacer l'image au doigt sur mobile quand zoomée.
 Coexiste avec :
 - swipe 1 doigt non zoomé (déjà géré plus haut, ignore si zoom>1)
 - pinch 2 doigts (filtre par length === 2)
 Mutuellement exclusif : length 1 + zoom > 1 = pan, et rien d'autre. */
      let touchPanStartX = 0;
      let touchPanStartY = 0;
      let touchPanOriginX = 0;
      let touchPanOriginY = 0;
      let isTouchPanning = false;

      lightboxEl.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1 || zoomTarget <= ZOOM_MIN) return;
        isTouchPanning = true;
        touchPanStartX = e.touches[0].clientX;
        touchPanStartY = e.touches[0].clientY;
        touchPanOriginX = panX;
        touchPanOriginY = panY;
      }, { passive: true });
      lightboxEl.addEventListener('touchmove', (e) => {
        if (!isTouchPanning || e.touches.length !== 1) return;
        e.preventDefault();
        panX = touchPanOriginX + (e.touches[0].clientX - touchPanStartX);
        panY = touchPanOriginY + (e.touches[0].clientY - touchPanStartY);
        applyTransform();
      }, { passive: false });
      lightboxEl.addEventListener('touchend', () => {
        if (!isTouchPanning) return;
        isTouchPanning = false;
      }, { passive: true });
    })();

 /* ── 3. MODAL "Poser une question" ──────────────────────────────── */
    // pdpReadingSync : DEMONTE (changement de direction client
    // 2026-08-22) - l'image principale est FIXE (cadre sticky d'origine),
    // la colonne droite defile classiquement : plus rien a synchroniser,
    // la relecture est le scroll de page naturel.

    (function pdpMobileBands() {
      // M3 (2026-08-22) : la bande 2 se cale SOUS la bande 1 — la hauteur
      // reelle de la bande 1 (prix + CTA, variable par etat/longueur) est
      // publiee en variable CSS, recalculee au resize et a tout
      // changement de contenu. Telephone seulement (le CSS n'utilise la
      // variable que sous 768px — publier ne coute rien ailleurs).
      const band1 = pdp.querySelector('[data-pdp-mband1]');
      if (!band1) return;
      const publish = () => {
        pdp.style.setProperty('--pdp-mband1-h', band1.offsetHeight + 'px');
      };
      publish();
      window.addEventListener('resize', publish);
      window.addEventListener('load', publish);
      if (window.ResizeObserver) new ResizeObserver(publish).observe(band1);
    })();

    (function questionModal() {
      const modal = pdp.querySelector('[data-pdp-question-modal]');
      if (!modal) return;

 // PORTAL vers <body> : un
 // position:fixed DANS la section reste vulnérable à tout ancêtre
 // transformé/filtré (containing block) — le lightbox est déjà
 // portalé pour la même raison. Hors de l'arbre, le
 // centrage viewport est garanti par construction. Les références
 // (closeBtns, form…) restent valides : même élément, déplacé.
      document.body.appendChild(modal);

      // M1 Maggs (2026-08-22) : DEUX déclencheurs par page (rangée d'achat
      // + fin de description — le « téléport » du CTA) → binder TOUS.
      const openBtns = pdp.querySelectorAll('[data-pdp-open-question]');
      const closeBtns = modal.querySelectorAll('[data-pdp-question-close]');

      let lastFocused = null;

      const open = () => {
        lastFocused = document.activeElement;
        modal.removeAttribute('hidden');
        modal.setAttribute('data-open', 'true');
        document.body.classList.add('pdp-question-modal-open');
        const firstField = modal.querySelector('input[name="contact[Prénom]"]');
        if (firstField) setTimeout(() => firstField.focus(), 100);
        document.addEventListener('keydown', onKeydown);
      };

      const close = () => {
        modal.setAttribute('data-open', 'false');
        document.body.classList.remove('pdp-question-modal-open');
        document.removeEventListener('keydown', onKeydown);
        setTimeout(() => {
          modal.setAttribute('hidden', '');
          if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
        }, 300);
      };

      const onKeydown = (e) => {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        trapTabKey(modal, e);
      };

      openBtns.forEach((b) => b.addEventListener('click', open));
      closeBtns.forEach((btn) => btn.addEventListener('click', close));

 /* PLUS AUCUNE interception du submit (réparation —
 fuite de contacts) : l'ancien code construisait un MAILTO
 (window.location.href) qui n'envoyait RIEN côté serveur (client
 mail du visiteur souvent absent/bloqué) tout en affichant
 « envoyée ». Le formulaire est désormais le form contact NATIF :
 le POST livre à la boutique, la validation est native (required),
 et après rechargement le marqueur [data-question-autopen]
 (succès OU erreurs, rendu par Liquid) ROUVRE la modale sur la
 confirmation. */
      if (modal.querySelector('[data-question-autopen]')) open();
    })();

 /* ── 4. DESCRIPTION — toggle "Lire la suite / Réduire" ───────────
  Fix iPhone : sur iOS, le repli/déploiement de la
 barre d'URL Safari déclenche un `resize` À CHAQUE début de scroll.
 L'ancien checkOverflow remettait alors l'état replié (classes
 retirées puis reposées SANS is-expanded) la description se
 ré-enroulait dès qu'on posait le doigt, bouton bloqué sur
 « Réduire ». Deux gardes : (1) resize ignoré si la LARGEUR n'a
 pas changé (la barre d'URL ne fait varier que la hauteur) ;
 (2) checkOverflow PRÉSERVE l'état déplié et resynchronise
 label + aria-expanded dans tous les cas. */
    (function descriptionToggle() {
      const wrap = pdp.querySelector('[data-pdp-description]');
      const body = pdp.querySelector('[data-pdp-description-body]');
      const toggle = pdp.querySelector('[data-pdp-description-toggle]');
      const label = pdp.querySelector('[data-pdp-description-toggle-label]');
      if (!body || !toggle || !label) return;

      const syncToggle = () => {
        const expanded = body.classList.contains('is-expanded');
        label.textContent = expanded ? T('readLess', 'Réduire') : T('readMore', 'Lire la suite');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      const checkOverflow = () => {
        const wasExpanded = body.classList.contains('is-expanded');
        body.classList.remove('is-collapsible', 'is-expanded');
        const naturalHeight = body.scrollHeight;
        const collapsedThreshold = 240;
        if (naturalHeight > collapsedThreshold + 20) {
          body.classList.add('is-collapsible');
          if (wasExpanded) body.classList.add('is-expanded');
          toggle.removeAttribute('hidden');
        } else {
          toggle.setAttribute('hidden', '');
        }
        syncToggle();
      };
      checkOverflow();

      let resizeTimer = null;
      let lastWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        if (window.innerWidth === lastWidth) return;  // iOS : barre d'URL = hauteur seule
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(checkOverflow, 200);
      });

      toggle.addEventListener('click', () => {
        const expanded = body.classList.toggle('is-expanded');
        syncToggle();
 // Réduction : même parcours que la bio des pages personnes
 // — le clic vient du BAS de la
 // description dépliée ; une fois repliée, on remonte au niveau
 // du bloc si son haut est passé sous le header sticky (offset
 // via scroll-margin-top sur.pdp__description).
        if (!expanded && wrap) {
          const headerH = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')
          ) || 80;
          if (wrap.getBoundingClientRect().top < headerH) {
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            wrap.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          }
        }
      });
    })();

 /* ── 5. FAVORIS PAGE PRODUIT — toggle dans localStorage via store global ──
 Lit le handle produit depuis data-product-handle et délègue à
 window.LibrairieFavoris (favoritesStore défini en bas du fichier).
 Le store dispatche un événement custom qui met à jour le badge header
 en temps réel. */
    (function favoritesPdp() {
      const favBtn = pdp.querySelector('[data-pdp-fav]');
      if (!favBtn) return;
      const handle = favBtn.getAttribute('data-product-handle');
      const store = window.LibrairieFavoris;
      if (!handle || !store) return;

      const sync = () => {
        const isFav = store.has(handle);
        favBtn.setAttribute('aria-pressed', isFav ? 'true' : 'false');
        favBtn.setAttribute('aria-label', isFav ? T('favRemove', 'Retirer des favoris') : T('favAdd', 'Ajouter aux favoris'));
        favBtn.classList.toggle('is-active', isFav);
      };

      sync();
      favBtn.addEventListener('click', () => store.toggle(handle));
      window.addEventListener('librairie:favoris-changed', sync);
    })();
  })();

 /* ── Header scroll state (animation logo) ─────────────────────────────
 Toggle la classe `is-scrolled` sur.header-section dès que scrollY
 dépasse SCROLL_THRESHOLD. Consommée par le CSS du logo (.header__logo
 dans sections/header.liquid) pour faire fader + scale-down + slide-up
 le logo SVG quand l'utilisateur scrolle hors du haut de page, et
 l'animer en sens inverse au retour en haut. Le wordmark n'est jamais
 affecté (logo en position absolue).

 Throttle via requestAnimationFrame + flag `ticking` pour éviter de
 déclencher 60+ updates par seconde de scroll (perf). */
  (function headerScrollState() {
    const headerSection = document.querySelector('.header-section');
    if (!headerSection) return;

    const SCROLL_THRESHOLD = 80;
    let ticking = false;

    const update = () => {
      if (window.scrollY > SCROLL_THRESHOLD) {
        headerSection.classList.add('is-scrolled');
      } else {
        headerSection.classList.remove('is-scrolled');
      }
      ticking = false;
    };

 // État initial
    update();

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  })();

 /* ── FAVORIS BADGE HEADER ─────────────────────────────────────────────
 Met à jour le compteur affiché sur l'icône Favoris du header. Le span
 existe déjà dans header.liquid : `<span data-favorites-count hidden>0</span>`.
 On affiche/masque via attribute hidden + on injecte le nombre. */
  (function favoritesBadge() {
    const badge = document.querySelector('[data-favorites-count]');
    if (!badge) return;

    const update = () => {
      const n = favoritesStore.count();
      badge.textContent = String(n);
      if (n > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    };

    update();
    window.addEventListener('librairie:favoris-changed', update);
  })();

 /* ── CŒURS FAVORIS SUR LES CARTES PRODUIT ─────────────────────────────
 Boutons [data-pcard-fav] rendus par pcard.liquid en haut-droite des
 cartes. Clic =
 toggle direct dans le store — depuis n'importe quelle grille, sans
 ouvrir la fiche. DÉLÉGATION document : couvre les cartes insérées en
 async (page Favoris, Section Rendering API). État plein doré via
 aria-pressed, resynchronisé sur librairie:favoris-changed (donc
 aussi cross-tab et après insertion async — la page Favoris émet
 l'événement une fois ses cartes montées). */
  (function favoritesCards() {
    const syncAll = () => {
      document.querySelectorAll('[data-pcard-fav]').forEach((btn) => {
        const handle = btn.getAttribute('data-product-handle');
        if (!handle) return;
        const isFav = favoritesStore.has(handle);
        btn.setAttribute('aria-pressed', isFav ? 'true' : 'false');
        btn.setAttribute('aria-label', isFav ? T('favRemove', 'Retirer des favoris') : T('favAdd', 'Ajouter aux favoris'));
      });
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pcard-fav]');
      if (!btn) return;
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      if (handle) favoritesStore.toggle(handle);
    });

    syncAll();
    window.addEventListener('librairie:favoris-changed', syncAll);
 // Cartes injectées après la page (fragment de recommandations de la fiche).
    document.addEventListener('pdp-recos:mount', syncAll);
  })();

 /* ── RECOMMANDATIONS DE LA FICHE : fragment différé ──────────────────
 [data-pdp-recos] (main-product.liquid) reçoit sections/pdp-recos-fragment
 rendu par la Section Rendering API sur la MÊME URL (même produit, même
 locale) — au premier temps libre après le chargement, ou dès que le
 réceptacle approche du viewport. Sorti du rendu de la fiche le
 2026-09-14 : ces recommandations coûtaient 300 à 600 ms de Liquid par
 fiche, pour un bloc situé en bas de page. */
  (function pdpRecos() {
    const host = document.querySelector('[data-pdp-recos]');
    if (!host) return;
    let started = false;
    const load = () => {
      if (started) return;
      started = true;
      const sec = host.getAttribute('data-pdp-recos-section') || 'pdp-recos-fragment';
      const qs = window.location.search ? window.location.search + '&' : '?';
      const url = window.location.pathname + qs + 'section_id=' + encodeURIComponent(sec);
      fetch(url, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.shopify-section') || doc.body;
          host.innerHTML = inner.innerHTML;
          document.dispatchEvent(new CustomEvent('pdp-recos:mount'));
        })
        .catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { io.disconnect(); load(); }
      }, { rootMargin: '800px' });
      io.observe(host);
    }
    const kick = () => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 2500 });
      else window.setTimeout(load, 1200);
    };
    if (document.readyState === 'complete') kick();
    else window.addEventListener('load', kick, { once: true });
  })();

 /* ── ESPACE CLIENT VITRINE : carte chiffre Favoris ────────────────────
 Page /pages/mon-compte (sections/account-overview.liquid). L'élément
 [data-account-fav-count] n'est rendu que si la page Favoris existe
 (garde anti-404 côté Liquid) — module idempotent sinon. */
  (function accountStats() {
    const el = document.querySelector('[data-account-fav-count]');
    if (!el) return;
    const update = () => {
      el.textContent = String(favoritesStore.count());
    };
    update();
    window.addEventListener('librairie:favoris-changed', update);
  })();

 /* ── FLÈCHE « REMONTER EN HAUT » (page compte) ────────────────────────
 Bouton [data-back-top] (account-overview.liquid) révélé après 600 px
 de scroll — utile après un atterrissage par ancre de la sidebar
 (Desiderata, Adresses…), mobile ET desktop. Générique
 par attribut : réutilisable tel quel sur d'autres pages longues.
 rAF-throttlé (même pattern que headerScrollState). */
  (function backToTop() {
    const btn = document.querySelector('[data-back-top]');
    if (!btn) return;

    const SHOW_AFTER = 600;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ticking = false;

    const update = () => {
      ticking = false;
      btn.hidden = window.scrollY < SHOW_AFTER;
    };
    update();

    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    });
  })();

 /* ── AJOUT PANIER EN PANNEAU (fiche produit) ──────────────────────────
 Décision : « Ajouter au panier » n'expulse plus vers
 /cart. Interception du submit du form [data-cart-add] POST AJAX
 /cart/add.js maj du badge header [data-cart-count] ouverture du
 panneau [data-cart-panel] (Échap / clic dehors / boutons pour
 fermer, focus restitué). Toute erreur AJAX repli sur la
 soumission NATIVE (redirection /cart, comportement d'origine).
 NOTE i18n : URLs /cart/add.js et /cart.js sans préfixe de locale —
 à revisiter avec les locales supplémentaires. */
  (function cartAddPanel() {
 // Multi-formulaires : la page Catalogues porte un form
 // [data-cart-add] PAR catalogue papier — tous partagent LE panneau
 // unique de la page (slots remplis depuis la réponse /cart/add.js).
    const forms = document.querySelectorAll('form[data-cart-add]');
    const panel = document.querySelector('[data-cart-panel]');
    if (!forms.length || !panel) return;
    const badge = document.querySelector('[data-cart-count]');
    let lastFocus = null;

    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    const onOutside = (e) => {
      if (!panel.contains(e.target)) close();
    };
    const open = () => {
      lastFocus = document.activeElement;
 // Sous le header RÉEL du moment :
 // tout en haut de page, la bande d'annonce (non sticky) pousse le
 // header plus bas que --header-sticky-height (hauteur SEULE du
 // header) le top CSS calculé passait SOUS le header. On mesure
 // le bas effectif du header à l'ouverture ; le calc CSS reste le
 // repli sans JS.
      const hs = document.querySelector('.header-section');
      if (hs) panel.style.top = (Math.max(hs.getBoundingClientRect().bottom, 0) + 12) + 'px';
      panel.removeAttribute('hidden');
      panel.focus();
      document.addEventListener('keydown', onKey);
      document.addEventListener('click', onOutside, true);
    };
    function close() {
      panel.setAttribute('hidden', '');
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onOutside, true);
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    }

    panel.querySelectorAll('[data-cart-panel-close]').forEach((btn) => {
      btn.addEventListener('click', close);
    });

    const updateBadge = (count) => {
      if (!badge) return;
      badge.textContent = String(count);
      if (count > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    };

 // Message d'erreur métier INLINE sous le formulaire :
 // un refus 422 de /cart/add = Shopify fait respecter le STOCK
 // (pièce unique déjà au panier, ou tirage épuisé). L'ancien catch
 // re-soumettait NATIVEMENT le même POST même refus, mais en
 // pleine page (expulsion vers /cart, déroutant). Désormais : le
 // refus est expliqué sur place, le repli natif ne sert plus qu'aux
 // vrais échecs réseau.
    const showFormError = (form, msg) => {
      let el = form.parentNode.querySelector('.cart-add-error');
      if (!el) {
        el = document.createElement('p');
        el.className = 'cart-add-error';
        el.setAttribute('role', 'alert');
        form.insertAdjacentElement('afterend', el);
      }
      el.textContent = msg;
    };
    const clearFormError = (form) => {
      const el = form.parentNode.querySelector('.cart-add-error');
      if (el) el.remove();
    };

    forms.forEach((form) => form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      clearFormError(form);

      fetch(form.getAttribute('action') + '.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then((r) => {
          if (r.status === 422) {
            return r.json().then((err) => { throw { cartError: err }; });
          }
          if (!r.ok) throw new Error('cart/add ' + r.status);
          return r.json();
        })
        .then((item) => {
 // Remplit le panneau avec la ligne RÉELLEMENT ajoutée (carte
 // cadeau : le montant dépend de la dénomination choisie).
 // Prix via fmtMoney : format boutique (shop.money_format) +
 // bascule par locale ( — fr = boutique, autres =
 // « €montant », alignée sur snippets/money-l10n.liquid).
          const titleEl = panel.querySelector('[data-cart-panel-title]');
          const priceEl = panel.querySelector('[data-cart-panel-price]');
          const imgEl = panel.querySelector('[data-cart-panel-image]');
          if (titleEl && item.product_title) {
            let t = item.product_title;
            if (item.variant_title && item.variant_title !== 'Default Title') {
              t += ' — ' + item.variant_title;
            }
            titleEl.textContent = t;
          }
          if (priceEl && typeof item.price === 'number') {
            priceEl.textContent = fmtMoney(item.price);
          }
          if (imgEl && item.image) {
            imgEl.src = item.image;
            imgEl.removeAttribute('hidden'); // slot rendu sans image initiale (page Catalogues)
          }
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then((r) => r.json())
        .then((cartState) => {
          updateBadge(cartState.item_count);
          if (form.hasAttribute('data-cart-add-unique') && submitBtn) {
 // Pièce UNIQUE ajoutée : le bouton se VERROUILLE sans
 // rechargement (miroir de l'état serveur « Pièce déjà dans
 // votre panier » rendu par main-product au prochain
 // chargement) — un 2e clic ne peut plus partir.
            submitBtn.disabled = true;
            submitBtn.textContent = T('alreadyInCart', 'Pièce déjà dans votre panier');
            submitBtn.classList.remove('pdp__cta--primary');
            submitBtn.classList.add('pdp__cta--disabled');
          } else if (submitBtn) {
            submitBtn.disabled = false;
          }
          open();
        })
        .catch((err) => {
          if (submitBtn) submitBtn.disabled = false;
          if (err && err.cartError) {
 // Refus MÉTIER (stock) : message sur place, pas de repli
 // natif (il re-heurterait le même refus en pleine page).
            let msg = (err.cartError && (err.cartError.description || err.cartError.message)) || '';
            if (form.hasAttribute('data-cart-add-unique')) {
              msg = T('uniqueInCart', 'Cette pièce est unique — elle est déjà dans votre panier.');
            } else if (!msg) {
              msg = T('maxQty', 'Quantité maximale atteinte pour cet article.');
            }
            showFormError(form, msg);
            return;
          }
 // Vrai échec réseau : soumission native (form.submit ne
 // redéclenche pas ce listener) redirection /cart, parcours
 // jamais cassé.
          form.submit();
        });
    }));
  })();

 /* ── PAGE CATALOGUES : filtre par type (pills) ────────────────────────
 Cartes [data-cat-kind] + groupes-année [data-cat-group] auto-masqués
 quand vides. Pills [data-cat-pill] (valeur '' = Tous), aria-pressed.
 modèle [hidden] + garde display:none !important dans la section
 (un display CSS bat [hidden]). Sans JS : pills inertes,
 tout reste visible. */
  (function catalogueFilter() {
    const root = document.querySelector('[data-cat-index]');
    if (!root) return;
    const pills = root.querySelectorAll('[data-cat-pill]');
    if (!pills.length) return;
    const cards = root.querySelectorAll('[data-cat-kind]');
    const groups = root.querySelectorAll('[data-cat-group]');

    const apply = (kind) => {
      cards.forEach((c) => {
        const show = kind === '' || c.getAttribute('data-cat-kind') === kind;
        if (show) c.removeAttribute('hidden');
        else c.setAttribute('hidden', '');
      });
      groups.forEach((g) => {
        if (g.querySelector('[data-cat-kind]:not([hidden])')) g.removeAttribute('hidden');
        else g.setAttribute('hidden', '');
      });
      pills.forEach((p) => {
        p.setAttribute('aria-pressed', p.getAttribute('data-cat-pill') === kind ? 'true' : 'false');
      });
    };

    pills.forEach((p) => {
      p.addEventListener('click', () => apply(p.getAttribute('data-cat-pill')));
    });
  })();

 /* ── CARTE CADEAU : formulaire destinataire (fiche produit) ───────────
 main-product-gift-card.liquid. Champs destinataire repliés tant que
 la case « Offrir cette carte » n'est pas cochée — SANS JS les champs
 restent visibles (repli progressif, la validation Shopify ne
 s'active que si la case est cochée). Pose aussi __shopify_offset
 (fuseau du client, pour l'envoi différé « Send on » — doc Shopify :
 new Date.getTimezoneOffset). */
  (function giftCardRecipient() {
    const wrap = document.querySelector('[data-gc-recipient]');
    if (!wrap) return;
    const offset = wrap.querySelector('[data-gc-offset]');
    if (offset) offset.value = String(new Date().getTimezoneOffset());

    const toggle = wrap.querySelector('[data-gc-recipient-toggle]');
    const fields = wrap.querySelector('[data-gc-recipient-fields]');
    if (!toggle || !fields) return;
 /* Prénom (et e-mail) du destinataire OBLIGATOIRES quand on offre
 (décision : le prénom personnalise l'e-mail du cadeau —
 « Jeanne, … a pensé à vous »). `required` posé/retiré ICI et non en
 dur dans le markup : un required statique sur un champ replié
 [hidden] bloquerait la soumission d'un achat SANS destinataire
 (« invalid form control is not focusable »). Sans JS : champs
 visibles, e-mail validé par Shopify, prénom non bloquant (assumé). */
    const requiredInputs = [
      fields.querySelector('[name="properties[Recipient email]"]'),
      fields.querySelector('[name="properties[Recipient name]"]'),
    ].filter(Boolean);
    const sync = () => {
      if (toggle.checked) fields.removeAttribute('hidden');
      else fields.setAttribute('hidden', '');
      requiredInputs.forEach((input) => {
        if (toggle.checked) input.setAttribute('required', '');
        else input.removeAttribute('required');
      });
    };
    toggle.addEventListener('change', sync);
    sync();
  })();

 /* ── INDEX LOCAL DES PIÈCES (recherche par SOUS-CHAÎNE) ───────────────
 La Predictive Search native ne matche que par PRÉFIXE de mots :
 « mémo » ne trouvait jamais « Mémorial de Sainte-Hélène » (recette
 client 2026-09-02). Cet index télécharge UNE fois l'île JSON de
 toutes les pièces (fragment product-suggest-data, paginé by 250)
 puis matche localement : chaque token de la requête doit être une
 sous-chaîne du titre+créateurs pliés (accents/casse ignorés).
 Ordre : exact > titre commence par > tokens tous dans le titre >
 créateurs ; à rang égal disponibles d'abord, vendues en queue.
 search() rend null tant que l'île n'est pas chargée (les
 consommateurs replient alors sur la predictive native). */
  const pieceIndex = (() => {
    let items = null;
    let loading = null;
    const normP = (s) => String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const fetchPage = (n) => fetch(ROOT + '?section_id=product-suggest-data&page=' + n)
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector('[data-product-suggest]');
        return el ? JSON.parse(el.textContent) : { pages: 1, items: [] };
      });
    const load = () => {
      if (items) return Promise.resolve(items);
      if (loading) return loading;
      loading = fetchPage(1).then((first) => {
        // pages restantes en parallèle (plafond 8 = ceinture ~2000 pièces)
        const rest = [];
        const total = Math.min(first.pages || 1, 8);
        for (let n = 2; n <= total; n++) rest.push(fetchPage(n).catch(() => ({ items: [] })));
        return Promise.all(rest).then((more) => {
          items = (first.items || []).concat(...more.map((m) => m.items || []));
          items.forEach((it) => {
            it._t = normP(it.t);
            it._n = it._t + ' ' + normP(it.a || '');
          });
          return items;
        });
      }).catch(() => { loading = null; return null; });
      return loading;
    };
    const search = (raw, cap) => {
      if (!items) return null; // île pas (encore) chargée : repli du consommateur
      const q = normP(String(raw).trim());
      if (!q) return [];
      const tokens = q.split(/\s+/).filter(Boolean);
      if (!tokens.length) return [];
      const scored = [];
      items.forEach((it) => {
        for (let k = 0; k < tokens.length; k++) {
          if (it._n.indexOf(tokens[k]) === -1) return;
        }
        let rank = 3;
        if (it._t === q) rank = 0;
        else if (it._t.indexOf(q) === 0) rank = 1;
        else {
          let inTitle = true;
          for (let k = 0; k < tokens.length; k++) {
            if (it._t.indexOf(tokens[k]) === -1) { inTitle = false; break; }
          }
          if (inTitle) rank = 2;
        }
        const avr = it.d === 'v' ? 2 : (it.d === 'r' ? 1 : 0);
        scored.push({ it, key: rank * 10 + avr });
      });
      scored.sort((a, b) => a.key - b.key);
      return scored.slice(0, cap || 5).map((s) => s.it);
    };
    return { load, search };
  })();

 /* ── INDEX LOCAL DES CONTENUS (glossaire, bibliographies, articles) ───
 Même patron que pieceIndex (recette client 2026-09-02 : « même
 comportement » substring pour glossaire/bibliographies/articles des
 4 blogs) — île content-suggest-data fetchée une fois, matching
 tokens-AND sous-chaîne, exact > préfixe > contient. search(kind)
 filtre par famille (term/biblio/article) ; null tant que l'île
 n'est pas chargée. */
  const contentIndex = (() => {
    let items = null;
    let loading = null;
    const normC = (s) => String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const load = () => {
      if (items) return Promise.resolve(items);
      if (loading) return loading;
      loading = fetch(ROOT + '?section_id=content-suggest-data')
        .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const el = doc.querySelector('[data-content-suggest]');
          items = el ? JSON.parse(el.textContent) : [];
          items.forEach((it) => { it._n = normC(it.t); });
          return items;
        })
        .catch(() => { loading = null; return null; });
      return loading;
    };
    const search = (raw, kinds, cap) => {
      if (!items) return null;
      const q = normC(String(raw).trim());
      if (!q) return [];
      const tokens = q.split(/\s+/).filter(Boolean);
      if (!tokens.length) return [];
      const scored = [];
      items.forEach((it) => {
        if (kinds.indexOf(it.k) === -1) return;
        for (let k = 0; k < tokens.length; k++) {
          if (it._n.indexOf(tokens[k]) === -1) return;
        }
        let rank = 2;
        if (it._n === q) rank = 0;
        else if (it._n.indexOf(q) === 0) rank = 1;
        scored.push({ it, rank });
      });
      scored.sort((a, b) => a.rank - b.rank);
      return scored.slice(0, cap || 3).map((s) => s.it);
    };
    return { load, search };
  })();

 /* ── RECHERCHE PAR RÔLE (combobox des pages index personnes) ──────────
 Groupe 2 v1 : raccourci de NAVIGATION — sélectionner un
 nom navigue vers sa collection-personne. Données : <script
 type="application/json" data-person-search-data="<id>"> émis par
 person-index (mêmes chaînes triées que la grille). Filtrage
 accents-insensibles, préfixe prioritaire, max 8 suggestions,
 clavier flèches/Entrée/Échap, ARIA combobox (aria-activedescendant). */
  (function personSearch() {
 /* MULTI-INSTANCES : tiroir + barre rapide du
 topbar coexistent (data-person-search-source partage UN jeu de
 données). GROUPES : si les résultats mêlent personnes et
 thématiques (role === 'Thématique'), la liste est sectionnée
 « Personnes » / « Thématiques » (en-têtes role=presentation,
 ignorées par le clavier). */
    const roots = document.querySelectorAll('[data-person-search]');
    if (!roots.length) return;

    const norm = (str) => String(str).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

 // Montage (re)jouable : les données d'une barre peuvent arriver APRÈS
 // le chargement (fragment collection-tools injecté par collectionFilters)
 // — une barre sans données reste masquée et sera retentée à l'événement
 // person-search:mount ; une barre déjà montée n'est jamais doublée.
    const mounted = new WeakSet();
    function setup(root) {
      if (mounted.has(root)) return;
      const input = root.querySelector('input[role="combobox"]');
      const list = root.querySelector('[role="listbox"]');
      if (!input || !list) return;
      const sourceId = root.getAttribute('data-person-search-source') || input.id;
      const dataEl = document.querySelector('[data-person-search-data="' + sourceId + '"]');
      if (!dataEl) return;

      let items = [];
      try {
        const parsed = JSON.parse(dataEl.textContent);
        if (Array.isArray(parsed)) items = parsed;
      } catch (e) {
        return; // JSON invalide : la barre reste masquée
      }
      if (!items.length) return;
      items.forEach((it) => { if (!it._n) it._n = norm(it.name); });

 // Recherche COMPLÈTE opt-in : suggestions
 // PIÈCES via la même predictive native que la loupe du header
 // (débounce 220ms + anti-course), groupes étiquetés Pièces /
 // Personnes / Thématiques. Limite pièces = 4 (lisibilité à 300+
 // produits en prod, même règle que la loupe).
      const withProducts = root.hasAttribute('data-person-search-products');
 // Le prix arrive déjà FORMATÉ du serveur (price_label du
 // fragment predictive-suggest-data) — aucun formatage ici.
      let productItems = [];
      let prodSeq = 0;
      let prodDebounce = 0;

      let matches = [];
      let active = -1;
      let groupsCache = [];

      const close = () => {
        list.setAttribute('hidden', '');
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        active = -1;
      };

      const buildOption = (it, idx) => {
        const li = document.createElement('li');
        li.className = 'person-search__option';
        li.id = input.id + '-opt-' + idx;
        li.setAttribute('role', 'option');
        const name = document.createElement('span');
        name.className = 'person-search__option-name';
        name.textContent = it.name;
        const count = document.createElement('span');
        count.className = 'person-search__option-count';
        count.textContent = it.meta != null
          ? it.meta
          : (it.role ? ((__T.roles && __T.roles[it.role]) || it.role) : '')
            + (it.count > 0 ? (it.role ? ' · ' : '') + TN(it.count, 'countPiecesOne', 'countPiecesOther', '{count} pièce', '{count} pièces') : '');
        li.appendChild(name);
        li.appendChild(count);
        li.addEventListener('mousedown', (e) => {
          e.preventDefault();
          window.location.href = it.url;
        });
        return li;
      };

      const buildHeader = (text) => {
        const li = document.createElement('li');
        li.className = 'person-search__grouphead';
        li.setAttribute('role', 'presentation');
        li.textContent = text;
        return li;
      };

      const renderList = () => {
        list.innerHTML = '';
 // L'ordre clavier suit STRICTEMENT l'ordre DOM des groupes.
        matches = groupsCache.reduce((acc, g) => acc.concat(g.items), []);
        if (!matches.length) {
          const li = document.createElement('li');
          li.className = 'person-search__empty';
          li.textContent = T('noResult', 'Aucun résultat.');
          list.appendChild(li);
        } else {
 // En-têtes : toujours en recherche complète (groupes étiquetés,
 // spec Raab) ; sinon seulement quand plusieurs kinds matchent
 // (les barres par rôle restent épurées).
          const showHeaders = withProducts || groupsCache.length > 1;
          let idx = 0;
          groupsCache.forEach((g) => {
            if (showHeaders) list.appendChild(buildHeader(g.title));
            g.items.forEach((it) => list.appendChild(buildOption(it, idx++)));
          });
        }
        list.removeAttribute('hidden');
        input.setAttribute('aria-expanded', 'true');
      };

      const setActive = (i) => {
        const opts = list.querySelectorAll('[role="option"]');
        opts.forEach((o) => o.classList.remove('is-active'));
        active = i;
        if (i >= 0 && opts[i]) {
          opts[i].classList.add('is-active');
          input.setAttribute('aria-activedescendant', opts[i].id);
          opts[i].scrollIntoView({ block: 'nearest' });
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      };

      input.addEventListener('input', () => {
        const raw = input.value.trim();
        const q = norm(raw);
        if (!q) {
          productItems = [];
          groupsCache = [];
          close();
          return;
        }
        const starts = [];
        const contains = [];
        items.forEach((it) => {
          if (it._n.startsWith(q)) starts.push(it);
          else if (it._n.indexOf(q) !== -1) contains.push(it);
        });
        const ranked = starts.concat(contains);
        const persons = ranked.filter((it) => it.role !== 'Thématique').slice(0, 4);
        const themes = ranked.filter((it) => it.role === 'Thématique').slice(0, 3);
        productItems = []; // résultats produits de la frappe précédente : périmés

        const compose = () => {
          groupsCache = [];
          if (productItems.length) groupsCache.push({ title: T('groupPieces', 'Pièces'), items: productItems });
          if (persons.length) groupsCache.push({ title: T('groupPersons', 'Personnes'), items: persons });
          if (themes.length) groupsCache.push({ title: T('groupThemes', 'Thématiques'), items: themes });
          renderList();
          setActive(-1);
        };
        compose();

        if (withProducts && raw.length >= 2) {
 // INSTANTANÉ (2026-09-02) : île déjà en cache → zéro debounce,
 // zéro réseau — le groupe Pièces sort à la frappe.
          const localNow = pieceIndex.search(raw, 4);
          if (localNow) {
            productItems = localNow.map((it) => ({ name: it.t, url: it.u, meta: it.p || '' }));
            compose();
          }
          clearTimeout(prodDebounce);
          const mySeq = ++prodSeq;
          if (localNow) { prodSeq = mySeq; } else {
          prodDebounce = setTimeout(() => {
 // Pièces : index LOCAL par sous-chaîne (pieceIndex — « mémo »
 // trouve le Mémorial) ; la predictive native ne sert plus que
 // de REPLI si l'île n'a pas pu se charger.
            pieceIndex.load().then(() => {
              if (mySeq !== prodSeq) return;
              if (norm(input.value.trim()) !== q) return;
              const local = pieceIndex.search(raw, 4);
              if (local) {
                productItems = local.map((it) => ({ name: it.t, url: it.u, meta: it.p || '' }));
                compose();
                return;
              }
 // Repli — Section Rendering (prix rendus SERVEUR : | money +
 // gardes Prix sur demande / Vendu, invisibles du JSON natif).
              fetch(ROOT + 'search/suggest?q=' + encodeURIComponent(raw)
                + '&resources[type]=product,collection&resources[limit]=4&resources[options][prefix]=last&resources[options][unavailable_products]=last'
                + '&section_id=predictive-suggest-data')
                .then((r) => (r.ok ? r.text() : null))
                .then((html) => {
                  if (mySeq !== prodSeq) return; // réponse périmée
                  if (norm(input.value.trim()) !== q) return;
                  let prods = [];
                  try {
                    const doc = new DOMParser().parseFromString(html || '', 'text/html');
                    const dataEl = doc.querySelector('[data-predictive-suggest]');
                    const parsed = dataEl ? JSON.parse(dataEl.textContent) : [];
                    prods = parsed.filter((it) => it.type === 'product');
                  } catch (e) { /* fragment illisible : pas de groupe Pièces */ }
                  productItems = prods.map((pr) => ({ name: pr.title, url: pr.url, meta: pr.price_label || '' }));
                  compose();
                })
                .catch(() => { /* réseau : les résultats locaux restent */ });
            });
          }, 220);
          }
        }
      });

 // Préchargement de l'île pièces au focus : la 1re frappe la trouve
 // en cache (instantanéité, 2026-09-02).
      if (withProducts) {
        input.addEventListener('focus', () => { pieceIndex.load(); });
      }

      input.addEventListener('keydown', (e) => {
        const open = !list.hasAttribute('hidden');
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (!open && input.value.trim()) { input.dispatchEvent(new Event('input')); return; }
          if (matches.length) setActive(Math.min(active + 1, matches.length - 1));
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (matches.length) setActive(Math.max(active - 1, 0));
        } else if (e.key === 'Enter') {
          if (open && matches.length) {
            e.preventDefault();
            const target = active >= 0 ? matches[active] : matches[0];
            window.location.href = target.url;
          }
        } else if (e.key === 'Escape') {
          if (open) { e.preventDefault(); close(); }
        }
      });

      input.addEventListener('blur', () => {
        setTimeout(close, 120);
      });

      mounted.add(root);
      root.removeAttribute('hidden'); // révélation : le composant est prêt
    }
    roots.forEach(setup);
    document.addEventListener('person-search:mount', () => {
      document.querySelectorAll('[data-person-search]').forEach(setup);
    });
  })();

 /* ── PANNEAU DE RECHERCHE (header) ────────────────────────────────────
 La loupe [data-search-toggle]
 ouvre/ferme le panneau [data-search-panel] (focus sur le champ à
 l'ouverture, Échap / clic dehors / croix pour fermer, focus
 restitué, aria-expanded synchronisé sur toutes les loupes). La
 soumission est un GET natif vers /search — le module ne gère que
 l'ouverture. */
  (function searchPanel() {
    const panel = document.querySelector('[data-search-panel]');
    const toggles = document.querySelectorAll('[data-search-toggle]');
    if (!panel || !toggles.length) return;
    const input = panel.querySelector('input[type="search"]');
    let lastFocus = null;

    const isOpen = () => !panel.hasAttribute('hidden');
    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    const onOutside = (e) => {
      if (panel.contains(e.target)) return;
 // Le clic sur une loupe est géré par le toggle lui-même (sinon
 // fermeture + réouverture immédiates).
      if (e.target.closest('[data-search-toggle]')) return;
      close();
    };
    const open = () => {
      lastFocus = document.activeElement;
 // Même fix troncature que le panneau panier : sous
 // le bas RÉEL du header (bande d'annonce comprise en haut de
 // page), le calc CSS restant le repli sans JS.
      const hs = document.querySelector('.header-section');
      if (hs) {
        const topPx = Math.max(hs.getBoundingClientRect().bottom, 0) + 12;
        panel.style.top = topPx + 'px';
 // Le body est verrouillé : le panneau DOIT porter son propre
 // défilement — plafond recalculé sur le top réel (le calc CSS
 // sur --header-sticky-height reste le repli sans JS).
        panel.style.maxHeight = (window.innerHeight - topPx - 16) + 'px';
      }
      bodyLock.lock('search-panel-open');
      panel.removeAttribute('hidden');
      toggles.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      if (input) input.focus();
      document.addEventListener('keydown', onKey);
      document.addEventListener('click', onOutside, true);
    };
    function close() {
      panel.setAttribute('hidden', '');
      bodyLock.unlock('search-panel-open');
      toggles.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onOutside, true);
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    }

    toggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (isOpen()) close();
        else open();
      });
    });
    panel.querySelectorAll('[data-search-close]').forEach((btn) => {
      btn.addEventListener('click', close);
    });

 /* ── Suggestions instantanées ──────
 Produits + pages/articles : Predictive Search NATIVE via la
 Section Rendering API (fragment predictive-suggest-data — prix
 formatés SERVEUR avec gardes POR/Vendu ; réglages S&D appliqués).
 Personnes (4 rôles) : fragment person-suggest-data (Section
 Rendering API), fetché UNE seule fois puis filtré localement,
 accents-insensibles. Rendu = de VRAIS liens <a> (clic, clic-droit/
 nouvel onglet, focus clavier). Entrée sans sélection = soumission
 GET normale vers /search (page de résultats). Anti-course par
 numéro de séquence (seule la dernière réponse rend).
 NOTE i18n : URLs sans préfixe de locale — Phase 12. */
    const suggest = panel.querySelector('[data-search-suggest]');
    if (input && suggest) {
      const normS = (str) => String(str).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      let persons = null;
      let personsLoading = false;
      let debounceT = 0;
      let seq = 0;

      const loadPersons = () => {
        if (persons !== null) return Promise.resolve();
        if (personsLoading) return Promise.resolve();
        personsLoading = true;
        return fetch(ROOT + '?section_id=person-suggest-data')
          .then((r) => {
            if (!r.ok) throw new Error(String(r.status));
            return r.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const dataEl = doc.querySelector('[data-person-suggest]');
            persons = dataEl ? JSON.parse(dataEl.textContent) : [];
            persons.forEach((pp) => { pp._n = normS(pp.name); });
          })
          .catch(() => { persons = []; })
          .finally(() => { personsLoading = false; });
      };

      const buildGroup = (title, items) => {
        const group = document.createElement('div');
        group.className = 'search-panel__suggest-group';
        const heading = document.createElement('p');
        heading.className = 'search-panel__suggest-title';
        heading.textContent = title;
        group.appendChild(heading);
        items.forEach((it) => {
          const a = document.createElement('a');
          a.className = 'search-panel__suggest-item';
          a.href = it.url;
          if (it.img) {
            const thumb = document.createElement('span');
            thumb.className = 'search-panel__suggest-thumb';
            const img = document.createElement('img');
            img.src = it.img;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 40;
            img.height = 50;
            thumb.appendChild(img);
            a.appendChild(thumb);
          }
          const name = document.createElement('span');
          name.className = 'search-panel__suggest-name';
          name.textContent = it.name;
          a.appendChild(name);
          if (it.meta) {
            const meta = document.createElement('span');
            meta.className = 'search-panel__suggest-meta';
            meta.textContent = it.meta;
            a.appendChild(meta);
          }
          group.appendChild(a);
        });
        return group;
      };

      const renderSuggest = (results, q) => {
        suggest.innerHTML = '';
        let any = false;
 // Recette 2026-09-02 : une correspondance EXACTE (collection
 // « Autographes », thème « Aux armes », personne) remonte AVANT les
 // pièces — file de groupes marqués exact, appendus exacts d'abord.
        const groups = [];
        const pushGroup = (node, exact) => { groups.push({ node, exact: !!exact }); };

        const products = (results.products || []).slice(0, 5);
        if (products.length) {
          pushGroup(buildGroup(T('groupPieces', 'Pièces'), products.map((pr) => ({
            url: pr.url,
            name: pr.title,
            meta: pr.price_label || '',
            img: pr.img || null,
          }))), products.some((pr) => normS(pr.title) === q));
        }

 // Collections (recette 2026-09-02 : « auto » → Autographes)
        const cols = (results.collections || []).slice(0, 3);
        if (cols.length) {
          pushGroup(buildGroup(T('groupCollections', 'Collections'), cols.map((c) => ({
            url: c.url,
            name: c.title,
            meta: '',
            img: null,
          }))), cols.some((c) => normS(c.title) === q));
        }

        if (persons && persons.length) {
 // tokens-AND sous-chaîne (2026-09-02 : même comportement que les
 // pièces — « hu vic » trouve Victor Hugo), préfixe prioritaire.
          const qTokens = q.split(/\s+/).filter(Boolean);
          const starts = [];
          const contains = [];
          persons.forEach((pp) => {
            let ok = true;
            for (let k = 0; k < qTokens.length; k++) {
              if (pp._n.indexOf(qTokens[k]) === -1) { ok = false; break; }
            }
            if (!ok) return;
            if (pp._n.indexOf(q) === 0) starts.push(pp);
            else contains.push(pp);
          });
          const ranked = starts.concat(contains);
 // Thématiques et personnes voyagent dans le même index (champ
 // kind) deux groupes distincts.
          const matchedThemes = ranked.filter((pp) => pp.kind === 'theme').slice(0, 3);
          const matchedPersons = ranked.filter((pp) => pp.kind !== 'theme').slice(0, 4);
          if (matchedThemes.length) {
            pushGroup(buildGroup(T('groupThemes', 'Thématiques'), matchedThemes.map((pp) => ({
              url: pp.url,
              name: pp.name,
              meta: TN(pp.count, 'countPiecesOne', 'countPiecesOther', '{count} pièce', '{count} pièces'),
              img: null,
            }))), matchedThemes.some((pp) => pp._n === q));
          }
          if (matchedPersons.length) {
            pushGroup(buildGroup(T('groupPersons', 'Personnes'), matchedPersons.map((pp) => ({
              url: pp.url,
              name: pp.name,
              meta: ((__T.roles && __T.roles[pp.role]) || pp.role)
                + (pp.count > 0 ? ' · ' + TN(pp.count, 'countPiecesOne', 'countPiecesOther', '{count} pièce', '{count} pièces') : ''),
              img: null,
            }))), matchedPersons.some((pp) => pp._n === q));
          }
        }

 // Glossaire / Bibliographies / Articles : index LOCAL par
 // sous-chaîne (2026-09-02) — les articles locaux remplacent ceux de
 // l'API (préfixe seul) ; les PAGES restent servies par l'API.
        const terms = contentIndex.search(q, ['term'], 3);
        if (terms && terms.length) {
          pushGroup(buildGroup(T('groupGlossary', 'Glossaire'), terms.map((it) => ({
            url: it.u, name: it.t, meta: '', img: null,
          }))), terms.some((it) => it._n === q));
        }
        const biblios = contentIndex.search(q, ['biblio'], 3);
        if (biblios && biblios.length) {
          pushGroup(buildGroup(T('groupBiblio', 'Bibliographies'), biblios.map((it) => ({
            url: it.u, name: it.t, meta: '', img: null,
          }))), biblios.some((it) => it._n === q));
        }
        const localArts = contentIndex.search(q, ['article'], 3);
        const arts = localArts !== null
          ? localArts.map((it) => ({ url: it.u, title: it.t, meta: it.m || '' }))
          : (results.articles || []).map((o) => ({ url: o.url, title: o.title, meta: '' }));
        const others = [].concat(results.pages || []).map((o) => ({ url: o.url, title: o.title, meta: '' })).concat(arts).slice(0, 4);
        if (others.length) {
          pushGroup(buildGroup(T('groupOther', 'Pages & articles'), others.map((o) => ({
            url: o.url,
            name: o.title,
            meta: o.meta || '',
            img: null,
          }))), others.some((o) => normS(o.title) === q));
        }

 // Exacts d'abord (ordre relatif préservé dans chaque moitié)
        groups.filter((g) => g.exact).forEach((g) => suggest.appendChild(g.node));
        groups.filter((g) => !g.exact).forEach((g) => suggest.appendChild(g.node));
        any = groups.length > 0;

        if (!any) {
          const empty = document.createElement('p');
          empty.className = 'search-panel__suggest-empty';
          empty.textContent = T('noSuggestion', 'Aucune suggestion — Entrée pour la recherche complète.');
          suggest.appendChild(empty);
        }
        suggest.removeAttribute('hidden');
      };

 // Mémoire de la DERNIÈRE réponse API (collections + pages — le
 // reste est local) : le rendu instantané la ré-affiche quand la
 // requête n'a pas changé, sinon groupes API absents jusqu'au retour.
      let lastApi = { q: '', collections: [], pages: [], articles: [] };

 // RENDU INSTANTANÉ (recette 2026-09-02 : « purement et simplement
 // instantané ») : les index locaux (pièces, personnes, thèmes,
 // glossaire, biblios, articles) rendent À CHAQUE frappe sans
 // debounce ni réseau — l'API (collections/pages) COMPLÈTE en
 // re-rendu à son retour. Les index se préchargent au focus.
      const renderLocalNow = () => {
        const raw = input.value.trim();
        if (raw.length < 2) {
          suggest.setAttribute('hidden', '');
          suggest.innerHTML = '';
          return;
        }
 // Aucun index encore chargé (toute 1re frappe avant préchargement)
 // → ne rien rendre : éviter un faux « Aucune suggestion » — le
 // rendu API arrive dans la foulée.
        if (pieceIndex.search(raw, 1) === null && !persons) return;
        const q = normS(raw);
        renderSuggest({
          products: [],
          collections: lastApi.q === q ? lastApi.collections : [],
          pages: lastApi.q === q ? lastApi.pages : [],
          articles: lastApi.q === q ? lastApi.articles : [],
        }, q);
      };

      const runSuggest = () => {
        const raw = input.value.trim();
        if (raw.length < 2) {
          suggest.setAttribute('hidden', '');
          suggest.innerHTML = '';
          return;
        }
        const mySeq = ++seq;
        const q = normS(raw);
 // Section Rendering — remplace suggest.json : prix
 // rendus côté SERVEUR (| money + gardes Prix sur demande / Vendu)
 // par le fragment predictive-suggest-data. Mêmes réglages S&D.
        const url = ROOT + 'search/suggest?q=' + encodeURIComponent(raw)
          + '&resources[type]=product,page,article,collection&resources[limit]=5&resources[options][prefix]=last&resources[options][unavailable_products]=last'
          + '&section_id=predictive-suggest-data';
        Promise.all([
          fetch(url)
            .then((r) => (r.ok ? r.text() : null))
            .catch(() => null),
          loadPersons(),
          pieceIndex.load(),
          contentIndex.load(),
        ]).then(([html]) => {
          if (mySeq !== seq) return; // réponse périmée (anti-course)
          if (input.value.trim().length < 2) return;
          let parsed = [];
          try {
            const doc = new DOMParser().parseFromString(html || '', 'text/html');
            const dataEl = doc.querySelector('[data-predictive-suggest]');
            parsed = dataEl ? JSON.parse(dataEl.textContent) : [];
          } catch (e) { parsed = []; }
          const results = {
            products: parsed.filter((it) => it.type === 'product'),
            collections: parsed.filter((it) => it.type === 'collection'),
            pages: parsed.filter((it) => it.type === 'page'),
            articles: parsed.filter((it) => it.type === 'article'),
          };
          lastApi = { q, collections: results.collections, pages: results.pages, articles: results.articles };
 // Pièces : index LOCAL par sous-chaîne quand l'île est chargée
 // (« mémo » → Mémorial) — la predictive native reste le repli.
          const localPieces = pieceIndex.search(raw, 5);
          if (localPieces) {
            results.products = localPieces.map((it) => ({
              type: 'product', title: it.t, url: it.u,
              price_label: it.p || '', img: it.i || null,
            }));
          }
          renderSuggest(results, q);
        });
      };

 // Préchargement des index au FOCUS (l'ouverture du panneau focus le
 // champ) ET dès le SURVOL/TOUCHER d'une loupe (l'intention précède le
 // clic de ~0,5-1s — l'île de 422 pièces, rendue serveur, a besoin de
 // cette avance à froid) : à la première frappe, tout est en cache.
      const preload = () => {
        loadPersons();
        pieceIndex.load();
        contentIndex.load();
      };
      input.addEventListener('focus', preload);
      toggles.forEach((b) => {
        b.addEventListener('mouseenter', preload, { once: true });
        b.addEventListener('touchstart', preload, { once: true, passive: true });
      });

      input.addEventListener('input', () => {
        renderLocalNow();
 // Île pièces pas encore prête → re-rendu DÈS son arrivée (sans
 // attendre le retour API) ; renderLocalNow lit la valeur courante,
 // un then multiple est inoffensif.
        if (pieceIndex.search(input.value.trim(), 1) === null) {
          pieceIndex.load().then(() => renderLocalNow());
        }
        clearTimeout(debounceT);
        debounceT = setTimeout(runSuggest, 180);
      });

 // Clavier : depuis le champ premier lien ; / entre les liens ;
 // Échap dans la liste retour au champ SANS fermer le panneau
 // (stopPropagation face au Échap global du panneau).
      input.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' && !suggest.hasAttribute('hidden')) {
          const first = suggest.querySelector('a');
          if (first) {
            e.preventDefault();
            first.focus();
          }
        }
      });
      suggest.addEventListener('keydown', (e) => {
        const links = Array.from(suggest.querySelectorAll('a'));
        const i = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (i < links.length - 1) links[i + 1].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (i > 0) links[i - 1].focus();
          else input.focus();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          input.focus();
        }
      });
    }
  })();

 /* ── « ÊTRE ALERTÉ » : succès vérifié + état immédiat + popup ─────────
 Pages personnes + thèmes (snippet alert-subscribe). La vérité
 cross-device = le metafield client custom.alerts (consigné par la
 librairie, rendu server-side) ; le localStorage ne couvre que
 l'intervalle avant consignation, POUR LE COMPTE CONNECTÉ.
 v2 2026-07-23 (recette client — 3 défauts corrigés, détail dans
 l'en-tête du snippet) :
 ① SUCCÈS VÉRIFIÉ, JAMAIS PRÉSUMÉ : un POST n'est un succès QUE si
 l'URL finale porte le marqueur de redirection Shopify
 (contact_posted=true / customer_posted=true). Tout le reste =
 échec HONNÊTE (message, bouton restauré, zéro écriture locale) ;
 l'URL finale est posée en data-alert-diag sur le message d'erreur
 (diagnostic inspecteur — jamais de console.*).
 ② STOCKAGE SCOPÉ PAR COMPTE : clé librairie-alerts:<customer.id>,
 lue/écrite connecté SEULEMENT ; déconnecté → aucune lecture +
 PURGE de toutes les clés librairie-alerts* (ordinateur partagé,
 changement de compte : personne ne voit l'état d'un autre).
 ③ GUEST : plus AUCUNE navigation native (constaté sur pièce : le
 POST natif du form customer aboutissait sur la page d'erreur
 système Shopify) — deux POST fetch en parallèle, succès si l'UN
 des deux est vérifié (e-mail OU fiche taguée alerte:<canonique>),
 sinon erreur dans la modale + mailto de secours. Le CONNECTÉ garde
 son repli natif sur /challenge (voie du form contact, prouvée). */
  (function alertSubscribe() {
    const roots = document.querySelectorAll('[data-alert-subscribe]');
    if (!roots.length) return;
    const LEGACY_KEY = 'librairie-alerts';

 // Purge : la clé globale v1 (toujours), et TOUTES les clés scopées
 // quand le visiteur est déconnecté (résidu d'un compte précédent).
    const purge = (all) => {
      try {
        localStorage.removeItem(LEGACY_KEY);
        if (all) {
          for (let i = localStorage.length - 1; i >= 0; i--) {
            const k = localStorage.key(i);
            if (k && k.indexOf(LEGACY_KEY + ':') === 0) localStorage.removeItem(k);
          }
        }
      } catch (e) { /* storage indisponible */ }
    };

    const postedOk = (res, marker) => !!(res && res.url && res.url.indexOf(marker) !== -1);
    const isChallenge = (res) => !!(res && res.url && res.url.indexOf('/challenge') !== -1);
 // Acceptation (v3 — la fiche était créée SANS marqueur dans l'URL
 // finale, constat client) : marqueur *_posted=true, OU réponse OK
 // redirigée HORS de /contact et /challenge — Shopify ne renvoie vers
 // la page d'origine qu'après acceptation (les erreurs se rendent sur
 // /contact, le challenge sur /challenge).
    const accepted = (res, marker) => {
      if (!res) return false;
      if (postedOk(res, marker)) return true;
      if (!res.ok || !res.url) return false;
      return res.url.indexOf('/challenge') === -1 && res.url.indexOf('/contact') === -1;
    };
    const setDiag = (el, text) => {
      if (!el) return;
      el.hidden = false;
      const d = text || 'aucune-reponse';
      el.setAttribute('data-alert-diag', d);
 // Relevable au SURVOL du message (infobulle navigateur) — pas
 // besoin d'ouvrir l'inspecteur.
      el.setAttribute('title', d);
    };

    roots.forEach((root) => {
      const label = root.getAttribute('data-alert-label');
      const canonical = root.getAttribute('data-alert-canonical') || label;
      const kind = root.getAttribute('data-alert-kind') || '';
      const cid = root.getAttribute('data-alert-customer') || '';
      const form = root.querySelector('form.alert-sub__form');
      const pending = root.querySelector('[data-alert-pending]');
      const guestCta = root.querySelector('[data-alert-guest-cta]');
      const modal = root.querySelector('[data-alert-modal]');

      const KEY = cid ? LEGACY_KEY + ':' + cid : '';
      let saved = [];
      if (KEY) {
        purge(false);
        try {
          const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
          if (Array.isArray(parsed)) saved = parsed;
        } catch (e) { /* états server-side seuls */ }
      } else {
        purge(true);
      }

      const store = (value) => {
        if (!KEY) return; // visiteur : jamais d'écriture locale
        if (saved.indexOf(value) === -1) {
          saved.push(value);
          try {
            localStorage.setItem(KEY, JSON.stringify(saved));
          } catch (e) { /* rien de plus à faire */ }
        }
      };

      const reveal = () => {
        if (form) form.hidden = true;
        if (guestCta) guestCta.hidden = true;
        if (pending) pending.hidden = false;
      };

 // État au chargement : CONNECTÉ seulement (déconnecté = jamais de
 // « Vous suivez », règle client).
      if (form && pending && (saved.indexOf(canonical) !== -1 || saved.indexOf(label) !== -1)) reveal();

 // ── CONNECTÉ : un clic, retour immédiat sur succès VÉRIFIÉ ──
      if (form) {
        const errEl = root.querySelector('[data-alert-error]');
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const btn = form.querySelector('[type="submit"]');
          if (btn) btn.disabled = true;
          if (errEl) errEl.hidden = true;
          fetch(form.action, { method: 'POST', body: new FormData(form) })
            .then((res) => {
              if (isChallenge(res)) {
 // Écran anti-spam : voie NATIVE du form contact (prouvée) —
 // aucune écriture locale avant, la confirmation reviendra
 // server-side (posted_successfully) après l'écran.
                form.submit();
                return;
              }
              if (accepted(res, 'contact_posted=true')) {
                store(canonical);
                reveal();
                return;
              }
              if (btn) btn.disabled = false;
              setDiag(errEl, res && res.url);
            })
            .catch(() => {
              if (btn) btn.disabled = false;
              setDiag(errEl, 'reseau');
            });
        });
      }

 // ── DÉCONNECTÉ : modale d'inscription ──
      if (guestCta && modal) {
 // Portal <body> : même raison que questionModal (un position:fixed
 // dans la bande hero resterait vulnérable à un ancêtre transformé).
        document.body.appendChild(modal);

        const trigger = guestCta.querySelector('a');
        const closeEls = modal.querySelectorAll('[data-alert-modal-close]');
        const gform = modal.querySelector('form');
        const gErr = modal.querySelector('[data-alert-modal-error]');
        let lastFocused = null;

        const onKeydown = (e) => {
          if (e.key === 'Escape') { e.preventDefault(); close(); return; }
          trapTabKey(modal, e);
        };
        const open = () => {
          lastFocused = document.activeElement;
          modal.removeAttribute('hidden');
          modal.setAttribute('data-open', 'true');
          document.body.classList.add('alert-modal-open');
          const first = modal.querySelector('input[name="contact[first_name]"]');
          if (first) setTimeout(() => first.focus(), 100);
          document.addEventListener('keydown', onKeydown);
        };
        const close = () => {
          modal.setAttribute('data-open', 'false');
          document.body.classList.remove('alert-modal-open');
          document.removeEventListener('keydown', onKeydown);
          setTimeout(() => {
            modal.setAttribute('hidden', '');
            if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
          }, 300);
        };

        if (trigger) trigger.addEventListener('click', (e) => { e.preventDefault(); open(); });
        closeEls.forEach((el) => el.addEventListener('click', close));

        if (gform) {
          gform.addEventListener('submit', (e) => {
            e.preventDefault();
            const sBtn = gform.querySelector('[type="submit"]');
            if (sBtn) sBtn.disabled = true;
            if (gErr) gErr.hidden = true;

            const val = (name) => {
              const el = gform.querySelector('input[name="contact[' + name + ']"]');
              return el ? (el.value || '').trim() : '';
            };

 // ① L'e-mail d'alerte — même format que le form connecté +
 // mention popup ; chemin /contact (celui de contactNewsletter).
 // Newsletter TOUJOURS (v3) : form 'customer' abonne au marketing
 // sans opt-out possible — la modale le dit en clair, le tag suit.
            const alertValue = canonical !== label ? canonical + ' (' + label + ')' : label;
            const fd = new FormData();
            fd.append('form_type', 'contact');
            fd.append('utf8', '✓');
            fd.append('contact[email]', val('email'));
            fd.append('contact[Client]', (val('first_name') + ' ' + val('last_name')).trim());
            fd.append('contact[Alerte]', kind + ' — ' + alertValue);
            fd.append('contact[body]', "Demande d'alerte (" + kind + ") via le POPUP D'INSCRIPTION (visiteur non connecté) : " + alertValue + '. Valeur à consigner dans custom.alerts : ' + canonical + '. Fiche client créée/retrouvée par e-mail — tag ceinture alerte:' + canonical + ' + newsletter.');

 // ② Les DEUX POST en parallèle, réponses INSPECTÉES — succès si
 // l'un des deux est VÉRIFIÉ : l'e-mail permet la fiche manuelle,
 // la fiche taguée porte la demande. Échec des deux → erreur
 // honnête dans la modale (mailto de secours), AUCUNE navigation
 // (le POST natif du form customer dead-end sur la page d'erreur
 // système — constaté sur pièce), AUCUN état local.
            const post = (url, body) => fetch(url, { method: 'POST', body: body }).catch(() => null);
            Promise.all([
              post('/contact', fd),
              post(gform.action, new FormData(gform))
            ]).then((results) => {
              const contactRes = results[0];
              const customerRes = results[1];
              const okContact = accepted(contactRes, 'contact_posted=true');
              const okCustomer = accepted(customerRes, 'customer_posted=true');
              if (okContact || okCustomer) {
 // Visiteur : « Vous suivez » transitoire seulement — store()
 // est un no-op sans compte (règle : déconnecté = zéro état
 // local). La modale reste OUVERTE sur le panneau de succès :
 // il explique la fiche créée + la connexion par code (v3 —
 // sans lui, revenir déconnecté passait pour un bug).
                reveal();
                gform.hidden = true;
                const intro = modal.querySelector('.alert-modal__intro');
                if (intro) intro.hidden = true;
                const success = modal.querySelector('[data-alert-modal-success]');
                if (success) {
                  success.hidden = false;
                  const firstAction = success.querySelector('a, button');
                  if (firstAction) firstAction.focus();
                } else {
                  close();
                }
                return;
              }
              if (sBtn) sBtn.disabled = false;
              const diag = ((contactRes && contactRes.url) || 'contact:aucune-reponse') +
                ' | ' + ((customerRes && customerRes.url) || 'customer:aucune-reponse');
              setDiag(gErr, diag);
            });
          });
        }
      }
    });
  })();

 /* ── CONTACT : case « S'abonner à la newsletter » ─────────────────────
 Un formulaire ne peut porter
 qu'UN form_type — la demande de contact (form_type=contact) et
 l'inscription newsletter (form_type=customer) ne voyagent pas dans
 la même soumission. Au submit, si la case est cochée, ce module
 rejoue EXACTEMENT le POST de la newsletter du footer (mécanisme
 qui fonctionne : form_type=customer + contact[tags]=newsletter +
 contact[email]) en fetch KEEPALIVE — la requête survit à la
 navigation du POST principal, l'inscription atterrit dans la base
 clients avec consentement marketing. CEINTURE : la case poste
 aussi contact[Newsletter]="Oui…" dans l'e-mail de contact — si le
 POST d'inscription était exceptionnellement refusé (challenge
 anti-spam), la librairie voit la demande et inscrit à la main. */
  (function contactNewsletter() {
    const form = document.getElementById('ctc-form');
    if (!form) return;
    const box = form.querySelector('[data-ctc-newsletter]');
    const emailField = form.querySelector('input[name="contact[email]"]');
    if (!box || !emailField) return;

    let fired = false;
    form.addEventListener('submit', () => {
      if (fired || !box.checked) return;
      const email = (emailField.value || '').trim();
      if (!email) return;
      fired = true;
      const fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[tags]', 'newsletter');
      fd.append('contact[email]', email);
      try {
        fetch('/contact', { method: 'POST', body: fd, keepalive: true });
      } catch (e) {
 // Réseau/navigateur récalcitrant : l'e-mail porte la demande.
      }
    });
  })();

 /* ── NEWSLETTER : copie de chaque inscription à la librairie ──────────
 The native customer form only CREATES a customer record: on an email
 that already exists in the store (buyer, account holder) it does
 nothing, silently. So every sign-up from the footer band or the popup
 also sends, at submit, a contact-form POST (keepalive, survives the
 native navigation) that lands in the shop's inbox: the bookseller can
 then subscribe an existing record by hand. Visitor flow unchanged. */
  (function newsletterCopy() {
    const forms = ['footer-newsletter-form', 'nl-popup-form']
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    if (!forms.length) return;
    forms.forEach((form) => {
      let fired = false;
      form.addEventListener('submit', () => {
        if (fired) return;
        const emailField = form.querySelector('input[name="contact[email]"]');
        const email = emailField ? (emailField.value || '').trim() : '';
        if (!email) return;
        fired = true;
        const where = form.id === 'nl-popup-form' ? 'popup' : 'bandeau du site';
        const fd = new FormData();
        fd.append('form_type', 'contact');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[Inscription]', 'Lettre de la librairie — ' + where);
        fd.append('contact[Page]', location.href);
        fd.append('contact[body]', 'Inscription à la lettre via le ' + where + ' : ' + email + '. Vérifier la fiche client : si elle existait déjà (commande, compte), l\'inscription automatique n\'a pas joué — abonner à la main depuis la fiche (Préférences de marketing).');
        try {
          fetch((typeof ROOT === 'string' ? ROOT : '/') + 'contact', { method: 'POST', body: fd, keepalive: true });
        } catch (e) {
 // Réseau récalcitrant : l'inscription native suit son cours.
        }
      });
    });
  })();

 /* ── POPUP NEWSLETTER −10 % (2026-07-25) ──────────────────────────────
 Déclenchement : 3e page de la session OU 60 s de session — le
 premier des deux (t0 de session posé à la 1re page, le compte à
 rebours SURVIT à la navigation) ; 1×/session ; refus mémorisé
 90 jours ; inscription réussie → plus jamais (localStorage).
 Succès VÉRIFIÉ, jamais présumé (règle gravée) : marqueur
 customer_posted=true OU redirection hors /contact et /challenge ;
 /challenge → soumission NATIVE (la voie du footer, prouvée).
 Non modal, aucun vol de focus. Exclusions de pages : côté serveur
 (theme.liquid). Stockage indisponible → jamais de popup. */
  (function newsletterPopup() {
    const root = document.querySelector('[data-nl-popup]');
    if (!root) return;
    const DONE_KEY = 'librairie-nlpopup-done';
    const REFUSE_KEY = 'librairie-nlpopup-refused';
    const SHOWN_KEY = 'librairie-nlpopup-shown';
    const PAGES_KEY = 'librairie-nlpopup-pages';
    const T0_KEY = 'librairie-nlpopup-t0';
    const REFUSE_MS = 90 * 864e5;
    const DELAY_MS = 60000;

    let pages = 1;
    let elapsed = 0;
    try {
      if (localStorage.getItem(DONE_KEY)) return;
      const refusedAt = parseInt(localStorage.getItem(REFUSE_KEY) || '0', 10);
      if (refusedAt && Date.now() - refusedAt < REFUSE_MS) return;
      if (sessionStorage.getItem(SHOWN_KEY)) return;
      pages = parseInt(sessionStorage.getItem(PAGES_KEY) || '0', 10) + 1;
      sessionStorage.setItem(PAGES_KEY, String(pages));
      let t0 = parseInt(sessionStorage.getItem(T0_KEY) || '0', 10);
      if (!t0) { t0 = Date.now(); sessionStorage.setItem(T0_KEY, String(t0)); }
      elapsed = Date.now() - t0;
    } catch (e) { return; }

    let timer = null;
    const show = () => {
      if (timer) clearTimeout(timer);
      try {
        if (sessionStorage.getItem(SHOWN_KEY)) return;
        sessionStorage.setItem(SHOWN_KEY, '1');
      } catch (e) { }
      root.removeAttribute('hidden');
      requestAnimationFrame(() => root.setAttribute('data-open', 'true'));
    };
    const hide = () => {
      root.setAttribute('data-open', 'false');
      setTimeout(() => root.setAttribute('hidden', ''), 350);
    };
    if (pages >= 3 || elapsed >= DELAY_MS) setTimeout(show, 1500);
    else timer = setTimeout(show, DELAY_MS - elapsed);

    const refuse = () => {
      try { localStorage.setItem(REFUSE_KEY, String(Date.now())); } catch (e) { }
      hide();
    };
    root.querySelectorAll('[data-nl-close]').forEach((el) => el.addEventListener('click', refuse));

    const form = root.querySelector('form');
    const err = root.querySelector('[data-nl-error]');
    const successEl = root.querySelector('[data-nl-success]');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        if (err) err.hidden = true;
        fetch(form.action, { method: 'POST', body: new FormData(form) })
          .then((res) => {
            if (res.url && res.url.indexOf('/challenge') !== -1) { form.submit(); return; }
            const accepted = (res.url && res.url.indexOf('customer_posted=true') !== -1) ||
              (res.ok && res.url && res.url.indexOf('/contact') === -1);
            if (accepted) {
              try { localStorage.setItem(DONE_KEY, '1'); } catch (e2) { }
              form.hidden = true;
              const intro = root.querySelector('[data-nl-intro]');
              if (intro) intro.hidden = true;
              const refuseBtn = root.querySelector('[data-nl-refuse]');
              if (refuseBtn) refuseBtn.hidden = true;
              if (successEl) successEl.hidden = false;
              return;
            }
            if (btn) btn.disabled = false;
            if (err) {
              err.hidden = false;
              err.setAttribute('data-nl-diag', (res && res.url) || 'aucune-reponse');
              err.setAttribute('title', (res && res.url) || 'aucune-reponse');
            }
          })
          .catch(() => {
            if (btn) btn.disabled = false;
            if (err) err.hidden = false;
          });
      });
    }
  })();

 /* ── ADRESSES + LETTRE, page compte (2026-07-26) ──────────────────────
 La voie native form 'customer_address' est PROUVÉE VIVANTE avec les
 nouveaux comptes (test client 26/07) — MAIS son POST redirige vers
 la page Shopify native. Ce module intercepte TOUS les formulaires
 .addr-form (ajout / édition / suppression d'adresse + bascule
 newsletter) : POST en fetch → RECHARGEMENT de /pages/mon-compte
 (grille et états re-rendus du customer — on ne quitte jamais la
 page) ; /challenge → soumission native (return_to en ceinture).
 Suppression : confirmation JS avant envoi. Pays : présélection du
 select (country_option_tags ne présélectionne pas). */
  (function accountAddresses() {
    const forms = document.querySelectorAll('form.addr-form');
    if (!forms.length) return;
    document.querySelectorAll('select[data-addr-country]').forEach((sel) => {
      const want = sel.getAttribute('data-addr-country');
      if (want) sel.value = want;
    });
    forms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        if (form.hasAttribute('data-addr-delete') && !window.confirm(T('addrDeleteConfirm', 'Supprimer cette adresse ?'))) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        fetch(form.action, { method: 'POST', body: new FormData(form) })
          .then((res) => {
            if (res.url && res.url.indexOf('/challenge') !== -1) {
              form.submit();
              return;
            }
            window.location.reload();
          })
          .catch(() => { if (btn) btn.disabled = false; });
      });
    });
  })();

 /* ── BANNIÈRE COOKIES NATIVE — réagencement (client 2026-08-22) ──────
 La bannière Customer Privacy est injectée par Shopify (script
 storefront-banner, PAS de shadow DOM — sélecteurs relevés dans le
 script : ids ButtonAccept/Decline/ManagePrefs stables). Ce module
 fait la SEULE part que le CSS ne peut pas faire : « Refuser » →
 « Tout refuser » (table de correspondance sur le libellé EXACT
 courant — une langue inconnue reste intacte). Tout le visuel
 (placement, navy littéral des 2 boutons, carte centrée mobile) vit
 dans components.css — la recopie runtime du cadre d'Accepter (v1)
 est retirée : le navy est désormais forcé en CSS pour les deux. La bannière arrive en
 asynchrone → MutationObserver, coupé après pose (ou 30 s sans
 bannière : visiteur déjà décidé / région sans consentement). */
  (function cookieBannerRelayout() {
    const LABELS = { 'Refuser': 'Tout refuser', 'Decline': 'Decline all' };
    const apply = () => {
      const accept = document.getElementById('shopify-pc__banner__btn-accept');
      const decline = document.getElementById('shopify-pc__banner__btn-decline');
      const manage = document.getElementById('shopify-pc__banner__btn-manage-prefs');
      if (!accept || !decline || !manage) return false;
      const label = decline.textContent.trim();
      if (LABELS[label]) decline.textContent = LABELS[label];
      return true;
    };
    if (apply()) return;
    const mo = new MutationObserver(() => { if (apply()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 30000);
  })();

 /* ── DESIDERATA : persistance locale des préférences ──────────────────
 Page /pages/mon-compte, section Desiderata. Les cases cochées sont
 mémorisées dans localStorage (clé 'librairie-desiderata') et
 re-cochées au chargement — MÊME APPAREIL seulement (limite v1
 assumée : pas d'écriture self-service sur le compte avec les
 nouveaux comptes, cf. commentaire de la section). La valeur
 business (notification librairie) passe par le form contact natif,
 fonctionnel SANS ce module. */
  (function desiderataPrefs() {
    const boxes = document.querySelectorAll('[data-desid-pref]');
    if (!boxes.length) return;
    const KEY = 'librairie-desiderata';
 // Récapitulatif copiable : une ligne composée des cases
 // cochées, envoyée dans l'email (champ caché) — la librairie
 // consigne chaque valeur dans le metafield client custom.interests.
    const summary = document.querySelector('[data-desid-summary]');

 // Libellé VISIBLE d'une case (span.checkbox-label du même label).
    const boxLabel = (b) => {
      const wrap = b.closest('label');
      const span = wrap && wrap.querySelector('.checkbox-label');
      return span ? span.textContent.trim() : '';
    };
 // Comparaison hors apostrophe typographique : l'affichage FR
 // remplace &#39; par ’, la donnée reste ASCII (« Envoi d'auteur »).
    const sameText = (a, b) => String(a).replace(/’/g, "'") === String(b).replace(/’/g, "'");

 // CANONIQUE MULTILINGUE : les cases thématiques portent
 // 'theme:<handle>' en donnée (et hors-FR, toute donnée diffère du
 // libellé traduit affiché) entrée de récap LISIBLE « donnée
 // (libellé) » : la librairie consigne la PARTIE CANONIQUE (avant la
 // parenthèse), la parenthèse n'est que lisibilité d'e-mail.
    const summaryEntry = (b) => {
      const value = b.getAttribute('data-desid-pref');
      const label = boxLabel(b);
      if (label && !sameText(value, label)) return value + ' (' + label + ')';
      return value;
    };

    const updateSummary = () => {
      if (!summary) return;
      const list = [];
      boxes.forEach((b) => {
        if (b.checked) list.push(summaryEntry(b));
      });
      summary.value = list.join(', ');
    };

    let saved = [];
    try {
      const raw = localStorage.getItem(KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      if (Array.isArray(parsed)) saved = parsed;
    } catch (e) {
 // localStorage indisponible : les cases restent fonctionnelles, sans mémoire
    }

    boxes.forEach((box) => {
 // Merge ADDITIF avec le pré-cochage server-side (metafield
 // custom.interests) : le local n'ajoute que ses retouches non
 // envoyées, il ne décoche jamais un intérêt consigné.
 // Tolérance transition : les entrées localStorage antérieures
 // portent le libellé FR — acceptées à côté du canonique.
      const pref = box.getAttribute('data-desid-pref');
      const lbl = boxLabel(box);
      if (saved.indexOf(pref) !== -1 || (lbl && saved.indexOf(lbl) !== -1)) {
        box.checked = true;
      }
      box.addEventListener('change', () => {
        const list = [];
        boxes.forEach((b) => {
          if (b.checked) list.push(b.getAttribute('data-desid-pref'));
        });
        try {
          localStorage.setItem(KEY, JSON.stringify(list));
        } catch (e) {
 // quota/indisponible : rien de plus à faire
        }
        updateSummary();
      });
    });

    updateSummary();
  })();

 /* ── PAGE FAVORIS (/pages/favoris) ────────────────────────────────────
 Rendu côté client depuis le store localStorage (favoritesStore).
 Chaque pièce = un fetch Section Rendering API
 (/products/<handle>?section_id=pcard-fragment) carte pcard
 STRICTEMENT identique au reste du site (metafields compris — le
 endpoint JSON.js ne les expose pas). Produit disparu (404) 
 retiré du store (auto-nettoyage). Retrait par le cœur STANDARD des
 cartes ([data-pcard-fav], module favoritesCards) :
 le toggle émet librairie:favoris-changed, et sur cet event on
 RETIRE (avec animation) les cartes absentes du store, sans jamais
 refetcher (pas de boucle avec l'auto-nettoyage). L'event est aussi
 émis cross-tab par le listener storage.
 i18n : fetch préfixé ROOT (routes.root_url) — cartes rendues dans
 la langue active. */
  (function favoritesPage() {
    const root = document.querySelector('[data-favorites-page]');
    if (!root) return;
    const grid = root.querySelector('[data-favs-grid]');
    const empty = root.querySelector('[data-favs-empty]');
    const loading = root.querySelector('[data-favs-loading]');
    const countEl = root.querySelector('[data-favs-count]');
    if (!grid || !empty) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const refreshChrome = () => {
      const n = grid.querySelectorAll('[data-fav-item]').length;
      if (countEl) {
        countEl.textContent = TN(n, 'countPiecesOne', 'countPiecesOther', '{count} pièce', '{count} pièces');
      }
      if (n === 0) empty.removeAttribute('hidden');
      else empty.setAttribute('hidden', '');
    };

    const removeNode = (node) => {
      if (reduceMotion) {
        node.remove();
        refreshChrome();
        return;
      }
      node.classList.add('is-removing');
      setTimeout(() => {
        node.remove();
        refreshChrome();
      }, 190);
    };

 // Sync store grille : le retrait passe par le cœur standard des
 // cartes (favoritesCards toggle cet event), le cross-tab et
 // l'auto-nettoyage aussi. On ne fait que RETIRER (animé) les cartes
 // orphelines — jamais de refetch ici.
    window.addEventListener('librairie:favoris-changed', () => {
      const kept = {};
      favoritesStore.all().forEach((h) => { kept[h] = true; });
      grid.querySelectorAll('[data-fav-item]').forEach((node) => {
        if (!kept[node.getAttribute('data-handle')] && !node.classList.contains('is-removing')) {
          removeNode(node);
        }
      });
      refreshChrome();
    });

 // ── Rendu initial : plus récents d'abord, fetchs en parallèle,
 // insertion dans l'ordre (les résultats sont ré-agrégés). ──
    const handles = favoritesStore.all().slice().reverse();

    const done = () => {
      if (loading) loading.setAttribute('hidden', '');
      refreshChrome();
    };

    if (!handles.length) {
      done();
      return;
    }

    Promise.all(handles.map((handle) =>
      fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=pcard-fragment')
        .then((r) => {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        })
        .then((html) => ({ handle, html }))
        .catch(() => ({ handle, html: null }))
    )).then((results) => {
      const parser = new DOMParser();
      results.forEach((res) => {
        if (!res.html) {
 // Produit supprimé/dépublié : on nettoie le store silencieusement
          favoritesStore.remove(res.handle);
          return;
        }
        const doc = parser.parseFromString(res.html, 'text/html');
        const item = doc.querySelector('[data-fav-item]');
        if (item) grid.appendChild(item);
      });
      done();
 // Cartes montées : resynchronise leurs cœurs (module favoritesCards)
 // — arrivées avec aria-pressed="false", elles doivent être PLEINES
 // ici puisque tout ce qui est affiché est en favori.
      window.dispatchEvent(new CustomEvent('librairie:favoris-changed', {
        detail: { count: favoritesStore.count() }
      }));
    });
  })();


 /* ── ACTUALITÉS & SALONS : onglets des deux espaces ───────────────────
 Amélioration progressive : sans JS les deux
 espaces sont rendus EMPILÉS avec leurs titres (la barre d'onglets
 reste hidden). Le JS révèle les onglets, masque les titres (classe
 is-tabbed), active l'espace demandé par ?espace= (défaut : le 1er
 onglet = Actualités) et tient l'URL à jour (replaceState — les
 autres paramètres, ex. ?page de la pagination, sont conservés).
 Clavier : flèches gauche/droite entre onglets (ARIA tablist). */
  (function spaceTabs() {
    const root = document.querySelector('[data-spaces]');
    if (!root) return;
    const bar = root.querySelector('[data-space-tabs]');
    const tabs = Array.from(root.querySelectorAll('[data-space-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-space-panel]'));
    if (!bar || tabs.length < 2 || panels.length < 2) return;

    const activate = (name, push) => {
      panels.forEach((p) => {
        if (p.getAttribute('data-space-panel') === name) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      tabs.forEach((t) => {
        const on = t.getAttribute('data-space-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      if (push) {
        const url = new URL(window.location.href);
        url.searchParams.set('espace', name);
        window.history.replaceState(null, '', url);
      }
    };

    root.classList.add('is-tabbed');
    bar.hidden = false;
    const known = tabs.map((t) => t.getAttribute('data-space-tab'));
    const param = new URLSearchParams(window.location.search).get('espace');
    activate(known.indexOf(param) !== -1 ? param : known[0], false);

    tabs.forEach((t, i) => {
      t.addEventListener('click', () => activate(t.getAttribute('data-space-tab'), true));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        next.focus();
        activate(next.getAttribute('data-space-tab'), true);
      });
    });
  })();

 /* ── SALONS : compte à rebours à 3 états ──────────────────────────────
 [data-salon-countdown] multi-instances (liste
 + page dédiée). data-starts/data-ends en ÉPOQUE (secondes, émises
 par | date: '%s' — aucun parsing de date côté JS, fuseaux réglés
 côté serveur). États : avant (label-pre, décompte vers le début) /
 pendant (label-live, décompte vers la fin, classe is-live) / après
 (label-past, chrono masqué, classe is-past). La bascule d'état se
 fait EN DIRECT si la page reste ouverte ; le reclassement des
 paniers de la liste, lui, attend un rechargement (assumé au
 cadrage). Blocs rendus hidden : sans JS, pas de chrono figé (les
 dates sont imprimées à côté). Un seul setInterval partagé, coupé
 quand plus rien ne décompte. */
  (function salonCountdown() {
    const els = Array.from(document.querySelectorAll('[data-salon-countdown]'));
    if (!els.length) return;

    const pad = (n) => String(n).padStart(2, '0');
    const instances = els.map((el) => ({
      el,
      starts: parseInt(el.getAttribute('data-starts'), 10) * 1000,
      ends: parseInt(el.getAttribute('data-ends'), 10) * 1000,
      label: el.querySelector('[data-cd-label]'),
      timer: el.querySelector('[data-cd-timer]'),
      d: el.querySelector('[data-cd-d]'),
      h: el.querySelector('[data-cd-h]'),
      m: el.querySelector('[data-cd-m]'),
      s: el.querySelector('[data-cd-s]'),
    })).filter((i) => !isNaN(i.starts) && !isNaN(i.ends) && i.label && i.timer && i.d && i.h && i.m && i.s);
    if (!instances.length) return;

    const tick = () => {
      const now = Date.now();
      let counting = false;
      instances.forEach((i) => {
        let target = null;
        if (now < i.starts) {
          i.el.classList.remove('is-live', 'is-past');
          i.label.textContent = i.el.getAttribute('data-label-pre');
          target = i.starts;
        } else if (now <= i.ends) {
          i.el.classList.add('is-live');
          i.el.classList.remove('is-past');
          i.label.textContent = i.el.getAttribute('data-label-live');
          target = i.ends;
        } else {
          i.el.classList.add('is-past');
          i.el.classList.remove('is-live');
          i.label.textContent = i.el.getAttribute('data-label-past');
          i.timer.hidden = true;
        }
        if (target !== null) {
          counting = true;
          i.timer.hidden = false;
          let rest = Math.max(0, Math.floor((target - now) / 1000));
          const dd = Math.floor(rest / 86400); rest -= dd * 86400;
          const hh = Math.floor(rest / 3600); rest -= hh * 3600;
          const mm = Math.floor(rest / 60);
          i.d.textContent = String(dd);
          i.h.textContent = pad(hh);
          i.m.textContent = pad(mm);
          i.s.textContent = pad(rest - mm * 60);
        }
        i.el.hidden = false;
      });
      return counting;
    };

    if (tick()) {
      const iv = setInterval(() => {
        if (!tick()) clearInterval(iv);
      }, 1000);
    }
  })();

 /* ── ACTUALITÉS : filtre par catégorie (tags) ─────────────────────────
 Pills [data-news-pill] ('' = Toutes) sur les
 brèves [data-news-item data-news-tags="tag1||tag2"] de la PAGE DE
 PAGINATION affichée (limite assumée au cadrage). Barre hidden
 révélée ici (sans JS : tout reste visible, zéro UI morte). Note
 [data-news-empty] montrée quand 0 brève visible. modèle [hidden]
 + garde display:none !important dans la section. */
  (function newsFilter() {
    const bar = document.querySelector('[data-news-filter]');
    if (!bar) return;
    const pills = Array.from(bar.querySelectorAll('[data-news-pill]'));
    const items = Array.from(document.querySelectorAll('[data-news-item]'));
    const empty = document.querySelector('[data-news-empty]');
    if (!pills.length || !items.length) return;
    bar.hidden = false;

    const apply = (tag) => {
      let visible = 0;
      items.forEach((it) => {
        const tags = (it.getAttribute('data-news-tags') || '').split('||');
        const show = tag === '' || tags.indexOf(tag) !== -1;
        if (show) { it.removeAttribute('hidden'); visible += 1; }
        else it.setAttribute('hidden', '');
      });
      pills.forEach((p) => {
        p.setAttribute('aria-pressed', p.getAttribute('data-news-pill') === tag ? 'true' : 'false');
      });
      if (empty) empty.hidden = visible !== 0;
    };

    pills.forEach((p) => {
      p.addEventListener('click', () => apply(p.getAttribute('data-news-pill')));
    });
  })();

 /* ── HOMEPAGE « Actualités & Salons » : pills de l'aperçu fusionné ─────
 Filtre l'aperçu déjà rendu (flux des deux blogs
 fusionnés) par espace : pill '' = tout, 'actualites', 'salons'. Sans
 JS : pills inertes, toutes les cartes visibles (aperçu complet).
 Cartes masquées par [hidden] (garde display:none !important dans la
 section,.acard étant flex). */
  (function homeNewsTabs() {
 // MULTI-INSTANCES : Actualités & Salons ET
 // Nos articles (home-discoveries) portent chacun leur aperçu à pills.
    document.querySelectorAll('[data-home-news]').forEach((root) => {
    const pills = Array.from(root.querySelectorAll('[data-home-news-pill]'));
    const cards = Array.from(root.querySelectorAll('[data-home-news-space]'));
    if (!pills.length || !cards.length) return;

    const apply = (space) => {
      cards.forEach((c) => {
        const show = space === '' || c.getAttribute('data-home-news-space') === space;
        if (show) c.removeAttribute('hidden');
        else c.setAttribute('hidden', '');
      });
      pills.forEach((p) => {
        p.setAttribute('aria-pressed', p.getAttribute('data-home-news-pill') === space ? 'true' : 'false');
      });
 // Filtre rangée recalée à gauche + recompute du carrousel partagé
 // (fondus de bord + boutons), la largeur défilable ayant changé.
      const sc = root.querySelector('[data-themes-scroller]');
      if (sc) { sc.scrollLeft = 0; window.dispatchEvent(new Event('resize')); }
    };

    pills.forEach((p) => {
      p.addEventListener('click', () => apply(p.getAttribute('data-home-news-pill')));
    });
    });
  })();

 /* ── HERO : largeur commune des CTAs TOUTES SLIDES confondues ─────────
 La grille fit-content égalise les boutons AU SEIN d'une
 slide ; entre slides (sous-arbres DOM séparés), chaque pile se cale
 sur SON libellé le plus long les boutons rétrécissaient à la
 bascule du carrousel. Ce module mesure la largeur naturelle du
 bouton le plus large de TOUTES les slides (rendues empilées,
 mesurables même en opacity/visibility hidden — pas de display:none)
 et pose --hero-cta-w sur la section ; le CSS la consomme à TOUTES
 les tailles (une largeur unique partout : un seuil de bascule
 créerait des largeurs incohérentes autour du point de rupture,
 iPad portrait/paysage notamment ; le resize — rotation iPad
 comprise — re-mesure). La variable est retirée avant chaque mesure
 (sinon le max resterait collant et ne pourrait jamais rétrécir au
 resize ou après un raccourcissement de libellé). Sans JS :
 égalisation par slide (dégradation douce). */
  (function heroCtaWidth() {
    const heroes = document.querySelectorAll('.home-hero');
    if (!heroes.length) return;

    heroes.forEach((hero) => {
      const btns = Array.from(hero.querySelectorAll('.home-hero__ctas .btn'));
      if (!btns.length) return;

      const measure = () => {
        hero.style.removeProperty('--hero-cta-w');
        let max = 0;
        btns.forEach((b) => {
          const w = b.getBoundingClientRect().width;
          if (w > max) max = w;
        });
        if (max > 0) hero.style.setProperty('--hero-cta-w', Math.ceil(max) + 'px');
      };

      measure();
      window.addEventListener('resize', measure);
    });
  })();


 /* ── HUB « NOS ARTICLES » : pills de tags PAR ESPACE ──────────────────
 Multi-scopes : chaque barre [data-art-filter]
 filtre les [data-art-item] de SON panneau d'espace (Journal /
 Guides). Filtre client-side sur la page affichée (limite assumée au
 cadrage, comme le hub Actualités & Salons). Barres hidden révélées
 ici — sans JS : tout reste visible. */
  (function artFilter() {
    document.querySelectorAll('[data-art-filter]').forEach((bar) => {
      const scope = bar.closest('[data-space-panel]') || document;
      const pills = Array.from(bar.querySelectorAll('[data-art-pill]'));
      const items = Array.from(scope.querySelectorAll('[data-art-item]'));
      const empty = scope.querySelector('[data-art-empty]');
      if (!pills.length || !items.length) return;
      bar.hidden = false;

      const apply = (tag) => {
        let visible = 0;
        items.forEach((it) => {
          const tags = (it.getAttribute('data-art-tags') || '').split('||');
          const show = tag === '' || tags.indexOf(tag) !== -1;
          if (show) { it.removeAttribute('hidden'); visible += 1; }
          else it.setAttribute('hidden', '');
        });
        pills.forEach((p) => {
          p.setAttribute('aria-pressed', p.getAttribute('data-art-pill') === tag ? 'true' : 'false');
        });
        if (empty) empty.hidden = visible !== 0;
      };
      pills.forEach((p) => {
        p.addEventListener('click', () => apply(p.getAttribute('data-art-pill')));
      });
    });
  })();

 /* ── HUB « NOS ARTICLES » : recherche à autocomplétion ────────────────
 Combobox MAISON, modèle personSearch — l'API
 prédictive Shopify ne sait pas se limiter à deux blogs (elle
 mêlerait brèves et salons, plafond 10 avant filtrage). Index JSON
 émis par la section (50 derniers/blog, titre+URL+espace+tags) :
 filtrage accents-insensible, titres à préfixe d'abord, puis titres
 contenant, puis tags ; max 8 ; clavier flèches/Entrée/Échap, ARIA
 combobox. Barre hidden révélée ici (sans JS : aucune UI morte). */
  (function articleSearch() {
    const wrap = document.querySelector('[data-article-search]');
    const dataEl = document.querySelector('[data-article-search-data]');
    if (!wrap || !dataEl) return;
    let items = [];
    try { items = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }
    if (!items.length) return;
    const input = wrap.querySelector('input');
    const list = wrap.querySelector('[data-article-search-list]');
    if (!input || !list) return;
    wrap.hidden = false;

    const fold = (v) => (v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    items.forEach((it) => { it.ft = fold(it.t); it.fg = fold(it.g); });

    let results = [];
    let active = -1;

    const close = () => {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    };
    const render = () => {
      list.innerHTML = '';
      results.forEach((it, i) => {
        const li = document.createElement('li');
        li.id = 'artx-opt-' + i;
        li.className = 'artx-search__opt';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', i === active ? 'true' : 'false');
        const t = document.createElement('span');
        t.className = 'artx-search__opt-title';
        t.textContent = it.t;
        const badge = document.createElement('span');
        badge.className = 'artx-search__opt-space';
        badge.textContent = it.s;
        li.appendChild(t);
        li.appendChild(badge);
        li.addEventListener('mousedown', (e) => {
          e.preventDefault();
          window.location.href = it.u;
        });
        list.appendChild(li);
      });
      list.hidden = !results.length;
      input.setAttribute('aria-expanded', results.length ? 'true' : 'false');
    };
    const search = () => {
      const q = fold(input.value.trim());
      active = -1;
      if (q.length < 2) { results = []; render(); return; }
      const pre = [];
      const mid = [];
      const tag = [];
      items.forEach((it) => {
        if (it.ft.indexOf(q) === 0) pre.push(it);
        else if (it.ft.indexOf(q) !== -1) mid.push(it);
        else if (it.fg.indexOf(q) !== -1) tag.push(it);
      });
      results = pre.concat(mid, tag).slice(0, 8);
      render();
    };

    input.addEventListener('input', search);
    input.addEventListener('keydown', (e) => {
      if (list.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const d = e.key === 'ArrowDown' ? 1 : -1;
        active = (active + d + results.length) % results.length;
        input.setAttribute('aria-activedescendant', 'artx-opt-' + active);
        render();
      } else if (e.key === 'Enter') {
        if (active >= 0 && results[active]) {
          e.preventDefault();
          window.location.href = results[active].u;
        }
      } else if (e.key === 'Escape') {
        close();
      }
    });
    input.addEventListener('blur', () => { window.setTimeout(close, 120); });
    input.addEventListener('focus', () => {
      if (results.length) {
        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });
  })();

 /* ── ARTICLE DE FOND : sommaire automatique ───────────────────────────
 Construit le sommaire depuis les h2/h3 du
 corps rendu ([data-article-body]) : ancres injectées (slug
 accents-pliés, collisions suffixées), h3 en sous-entrées. Montré à
 partir de 2 intertitres. Sans JS : encart hidden, article
 intégralement lisible (amélioration progressive). */
  (function articleToc() {
    const body = document.querySelector('[data-article-body]');
    const toc = document.querySelector('[data-article-toc]');
    if (!body || !toc) return;
    const list = toc.querySelector('[data-article-toc-list]');
    if (!list) return;
    const heads = Array.from(body.querySelectorAll('h2, h3'));
    if (heads.length < 2) return;

    const used = {};
    const slug = (t) => {
      const v = (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return v || 'section';
    };
    heads.forEach((h) => {
      if (!h.id) {
        let id = slug(h.textContent);
        if (used[id]) { used[id] += 1; id = id + '-' + used[id]; } else { used[id] = 1; }
        while (document.getElementById(id)) id += '-b';
        h.id = id;
      }
      const li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'is-sub';
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
  })();

 /* ── ARTICLE DE FOND : notes de bas de page ───────────────────────────
 Convention d'écriture (cadrage validé) :
 appels [1], [2]… dans le texte + intertitre « Notes » suivi d'une
 LISTE NUMÉROTÉE en fin d'article. Ce module élève chaque appel en
 exposant cliquable note, et ajoute à chaque note un lien retour 
 vers son premier appel. Nœuds texte seulement, jamais dans un lien /
 exposant / code, jamais après l'intertitre Notes. Sans JS : [1] et
 liste visibles — lisible, non cliquable (dégradation douce). */
  (function articleNotes() {
    const body = document.querySelector('[data-article-body]');
    if (!body) return;
    const heads = Array.from(body.querySelectorAll('h2, h3, h4'));
    let notesHead = null;
    heads.forEach((h) => {
      // Heading recognised as the notes/sources block: "Notes", "Sources",
      // "Références"/"References", "Sources et références" (FR/EN, accents folded).
      const label = h.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
      if (/^(notes?|sources?|references?|sources? (et|and) references?|notes? (et|and) references?)$/.test(label)) notesHead = h;
    });
    if (!notesHead) return;
    let ol = notesHead.nextElementSibling;
    while (ol && ol.tagName !== 'OL' && ol.tagName !== 'UL') {
      if (/^H[1-6]$/.test(ol.tagName)) { ol = null; break; }
      ol = ol.nextElementSibling;
    }
    if (!ol) return;
    const notes = Array.from(ol.children).filter((el) => el.tagName === 'LI');
    if (!notes.length) return;
    ol.classList.add('artr__notes');

 // Encadré : le titre « Notes », la liste et tout élément
 // intermédiaire sont enveloppés dans une boîte teintée navy —
 // repérage clair de la section, distincte du corps.
    const box = document.createElement('div');
    box.className = 'artr__notes-box';
    const range = [];
    let cur = notesHead;
    while (cur) {
      range.push(cur);
      if (cur === ol) break;
      cur = cur.nextElementSibling;
    }
    notesHead.parentNode.insertBefore(box, notesHead);
    range.forEach((el) => box.appendChild(el));

    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    const targets = [];
    let node;
    while ((node = walker.nextNode())) {
 // seulement AVANT la section Notes
      if (!(node.compareDocumentPosition(notesHead) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
      if (node.parentElement && node.parentElement.closest('a, sup, code')) continue;
      if (/\[\d+\]/.test(node.nodeValue)) targets.push(node);
    }

    const seen = {};
    targets.forEach((tn) => {
      const parts = tn.nodeValue.split(/\[(\d+)\]/);
      const frag = document.createDocumentFragment();
      for (let i = 0; i < parts.length; i++) {
        if (i % 2 === 0) {
          if (parts[i]) frag.appendChild(document.createTextNode(parts[i]));
        } else {
          const n = parseInt(parts[i], 10);
          if (n >= 1 && n <= notes.length) {
            seen[n] = (seen[n] || 0) + 1;
            const sup = document.createElement('sup');
            sup.className = 'artr__noteref';
            const a = document.createElement('a');
            a.href = '#artr-note-' + n;
            a.id = seen[n] === 1 ? 'artr-ref-' + n : 'artr-ref-' + n + '-' + seen[n];
            a.textContent = n;
            a.setAttribute('aria-label', T('noteLabel', 'Note {n}').replace('{n}', n));
            sup.appendChild(a);
            frag.appendChild(sup);
          } else {
            frag.appendChild(document.createTextNode('[' + parts[i] + ']'));
          }
        }
      }
      tn.parentNode.replaceChild(frag, tn);
    });

 // list-style:none (pastilles maison) strippe la sémantique de liste
 // sous Safari/VoiceOver rôle réaffirmé.
    ol.setAttribute('role', 'list');
    notes.forEach((li, i) => {
      const n = i + 1;
      li.id = 'artr-note-' + n;
 // Pastille de numéro : chaque note clairement
 // identifiée — même traitement visuel que l'appel dans le corps
 // (l'ol porte toujours l'ordinal pour les lecteurs d'écran).
      const num = document.createElement('span');
      num.className = 'artr__note-num';
      num.textContent = n;
      num.setAttribute('aria-hidden', 'true');
      li.insertBefore(num, li.firstChild);
      if (!seen[n]) return; // note sans appel : pas de lien retour
      const back = document.createElement('a');
      back.className = 'artr__noteback';
      back.href = '#artr-ref-' + n;
      back.textContent = '\u21A9';
      back.setAttribute('aria-label', T('noteBack', 'Retour à l\u2019appel de note {n}').replace('{n}', n));
      li.appendChild(document.createTextNode(' '));
      li.appendChild(back);
    });
  })();

 /* ── MODE NUIT — bascule manuelle ──────────────
 Bouton [data-night-toggle] du header (gaté par night-scope).
 L'ÉTAT INITIAL est posé par le
 script anti-FOUC de theme.liquid (localStorage `librairie-night`
 lu AVANT le premier rendu) — ici on ne fait que synchroniser
 l'ARIA/le meta theme-color au chargement, puis basculer au clic.
 La bascule est un simple attribut sur <html> : night.css (chargé
 en permanence) fait tout le reste — zéro rechargement.
 Pas d'auto-détection système (parti pris : bouton manuel). */
 /* ── Avatar compte : animation « première connexion » ────────────────
 Le rond à initiale du header (client connecté) tourne sur lui-même
 à sa PREMIÈRE apparition de la session. sessionStorage : une fois
 par session de navigateur — le module ne s'exécute que si l'avatar
 est rendu (donc connecté), un visiteur déconnecté ne consomme pas
 le marqueur. Échec de stockage (navigation privée stricte) 
 avatar statique, rien ne casse. */
  (function accountAvatarFresh() {
    const avatar = document.querySelector('[data-account-avatar]');
    if (!avatar) return;
    try {
      if (!sessionStorage.getItem('librairie-acc-hello')) {
        sessionStorage.setItem('librairie-acc-hello', '1');
        avatar.classList.add('is-fresh');
      }
    } catch (e) { /* stockage indisponible : pas d'animation */ }
  })();

  (function nightMode() {
    const KEY = 'librairie-night';
    const root = document.documentElement;
    const toggles = document.querySelectorAll('[data-night-toggle]');
    if (!toggles.length) return;

    const meta = document.querySelector('meta[name="theme-color"]');
    const DAY_META = meta ? meta.getAttribute('content') : '';
 // La bande d'annonce (tout en haut) reste bleu nuit DANS LES DEUX
 // modes (îlot de jour, night.css §2) même valeur ; le swap est
 // conservé comme point d'accroche si le chrome évolue.
    const NIGHT_META = '#042959';

    const sync = (on) => {
      toggles.forEach((btn) => {
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? T('nightOn', 'Désactiver le mode nuit') : T('nightOff', 'Activer le mode nuit'));
      });
      if (meta) meta.setAttribute('content', on ? NIGHT_META : DAY_META);
    };

    sync(root.getAttribute('data-night') === '1');

    toggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        const on = root.getAttribute('data-night') !== '1';
        if (on) root.setAttribute('data-night', '1');
        else root.removeAttribute('data-night');
        sync(on);
        try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) { /* préférence non mémorisée */ }
      });
    });
  })();

 /* ── PARTAGE sobre ──────────
 UN bouton : Web Share NATIF quand il existe (mobile — la feuille du
 système porte déjà les canaux de l'utilisateur), sinon COPIE du
 lien + confirmation inline « Lien copié ». Zéro réseau social,
 zéro traceur. Délégué : couvre fiche + articles + poses futures. */
  (function themeCross() {
    // Croisement de thèmes (prototype 2026-08-19) : navigation vers la vue
    // de tags multiples NATIVE /collections/<handle>/<tag1>+<tag2> (ET
    // strict, current_tags). Les cases (data-cross-tag, déjà handleizées
    // côté Liquid, SANS name — jamais sérialisées par le form des facettes)
    // vivent dans le tiroir de filtres ; délégation → zéro init par page.
    document.addEventListener('click', (e) => {
      const btn = e.target.closest ? e.target.closest('[data-cross-apply]') : null;
      if (!btn) return;
      const box = btn.closest('[data-theme-cross]');
      if (!box) return;
      const base = box.getAttribute('data-cross-base') || window.location.pathname;
      const tags = Array.from(box.querySelectorAll('[data-cross-tag]'))
        .filter((i) => i.checked)
        .map((i) => i.getAttribute('data-cross-tag'));
      window.location.href = tags.length ? base.replace(/\/$/, '') + '/' + tags.join('+') : base;
    });
  })();

    (function themeCrossPick() {
    // ⑤ v2 (retour client 2026-08-20) : croisement de thèmes SUR les cartes
    // de /pages/thematiques — les « + » (data-cross-pick, hors des liens)
    // togglent la sélection, la barre flottante (data-cross-bar) suit et
    // navigue vers la vue de tags multiples. Délégation → zéro init.
    function picked() {
      return Array.from(document.querySelectorAll('[data-cross-pick][aria-pressed="true"]'));
    }
    function refreshBar() {
      const bar = document.querySelector('[data-cross-bar]');
      if (!bar) return;
      const n = picked().length;
      const count = bar.querySelector('[data-cross-count]');
      if (count) count.textContent = String(n);
      bar.hidden = n === 0;
    }
    document.addEventListener('click', (e) => {
      const pick = e.target.closest ? e.target.closest('[data-cross-pick]') : null;
      if (pick) {
        e.preventDefault();
        pick.setAttribute('aria-pressed', pick.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        refreshBar();
        return;
      }
      const go = e.target.closest ? e.target.closest('[data-cross-go]') : null;
      if (go) {
        const bar = go.closest('[data-cross-bar]');
        const base = bar.getAttribute('data-cross-base') || '';
        const tags = picked().map((b) => b.getAttribute('data-cross-pick'));
        if (tags.length) window.location.href = base.replace(/\/$/, '') + '/' + tags.join('+');
        return;
      }
      const clear = e.target.closest ? e.target.closest('[data-cross-clear]') : null;
      if (clear) {
        picked().forEach((b) => b.setAttribute('aria-pressed', 'false'));
        refreshBar();
      }
    });
  })();

  (function themeShelves() {
    // Rayonnages de /pages/thematiques : le compteur d'une tuile déplie son
    // panneau de sous-thèmes SOUS LA RANGÉE visuelle (les panneaux sont des
    // frères masqués rendus par Liquid, replacés après le dernier élément de
    // la rangée) ; « Déplier tout » ; Échap referme ; relayout au resize.
    const root = document.querySelector('[data-thidx-shelves]');
    if (!root) return;
    function tileOf(panel) {
      return root.querySelector('[data-thidx-tile="' + panel.getAttribute('data-thidx-sub') + '"]');
    }
    function panelOf(tile) {
      return root.querySelector('[data-thidx-sub="' + tile.getAttribute('data-thidx-tile') + '"]');
    }
    function layoutRow(row) {
      // 1. chaque panneau revient masqué juste après SA tuile (ordre DOM propre)
      Array.from(row.querySelectorAll('[data-thidx-sub]')).forEach((p) => {
        p.hidden = true;
        const t = tileOf(p);
        if (t) t.after(p);
      });
      const tiles = Array.from(row.querySelectorAll('[data-thidx-tile]'));
      if (!tiles.some((t) => t.classList.contains('is-open'))) return;
      // 2. rangées visuelles = tuiles de même offsetTop (panneaux masqués)
      const groups = [];
      tiles.forEach((t) => {
        const top = t.offsetTop;
        const g = groups.find((x) => x.top === top);
        if (g) g.tiles.push(t); else groups.push({ top: top, tiles: [t] });
      });
      // 3. les panneaux ouverts s'insèrent après le dernier élément de leur rangée
      groups.forEach((g) => {
        let anchor = g.tiles[g.tiles.length - 1];
        g.tiles.filter((t) => t.classList.contains('is-open')).forEach((t) => {
          const p = panelOf(t);
          if (!p) return;
          anchor.after(p);
          p.hidden = false;
          anchor = p;
        });
      });
    }
    function setOpen(tile, open) {
      tile.classList.toggle('is-open', open);
      const b = tile.querySelector('[data-thidx-toggle]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function refreshExpandAll() {
      const btn = document.querySelector('[data-thidx-expand]');
      if (!btn) return;
      const all = Array.from(root.querySelectorAll('[data-thidx-tile]')).filter((t) => t.querySelector('[data-thidx-toggle]'));
      const allOpen = all.length > 0 && all.every((t) => t.classList.contains('is-open'));
      btn.setAttribute('aria-pressed', allOpen ? 'true' : 'false');
      btn.textContent = allOpen ? btn.getAttribute('data-label-collapse') : btn.getAttribute('data-label-expand');
    }
    function layoutAll() {
      root.querySelectorAll('[data-thidx-row]').forEach(layoutRow);
      refreshExpandAll();
    }
    document.addEventListener('click', (e) => {
      const tg = e.target.closest ? e.target.closest('[data-thidx-toggle]') : null;
      if (tg) {
        const tile = tg.closest('[data-thidx-tile]');
        setOpen(tile, !tile.classList.contains('is-open'));
        layoutRow(tile.closest('[data-thidx-row]'));
        refreshExpandAll();
        return;
      }
      const cl = e.target.closest ? e.target.closest('[data-thidx-close]') : null;
      if (cl) {
        const tile = tileOf(cl.closest('[data-thidx-sub]'));
        if (!tile) return;
        setOpen(tile, false);
        layoutRow(tile.closest('[data-thidx-row]'));
        refreshExpandAll();
        const b = tile.querySelector('[data-thidx-toggle]');
        if (b) b.focus();
        return;
      }
      const ex = e.target.closest ? e.target.closest('[data-thidx-expand]') : null;
      if (ex) {
        const open = ex.getAttribute('aria-pressed') !== 'true';
        root.querySelectorAll('[data-thidx-tile]').forEach((t) => {
          if (t.querySelector('[data-thidx-toggle]')) setOpen(t, open);
        });
        layoutAll();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !root.querySelector('[data-thidx-tile].is-open')) return;
      root.querySelectorAll('[data-thidx-tile].is-open').forEach((t) => setOpen(t, false));
      layoutAll();
    });
    let raf = 0;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => root.querySelectorAll('[data-thidx-row]').forEach(layoutRow));
    });
  })();

  /* ── 2e IMAGE DES CARTES À LA DEMANDE ─────────────────────────────────
     La <source> du <picture> (pcard.liquid) ne sert la 2e image qu'aux
     appareils à pointeur fin. Ailleurs (tactile, portable qui se déclare
     sans pointeur fin), au PREMIER geste sur une carte — survol, toucher
     ou focus — on pose les candidats sur l'<img> de repli et, une fois
     l'image décodée, la classe is-hover-ready autorise le fondu. Une seule
     carte touchée charge sa 2e image ; jamais de fondu vers le GIF 1×1.
     Délégué : couvre les cartes injectées plus tard (recos, favoris).
     PRÉCHARGEMENT (tactile) : demandée seulement au tap, la 2e image
     arrivait 300 ms à 1,3 s après le geste (génération de la variante par
     le CDN). Après le chargement de la page, hors pointeur fin, les cartes
     qui APPROCHENT de l'écran (marge d'un écran) préchargent leur 2e image
     en priorité basse — le tap est alors immédiat ; les cartes jamais
     approchées ne coûtent rien (pas de Save-Data ni de réseau lent). */
  (function pcardHoverLazy() {
    const ready = (media, img) => {
      if (media.classList.contains('is-hover-ready')) return;
      if (img.complete && img.naturalWidth > 1) { media.classList.add('is-hover-ready'); return; }
      img.addEventListener('load', () => { if (img.naturalWidth > 1) media.classList.add('is-hover-ready'); }, { once: true });
    };
    const arm = (media, low) => {
      const img = media.querySelector('.pcard__img--hover');
      if (!img) return;
      const served = img.currentSrc && img.currentSrc.indexOf('data:') !== 0;
      if (!served && img.dataset.hoverSrcset) {
        if (low) { try { img.fetchPriority = 'low'; } catch (e) { /* attribut absent : sans effet */ } }
        img.loading = 'eager';
        img.sizes = img.dataset.hoverSizes || '';
        img.srcset = img.dataset.hoverSrcset;
      }
      ready(media, img);
    };
    const wake = (e) => {
      const card = e.target && e.target.closest ? e.target.closest('.pcard') : null;
      const media = card ? card.querySelector('.pcard__media--has-hover') : null;
      if (media) arm(media, false);
    };
    document.addEventListener('pointerover', wake, { passive: true });
    document.addEventListener('touchstart', wake, { passive: true });
    document.addEventListener('focusin', wake);
    const finePointer = window.matchMedia && window.matchMedia('(any-hover: hover) and (any-pointer: fine)').matches;
    if (finePointer || !('IntersectionObserver' in window)) return;
    const conn = navigator.connection || {};
    if (conn.saveData || (conn.effectiveType && conn.effectiveType !== '4g')) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        arm(en.target, true);
      });
    }, { rootMargin: '100% 0px' });
    const observeAll = () => document.querySelectorAll('.pcard__media--has-hover:not(.is-hover-ready)').forEach((m) => io.observe(m));
    const start = () => { const idle = window.requestIdleCallback || ((f) => setTimeout(f, 400)); idle(observeAll); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    document.addEventListener('pdp-recos:mount', observeAll);
    window.addEventListener('librairie:favoris-changed', () => setTimeout(observeAll, 300));
  })();

  (function shareButton() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest ? e.target.closest('[data-share]') : null;
      if (!btn) return;
      const url = btn.getAttribute('data-share-url') || window.location.href;
      const title = btn.getAttribute('data-share-title') || document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(() => { /* feuille fermée : rien */ });
        return;
      }
      if (!navigator.clipboard || !navigator.clipboard.writeText) return;
      navigator.clipboard.writeText(url).then(() => {
        const label = btn.querySelector('[data-share-label]');
        if (!label) return;
        const prev = label.textContent;
        label.textContent = T('linkCopied', 'Lien copié');
        btn.classList.add('is-copied');
        setTimeout(() => {
          label.textContent = prev;
          btn.classList.remove('is-copied');
        }, 2200);
      }).catch(() => { /* clipboard refusé : rien */ });
    });
  })();

 /* ── PREFETCH AU SURVOL (audit vitesse 2026-09-02 — « passage d'une
 page à l'autre quasi instantané ») : au mouseenter/touchstart d'un
 lien INTERNE, le HTML de la destination est préchargé (<link
 rel=prefetch>) — le clic qui suit (~300-800ms plus tard) sert la
 page depuis le cache. Exclusions : panier/checkout/compte (états),
 ancres pures, URLs à paramètres (variantes infinies de tri/filtres),
 liens de langue. Dédupe par Set, plafond 40/page (garde-fou données),
 Save-Data respecté. */
  (function linkPrefetch() {
    if (navigator.connection && navigator.connection.saveData) return;
    const seen = new Set();
    let count = 0;
    const EXCLUDE = /^\/(cart|checkout|account|customer_authentication|challenge)/;
    const onIntent = (e) => {
      if (count >= 40) return;
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href') || '';
      if (!href.startsWith('/') || href.startsWith('//')) return;
      if (href.indexOf('#') !== -1 || href.indexOf('?') !== -1) return;
      if (EXCLUDE.test(href)) return;
      if (href === window.location.pathname) return;
      if (seen.has(href)) return;
      seen.add(href);
      count++;
      const l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = href;
      l.as = 'document';
      document.head.appendChild(l);
    };
 // mouseover (bubbling) et non mouseenter : mouseenter ne se propage
 // pas — un écouteur document ne le reçoit jamais des liens (attrapé
 // à la sonde du 2026-09-02). Les survols répétés sont dédupés (Set).
    document.addEventListener('mouseover', onIntent, { capture: true, passive: true });
    document.addEventListener('touchstart', onIntent, { capture: true, passive: true });

 // MOBILE (exigence client : aussi rapide qu'au survol desktop — or
 // le doigt ne survole pas) : les liens internes VISIBLES dans le
 // viewport se préchargent en idle (patron quicklink). Mêmes gardes
 // et même plafond partagé (40) ; connexion lente (≠4g) : rien.
 // Contrainte (2026-09-14) : Safari (iOS compris) ignore rel=prefetch —
 // sur iPhone ce module est inerte par construction, et un fetch() ne
 // remplace pas : la réponse Shopify n'est pas réutilisable par une
 // navigation (pas de Cache-Control) et son cache de page ne sert
 // jamais un visiteur porteur d'un panier ou d'une session.
    if (!('IntersectionObserver' in window)) return;
    const conn = navigator.connection || {};
    if (conn.effectiveType && conn.effectiveType !== '4g') return;
 // Révision mobile 2026-09-14 : un « 4G » lent (débit < 5 Mb/s ou
 // RTT > 250 ms — c'est le profil Lighthouse) ne précharge rien, et un
 // écran tactile plafonne à 12 pages (une collection en affichait 24 à
 // 40 Ko = 1 Mo de HTML préchargé sur 4G lent).
    if ((conn.downlink && conn.downlink < 5) || (conn.rtt && conn.rtt > 250)) return;
    const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    const viewportCap = coarse ? 12 : 40;
    let viewportCount = 0;
    const idle = window.requestIdleCallback || ((f) => setTimeout(f, 300));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        if (viewportCount >= viewportCap) return;
        viewportCount++;
        idle(() => onIntent({ target: en.target }));
      });
    }, { rootMargin: '96px' });
    document.querySelectorAll('a[href^="/"]').forEach((a) => io.observe(a));
  })();

})();
